import { VisibilityOutlined } from "@mui/icons-material";
import { SupportApiService } from "../../Service/SupportApiService";
import React, { useEffect, useRef, useState,useLayoutEffect } from "react";
import { Button, Form, OverlayTrigger, Table } from "react-bootstrap";
import "../Dynamic/UserList.scss";
import Accordion from 'react-bootstrap/Accordion';
import { useHistory, useParams } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import WarningIcon from '@mui/icons-material/Warning';
import Swal from "sweetalert2";
import DeleteItemIcon from "../../assets/images/icons/DeleteItem.png";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownLoadIcon from '../../assets/images/icons/DownLoadIcon.svg';
import RedirectIcon from '../../assets/images/icons/RedirectIcon.svg';
import ExpandMore from '../../assets/images/icons/ExpandMore.svg';
import "../Dynamic/UserList.scss";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import "../Dynamic/UserList.scss";
import Select from "react-select";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExportIconLight from '../../assets/images/icons/ExportIconLight.svg'
import ScannedWarning from "../../assets/images/icons/ScannedWarning.svg";
import DoneIcon from "@mui/icons-material/Done";
import { Overlay, Popover } from "react-bootstrap";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import {
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import Container from "@mui/material/Container";
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import Modal from "react-bootstrap/Modal";
import BootstrapSpinner from 'react-bootstrap/Spinner';
import Constant from "../../Constant";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import { CookieService } from "../../Service/CookieService";
import CloudArrowUp from "../../assets/images/icons/CloudArrowUp.svg";
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import ProofIcon from '../../assets/images/icons/ProofIcon.svg';
import ExcelExportIcon from '../../assets/images/icons/BarrelProofingExcel.svg'
import ExportIcon from '../../assets/images/icons/ExportIcon.svg'
import PDFExportIcon from '../../assets/images/icons/PdfExportIcon.svg';
import TrashIcon from "../../assets/images/icons/Trash_Black.svg";
import "../../sass/responsive.scss";
import CKContent from "../Common/CKcontent";
import { HistoryStepper } from "../Common/HistoryStepper";
import Spinner from "../Common/Spinner";
import StatusDropdown from "../Common/StatusDropdown";
import "../Dynamic/InventoryCSV.scss";
import UploadDocs from "../popups/uploadDocs";
import AdminMessageBox from "./AdminMessageBox";
import ContainerMessageBox from "./ContainerMessageBox";
import EditRequest from "./EditOrderRequest";
import SellRequestEditValidationPopup from "../popups/SellRequestEditValidationPopup";
import SellRequestPricingInsightChart from "./SellRequestPricingInsightChart";
import { Url } from "../../Constants/Url";
import RequestDetails from "./RequestDetails";
import ManageBarrelProofingDetails from "../popups/ManageBarrelProofing";
import ManageBarrelValuationDetails from "../popups/ManageBarrelValuation";
import ValuationIcon from '../../assets/images/icons/ValuationIcon.svg';
import ManageBarrelTastingNoteDetails from "../popups/ManageBarrelTastingNote";
import TastingNoteIcon from '../../assets/images/icons/TastingNote.svg';
import LinkIcon from '@mui/icons-material/Link';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from "@mui/icons-material/Search";
import EmptyBarrel from '../../../src/assets/images/icons/EmptyBarrel.svg';
import FilledBarrel from '../../../src/assets/images/icons/FilledBarrel.svg';
import ManageDestinationBarrelDetails from "../popups/ManageDestinationBarrelDetails";
import DestinationBarrelIcon from '../../assets/images/icons/DestinationBarrelIcon.svg';

const ViewSupportRequest: React.FC = () => {

    const {id} = useParams<{id: string}>();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [isSpinner, setSpinner] = useState(false);
    
    const [isOpenEditSection, setOpenEditSection] = useState(false);
    const [isMessageBoxOpen, setMessageBoxOpen] = useState(false);
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [unreadGroupsCount, setUnreadGroupsCount] = React.useState<number>(0);
    const [unreadMessageCount, setUnreadMessageCount] = React.useState<number>(0);
    const [customerServiceRequest, setCustomerServiceRequest] = useState<any>([]);
    const [customerServiceRequestHistory, setCustomerServiceRequestHistory] = useState<any[]>([]);
    const [customerServiceRequestDocs, setCustomerServiceRequestDocs] = useState([]);
    const [isSellRequestAccepted, setSellRequestAccepted] = useState(false);
    const [isOwnershipTransferedAccepted, setOwnershipTransferedAccepted] = useState(false);
    const [filteredActiveInactiveCompaniesList, setFilteredActiveInactiveCompaniesList] = useState([]);
    const [isShowSellRequestPricingHistory, setShowSellRequestPricingHistory] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [selectedRequestForShipment, setSelectedRequestForShipment] = useState();
    const [open, setOpen] = useState(false);
    const [previousCustomerServiceRequest, setPreviousCustomerServiceRequest] = useState(null);
    const [wantedToBuyCustomerServiceRequest, setWantedToBuyCustomerServiceRequest] = useState<any[]>([]);

    const serviceRequestUpdateStatus = useRef({
        customerServiceRequestId: "",
        reason: "",
        status: "",
        spendHourOnRequest: "",
        fee: "",
        feeType: "",
        requestNumber: "",
        trackNumber: "",
        flow: "",
        assignedTo: "",
        transferRequestId: "",
        destinationCompanyAcceptedByName: "",
        sourceCompanyAcceptedByName: ""
      });

    const [spendHour, setSpendHour]  = useState("");
    const [reason,setReason] = useState(""); 
    const [showFileUploadModal, setShowFileUploadModal] = useState(false);
    const [file, setFile] = useState<File | null>(null);
    const [validated, setValidated] = useState(false);
    const [isRejected, setIsRejected] = useState(false);
    const [isCancelled, setIsCancelled] = useState(false);
    const [isInTransit, setInTransit] = useState(false);
    const [isInWarehouse, setIsInWarehouse] = useState(false);
    const [warehouseUserList, setWarehouseUserList] = useState([]);  
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const [error, setError] = useState("");
    const [ttbFile, setTTBFile] = useState<File[]>([]);
    const [errorMessage,setErrorMessage] = useState<string>("");
    const [files, setFiles] = useState<File[]>([]);
    const userId = CookieService.getCookie("userId");
    const [validationsList, setValidationsList] = useState<any[]>([]);
    const [isInvited, setIsInvited] = useState(false);
    const [companiesList, setCompaniesList] = useState<any[]>([]);
    const [statusList, setStatusList] = useState([]);
    const [sellRequestFee, setSellRequestFee] = useState('');
    const [sellRequestFeeType, setSellRequestFeeType] = useState('');
    const [selectedWarehouseUser, setSelectedWarehouseUser] = useState<string>("");
    const [receivingCompany, setReceivingCompany] = useState<string>("");
    const [selectedTransferCompany, setSelectedTransferCompany] = useState<string>("");
    const [transferCompanyError, setTransferCompanyError] = useState('');
    const [warehouseError, setWarehouseError] = useState('');
    const [feeError, setFeeError] = useState('');
    const [feeTypeError, setFeeTypeError] = useState('');
    const [isSellRequestFeeUpdated, setSellRequestFeeUpdated] = useState(false);
    const [isSelectedBarrelAreReserved, setIsSelectedBarrelAreReserved] = useState('');
    const [isShowSellRequestEditValidationPopup, setShowSellRequestEditValidationPopup] = useState(false)
    const [sellRequestEditValidationType, setSellRequestEditValidationType] = useState('');
    const [trackNumberValue, setTrackNumber] = useState<string>("");
    const [flowValue, setFlow] = useState<string>("");
    const [trackNumberError, setTrackNumberError] = useState('');
    const [flowError, setFlowError] = useState('');
    const [isManageProofingDetailsClick, setManageProofingDetailClick] = useState(false);
    const [isManageValuationDetailsClick, setManageValuationDetailClick] = useState(false);
    const [isManageDestinationDetailsClick, setManageDestinationDetailsClick] = useState(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);
    // Dynamic Height Calculation
    const [wrapperHeight, setWrapperHeight] = useState(0);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [isAgreed, setIsAgreed] = useState(false);
    const [agreeError, setAgreeError] = useState("");
    const [ownershipName, setOwnershipName] = useState<string>("");
    const [ownershipNameError, setOwnershipNameError] = useState('');
    const filteredCompanyOptions = filteredActiveInactiveCompaniesList.map((company: any) => ({
      value: company.id,
      label: company.companyName,
    }));
    const selectedTransferCompanyRef = useRef('');
    const isReceivingCompanyExist = filteredCompanyOptions.some(
      (option) => option.label.toLowerCase() === receivingCompany.toLowerCase()
    );
    const [activeType, setActiveType] = useState<"quantity" | "scanned" | null>(null);
    const [transferRequestId, setTransferRequestId] = useState<any>([]);
    type ScanType = "barrel" | "lot" | "all";
    const [isScannedCustomerServiceRequest, setIsScannedCustomerServiceRequest] = useState(false);
    const [activeTab, setActiveTab] = useState("marketplace"); 
    const [loading, setLoading] = useState(false);
    const [openPopupForBarrelId, setOpenPopupForBarrelId] = useState(null);
    const [selectedBarrelIds, setSelectedBarrelIds] = useState<string[]>([]);
    const [isSourceCompanyAccepted, setSourceCompanyAccepted] = useState(false);
    const [isSourceCompanyRejected, setSourceCompanyRejected] = useState(false);
    const [isReopenConfirm, setIsReopenConfirm] = useState(false);

    const updateWrapperHeight = () => {
      if (wrapperRef.current) {
        setWrapperHeight(wrapperRef.current.clientHeight);
      }
    };

  // Run on mount, after layout updates
  useLayoutEffect(() => {
    setTimeout(updateWrapperHeight, 0);
  }, []);

  // Run when isLoading changes
  useEffect(() => {
    if (!isLoading) {
      setTimeout(updateWrapperHeight, 0); // Delay to ensure DOM updates
    }
  }, [isLoading]);

  // 👇 close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const redirectToDashboard = async () => {
    if(CommonService.isUser()) {
      history.push('/user/my-warehouse');
    } else {
      history.push(`/master/company-dashboard/${customerServiceRequest?.companyId}`);
    }
  }

  const handlePopupCancel = () => {
    setShowSellRequestEditValidationPopup(false);
  }

  const getField = (name: string) =>
  customerServiceRequest?.dynamicFields?.find((f: any) => f.fieldName === name);

  // Run on window resize
  useEffect(() => {
    const handleResize = () => updateWrapperHeight();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function formatDateForAll(dateTimeString: string | null | undefined): string {
    if (!dateTimeString) return "";

    const date = new Date(dateTimeString);

    return date.toLocaleString("en-US", {
      month: "short",     // Nov
      day: "numeric",     // 12
      year: "numeric",    // 2025
      hour: "numeric",    // 6
      minute: "2-digit",  // 00
      hour12: true        // AM/PM
    });
  }

  const showRequestDetails = (requestType: any, id: any) => {
    let url = "";

    if (requestType === "Order Request") {
      url = `/master/order-detail/${id}`;
    } else if (requestType === "Offer Request") {
      url = `/master/view-offer-request/${id}`;
    } else {
      url = `/${CommonService.isAdmin() ? 'master' : 'user'}/view-customer-service-request/${id}`;
    }

    // open in new tab
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // Dynamic Height Calculation
  const [innerHeight, setInnerHeight] = useState(0);
  const innerRef = useRef<HTMLDivElement>(null);

  // Function to update height
  const updateHeight = () => {
    if (innerRef.current) {
      setInnerHeight(innerRef.current.clientHeight);
    }
  };

  const getRequestDetailsById = async (id:any) => {
    try {
      const response = await SupportApiService.getRequestDetailsById(id);
      console.log(response.data);
      setSelectedRequestForShipment(response?.data);
      return `${response?.data?.requestNumber} - (${response?.data?.totalBarrels}) Container`;
    } catch (error) {
        console.log("error occurred while api calling " + error);
    } 
  }

  useEffect(() => {
    // Update height on mount and resize
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);


    const handleFileShow = () => setShowFileUploadModal(true);

    const handleClose = () => {
      setShow(false);
      setError("");
      setReason("");
      setAgreeError("");
      setOwnershipName("");
      setIsAgreed(false);
      setOwnershipNameError("");
      setFeeError("");
      setTrackNumberError("");
      setFeeTypeError("");
      setTrackNumberError("");
      setFlowError("");
      setSellRequestFee("");
      setSellRequestFeeType("");
      setWarehouseError("");
      setTransferCompanyError("");
      setSelectedTransferCompany("");
      setSelectedWarehouseUser("");
      setSpendHour("");
      setSellRequestFeeUpdated(false);
      setIsRejected(false);
      setIsCancelled(false);
      setSellRequestAccepted(false);
      setTrackNumber("");
      setFlow("");
      setInTransit(false);
      //setIsScannedCustomerServiceRequest(false);
      setIsReopenConfirm(false);
      if (previousCustomerServiceRequest) {
        setCustomerServiceRequest(previousCustomerServiceRequest);
      }
      setOpenPopupForBarrelId(null);
    };

    const handleFileClose = () => {
      if (!isLoading) {
        setIsInvited(false);
        setValidated(false);
        setFile(null);
        setTTBFile([]);
        fetchData();
        setShowFileUploadModal(false);
      }
    };

    const handleUploadDocument = () => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };

    const handleSellRequestFeeChange = (e) => {
      setFeeError('');
      const value = e.target.value;
      setSellRequestFee(value);
    }

    const handleSellRequestFeeTypeChange = (e) => {
      setFeeTypeError('');
      const value = e.target.value;
      setSellRequestFeeType(value);
    }

    const removeAlertMessage = () => {
      setIsSelectedBarrelAreReserved('');
    }


    const getAllServiceStatusByServiceTypeId = async (serviceTypeId:any, currentStatus:any, destinationCompanyId:any) => {

      try {
          const response = await SupportApiService.getAllStatusByServiceTypeId(serviceTypeId, currentStatus, destinationCompanyId == CommonService.getCompanyId());
          setStatusList(response?.data);
      } catch (error) {
          console.log("error occurred while api calling ");
      }
    }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const selectedFile = input.files[0];
      const validTypes = [
        "text/csv",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (validTypes.includes(selectedFile.type)) {
        setFile(selectedFile);
        setValidated(false);
      } else {
        setFile(null);
        setValidated(true);
      }
    }
  };

  const handleInputOwnershipName = (event) => {
    setOwnershipNameError("");
    setOwnershipName(event.target.value);
  }

  const uploadFilesAndDocs = async () => {
      
    setValidated(true);
    setIsLoading(true);
    let response;
    
    if (customerServiceRequest.serviceName === Constant.CustomerService.BULK_INVENTORY_UPLOAD ) {
      //Upload document of customer service request request
      response = await uploadCustomerServiceRequestFile(); 
    }

    if (response && !errorMessage) {
      setIsLoading(true);
      setValidated(true);
      //fetchData();
    }
    //setIsLoading(false);
  };

  const fetchCompaniesList = async () => {
      const response: any = await Service.fetchCompaniesList();
      setCompaniesList(response.data);
    };

  const uploadCustomerServiceRequestFile = async() => {
    const serviceRequestData = new FormData();
    let response;
    let customerServiceRequestValueFile = {};

    const fileNames = file.name;

    if (file) {
      serviceRequestData.append("file", file);
    }

    const targetFields = customerServiceRequest.dynamicFields.filter((field) => {
      if (field.fieldName === 'Upload Inventory CSV/Excel File') {
        return typeof field.value === 'string' && (field.value.endsWith('.csv') || field.value.endsWith('.xlsx'));
      }
      if (field.fieldName === 'Does the company own the uploaded inventory?') {
        return field.value;
      }
      return false;
    });

    customerServiceRequestValueFile = {
      dynamicFields: targetFields || [],
      selectedCompanyId: customerServiceRequest.companyId,
      selectedUserId: customerServiceRequest.userId,
      selectedInventoryId: null,
      selectedServiceId: null,
      customerServiceRequestId : id ? id : null,
      comment: null,
      price: null,
      quantity: null,
      finalSelectedInventoriesWithBarrels: [],
      tempPath:'',
    };

    serviceRequestData.append(
      "param",
      new Blob([JSON.stringify(customerServiceRequestValueFile)], {
        type: "application/json",
      })
    );

    // Log the form data to the console
    setIsLoading(true);
    setValidationsList([]);

    try{
      response = await Service.updateCustomerSupportRequestValue(serviceRequestData);
      if (response) {
          setIsLoading(false);
          setIsInvited(true);
          setValidated(false);
      } else {
        setIsLoading(false);
        CommonService.Toast.fire({
          title: `Request ${id ? "Updated" : "Submitted"} Successfully`,
          icon: "success",
        });
      }
    } catch (error) {
        setIsLoading(false);
        setIsInvited(false);

        if (error.response) {
        // The backend error message should be inside error.response.data.message

        const errorMessage =
          error?.response?.data?.errorMessage || "Failed to upload CSV";

        // Log the error for debugging
        console.log("Error message from server: ", errorMessage);

        // Show the error in a toaster
        if (error?.response?.data?.data != null && errorMessage.includes("Error occurred while validating")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid file",
            icon: "error",
          });

          setValidationsList(error?.response?.data?.data);
          setValidated(true);
        } else if (errorMessage.includes("Invalid Csv File")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid CSV file",
            icon: "error",
          });
        } else if (errorMessage.includes("Excel file")) {
          CommonService.Toast.fire({
            title: "Please Upload a valid excel file",
            icon: "error",
          });
        } else if (errorMessage.includes("UNSUPPORTED_MEDIA_TYPE")) {
          CommonService.Toast.fire({
            title: "Please select a valid inventory file format either CSV or Excel (XLSX). You can add non-CSV or non-Excel files as supporting documents.",
            icon: "error",
          });
        } else {
          CommonService.Toast.fire({
            title: errorMessage,
            icon: "error",
          });
        }
      }
        console.log("error occurred while api calling " + error);
      }
  }
  
  const onDropHandler = (ev: any) => {
    ev.preventDefault();

      let file: any = "";

      if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        const fileItem = [...ev.dataTransfer.items].find(
          (item: any) => item.kind === "file"
        );
        if (fileItem) {
          file = fileItem.getAsFile();
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        file = ev.dataTransfer.files[0];
      }
      setFile(file);
  };

  const onDragOver = (ev: any) => ev.preventDefault();

  const handleSpendHourChange = (e:any) => {
    const value = e.target.value.trim();
    const numericValue = Number(value);

    if (!value) {
      setError("Time spent is required");
      setSpendHour("");
    } else if (numericValue < 1) {
      setError("Time spent must be at least 1 hour");
      setSpendHour("");
    } else if (numericValue > 24) {
      setError("Time spent cannot exceed 24 hours");
      setSpendHour("24");
    } else {
      setError("");
      setSpendHour(value);
    }
  }

  const handleReasonChange = (e:any) => {
    setError("");
    setReason(e.target.value);
  }

  const handleInputTrackerNumber = (event) => {
    setTrackNumberError("");
    setTrackNumber(event.target.value);
  };

  const handleWarehouseUserChange = (selectedOption) => {
    setWarehouseError('');
    setSelectedWarehouseUser(selectedOption ? selectedOption.value : '');
  };

  const handleTransferCompanyChange = (selectedOption) => {
    setTransferCompanyError('');
    setSelectedTransferCompany(selectedOption ? selectedOption.value : '');
  };

  const handleInputFlow = (event) => {
    setFlowError("");
    setFlow(event.target.value);
  };
  
  function getAge(row: { fillDate?: string }): string {
    if (!row.fillDate) return ""; // Return empty string if fillDate is null or undefined

    const currentDate = new Date();
    const fillDate = new Date(row.fillDate); // Convert to Date

    // Calculate difference in years and months
    let years = currentDate.getFullYear() - fillDate.getFullYear();
    let months = currentDate.getMonth() - fillDate.getMonth();

    // Adjust for negative months
    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years} years ${months} months`;
  }

  const handleCreateCustomerServiceRequest = (requestType, companyId, lots) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    const selectedLotNos = lots.map(l => l.lotNo);
      history.push(`${linkPrefix}/add-customer-service-request`, {
        data: requestType,
        companyId: companyId,
        lots: selectedLotNos
      });   
  };
  
  const deleteServiceRequest = async () => {
    Swal.fire({
      html: `
        <style>
          .custom-swal .icon-container {
              background-color: #ffebee;
              border-radius: 50%;
              width: 105px;
              height: 105px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 auto 20px;
            }
            .custom-swal .icon-container i {
              color: #ff3e4e;
              font-size: 24px;
            }
            .custom-swal h2 {
              font-size: 20px;
              margin-bottom: 10px;
              margin-top: 20px;
            }
            .custom-swal p {
              font-size: 14px;
              color: #666;
              margin-bottom: 20px;
            }
            .custom-swal .button-container {
              margin-top: 40px;
              display: flex;
              justify-content: center;
              gap: 20px;
            }
            .custom-swal button {
              border: none;
              padding: 10px 50px;
              border-radius: 30px;
              font-size: 14px;
              cursor: pointer;
            }
            .custom-swal .cancel-btn {
              background-color: #e0e0e0;
              color: #333;
            }
            .custom-swal .delete-btn {
              background-color: #ec2323;
              color: white;
            }
        </style>
        <div class="custom-swal">
          <div class="icon-container" id="iconContainer"></div>
          <h2>Are you sure?</h2>
          <p>Remove service request</p>
          <div class="button-container">
            <button class="cancel-btn" id="cancelBtn">Cancel</button>
            <button class="delete-btn" id="deleteBtn">Remove</button>
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: true,
      focusCancel: true,
      customClass: {
        popup: "custom-popup",
      },
      backdrop: `rgba(0,0,0,0.4)`,
      width: "500px",
      background: "#f8f8f8",
      didOpen: () => {
        // Add the image after the popup has been rendered
        const iconContainer = Swal.getPopup().querySelector("#iconContainer");
        if (iconContainer) {
          const img = document.createElement("img");
          img.src = DeleteItemIcon;
          img.width = 47;
          img.height = 51;
          iconContainer.appendChild(img);
        }
  
        // Add event listeners to the buttons
        const cancelBtn = Swal.getPopup().querySelector("#cancelBtn");
        const deleteBtn = Swal.getPopup().querySelector("#deleteBtn");
  
        cancelBtn?.addEventListener("click", () => {
          Swal.close();
        });
  
        deleteBtn?.addEventListener("click", async () => {
          try {
            const response = await SupportApiService.deleteCustomerServiceRequest(id);
  
            // Check if the response indicates success
            if (response.data ) {
              setTimeout(() => {
                CommonService.Toast.fire({
                  title: "Service request removed successfully",
                  icon: "success",
                });
  
              }, 1000);
              const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
              history.push(`${linkPrefix}/customer-service`);
            } else {
              throw new Error("Failed to delete service request");
            }
          } catch (error) {
            console.error("Error deleting service request:", error);
          }
  
          Swal.close();
        });
      },
    });
  };
  

    const downloadCustomerServiceRequestDOC = async(item:any) => {
        //hare we need to call the api and download the doc

        const requestDto = {
            id: item.id,
            companyId: item.companyId,
            fileName: item.fileName,
            requestNumber: customerServiceRequest?.requestNumber,
          };
      
          try {
            const response: any = await SupportApiService.downloadCustomerServiceRequestDOC(
              requestDto
            );
            // Assuming response.data is the blob data
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = item.fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
    }

    const fetchCustomerServiceRequestHistory = async () => {
        //fetch all the history for service request

        try {
            const response = await SupportApiService.fetchCustomerServiceRequestHistory(id);
            setCustomerServiceRequestHistory(response?.data);
        } catch (error) {
            console.log("error occurred while api calling ");
        }

    }

    const exportBarrelProofingValue = async (exportType:any) => {
      try {

        //first need to check if the barrel value present or not
        const isPresent = await SupportApiService.checkAllBarrelProofingValuePresent(id);

          if(isPresent.data) {
            //prepare request data for api calling 
          const request = {
            customerServiceRequestId: id,
            userId: CommonService.getUserId(),
            exportType: exportType
          }

          const response = await SupportApiService.exportBarrelProofingReport(request);
          
          CommonService.Toast.fire({
            title: "Your export is in progress. We'll notify you when it's ready!",
            icon: "success",
          });
        } else {
         CommonService.Toast.fire({
          title: customerServiceRequest?.status == Constant.CustomerServiceRequestStatus.CLOSED ? "Can not export as this request is already cancelled" : "Proof values are missing for selected container",
          icon: "error",
        });
        }
        setOpen(false);

      } catch(error) {
        console.log("error occurred while api calling " + error);
      }
    }

    const exportBarrelValuationValue = async (exportType:any) => {
      try {

        //first need to check if the barrel value present or not
        const isPresent = await SupportApiService.checkAllBarrelValuationValuePresent(id);

          if(isPresent.data) {
            //prepare request data for api calling 
          const request = {
            customerServiceRequestId: id,
            userId: CommonService.getUserId(),
            exportType: exportType
          }

          const response = await SupportApiService.exportBarrelValuationReport(request);
          
          CommonService.Toast.fire({
            title: "Your export is in progress. We'll notify you when it's ready!",
            icon: "success",
          });
        } else {
         CommonService.Toast.fire({
          title: customerServiceRequest?.status == Constant.CustomerServiceRequestStatus.CLOSED ? "Can not export as this request is already cancelled" : "Valuation costs are missing for selected container",
          icon: "error",
        });
        }
        setOpen(false);

      } catch(error) {
        console.log("error occurred while api calling " + error);
      }
    }
    
    const exportTastingValue = async (exportType:any) => {
      try {

        //first need to check if the barrel value present or not
        const isPresent = await SupportApiService.checkAllBarrelTastingNoteValuePresent(id);

          if(isPresent.data) {
            //prepare request data for api calling 
          const request = {
            customerServiceRequestId: id,
            userId: CommonService.getUserId(),
            exportType: exportType
          }

          const response = await SupportApiService.exportTastingReport(request);
          
          CommonService.Toast.fire({
            title: "Your export is in progress. We'll notify you when it's ready!",
            icon: "success",
          });
        } else {
         CommonService.Toast.fire({
          title: customerServiceRequest?.status == Constant.CustomerServiceRequestStatus.CLOSED ? "Can not export as this request is already cancelled" : "Tasting details are missing for selected container",
          icon: "error",
        });
        }
        setOpen(false);

      } catch(error) {
        console.log("error occurred while api calling " + error);
      }
    }

    const fetchCustomerServiceRequestDocs = async () => {
        //fetch all the docs service request

        try {
            const response = await SupportApiService.fetchCustomerServiceRequestDocs(id);
            setCustomerServiceRequestDocs(response?.data);
        } catch (error) {
            console.log("error occurred while api calling ");
        }
    }

    const getCustomerServiceRequestDetails = async () => {
        try {
            const response = await SupportApiService.getCustomerServiceRequest(id);
            setCustomerServiceRequest(response?.data);
            getAllServiceStatusByServiceTypeId(response?.data?.serviceTypeId, response?.data?.status, response?.data?.destinationCompanyId);

            const transferRequestId = response?.data?.dynamicFields?.find(f => f.fieldName === "Transfer Request")?.value;
            if (transferRequestId) {
              getTransferRequestDetails(transferRequestId);
              setTransferRequestId(transferRequestId);
            }

            if(Constant.CustomerService.WANTED_TO_BUY === response?.data?.serviceName)
              handleTabClickForWantedToBuy(activeTab);
            
        } catch (error) {
            console.log("error occurred while api calling ");
        }
    }

    const getTransferRequestDetails = async (transferRequestId: any) => {
        try {
            const response = await SupportApiService.getTransferRequestDetails(id, transferRequestId);
            setCustomerServiceRequest(response?.data);
        } catch (error) {
            console.log("error occurred while api calling ");
        }
    }

    const handleTabClickForWantedToBuy = async (tab) => {
      setActiveTab(tab);
      setLoading(true);  // Show loader instantly

      try {
        if (tab === "marketplace") {
          await getWantedToBuyCustomerServiceRequestDetails();
        } else {
          await getWantedToBuySystemSuggestedDetails();
        }
      } catch (error) {
        console.error("Failed to load data:", error);
      }

      setLoading(false); // Hide loader when done
    };

    const getWantedToBuyCustomerServiceRequestDetails = async () => {
        try {
            const response = await SupportApiService.getWantedToBuyCustomerServiceRequestDetails(id);
            // Store the array directly
            setWantedToBuyCustomerServiceRequest(response?.data);
        } catch (error) {
            console.log("error occurred while api calling : getWantedToBuyCustomerServiceRequestDetails ", error);
        }
    };

    const getWantedToBuySystemSuggestedDetails = async () => {
      try {
          const response = await SupportApiService.getWantedToBuySystemSuggestedDetails(id);
          setWantedToBuyCustomerServiceRequest(response?.data);
      } catch (error) {
          console.log("error occurred while api calling : getWantedToBuySystemSuggestedDetails ", error);
      }
    };

    const downloadCustomerServiceRequestValueDOC = async(item:any) => {
      //hare we need to call the api and download the doc

      const requestDto = {
          id: item.id,
          companyId: item.companyId,
          fileName: item.fileName,
          createdBy: userId
        };
    
        try {
          const response: any = await SupportApiService.downloadCustomerServiceRequestValueDOC(
            requestDto
          );
          // Assuming response.data is the blob data
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = item.fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
    }

    const exportReport = async () => {
      
      const request = {
        customerServiceRequestId: id,
        requestNumber: customerServiceRequest?.requestNumber
      };

      try {
        const response: any = await SupportApiService.ExportErrorReport(request);

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "upload_inventory_report.xlsx";  // ✅ Add proper filename and extension
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log("error occurred while API calling", error);
      }
    };

    useEffect(() => {
      if (!customerServiceRequest?.inventoryDetails) return;
      const scannedIds: string[] = [];

      customerServiceRequest.inventoryDetails.forEach(lot => {
        lot.scannedBarrels?.forEach(b => {scannedIds.push(b.barrelId);});
      });
      setSelectedBarrelIds(scannedIds);
    }, [customerServiceRequest]);
    
    // Check if barrel is checked
    const isBarrelChecked = (barrelId: string) => {
      return selectedBarrelIds.includes(barrelId);
    };

    // Check if LOT is checked
    const isLotChecked = (lotIndex: number) => {
      const lot = customerServiceRequest.inventoryDetails[lotIndex];
      if (!lot) return false;

      return lot.barrelNumbers.every(b =>
        selectedBarrelIds.includes(b.barrelId)
      );
    };

    const isAllChecked = () => {
      return customerServiceRequest.inventoryDetails.every((_, lotIndex) =>
        isLotChecked(lotIndex)
      );
    };

    const isAllScanned = () => {
      return customerServiceRequest.inventoryDetails.every(lot =>
        lot.barrelNumbers.every(b => b.isScanned)
      );
    };

    const isLotScanned = (lotIndex: number) => {
      const lot = customerServiceRequest.inventoryDetails[lotIndex];
      if (!lot) return false;

      return lot.barrelNumbers.every(b => b.isScanned === true);
    };

    const handleScanChange = (type: "all" | "lot" | "barrel",e, lotIndex?: number, barrelId?: string) => {
      const isChecked = e.target.checked;

      setSelectedBarrelIds(prev => {
        let updated = [...prev];

        // Get all scanned barrel IDs
        const scannedBarrelIds = customerServiceRequest.inventoryDetails.flatMap(lot =>
          lot.barrelNumbers
            .filter(b => b.isScanned === true)
            .map(b => b.barrelId)
        );

        if (type === "all") {
          if (isChecked) {
            updated = customerServiceRequest.inventoryDetails.flatMap(lot =>
              lot.barrelNumbers.map(b => b.barrelId)
            );
          } else {
            // don't remove scanned barrels
            updated = scannedBarrelIds;
          }
        }

        if (type === "lot" && lotIndex !== undefined) {
          const lotBarrels =
            customerServiceRequest.inventoryDetails[lotIndex].barrelNumbers.map(
              b => b.barrelId
            );

          const lotScannedIds =
            customerServiceRequest.inventoryDetails[lotIndex].barrelNumbers
            .filter(b => b.isScanned === true)
            .map(
              b => b.barrelId
            );

          if (isChecked) {
            updated = Array.from(new Set([...updated, ...lotBarrels]));
          } else {
            updated = updated.filter(id => !lotBarrels.includes(id) || lotScannedIds.includes(id));
          }
        }

        if (type === "barrel" && barrelId) {
          if (isChecked) {
            updated = [...new Set([...updated, barrelId])];
          } else {
            updated = updated.filter(id => id !== barrelId);
          }
        }

        return updated;
      });
    };

    const handleMarkAsScannedClick = () => {
      if (!selectedBarrelIds || selectedBarrelIds.length === 0) {
        CommonService.Toast.fire({
          title: "Please select at least one container.",
          icon: "warning",
        });
        return;
      }

      setIsScannedCustomerServiceRequest(true);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setInTransit(false);
      setIsInWarehouse(false);
      handleShow();
    };

    const updateScan = async (barrelIds, isChecked) => {
      try {
        const customerServiceRequestId = transferRequestId.length === 0 ? id : transferRequestId;

        await SupportApiService.manageScannedBarrels({ customerServiceRequestId, barrelIds, isScanned: isChecked });

        // Update local state after API success
        const updatedCSR = JSON.parse(JSON.stringify(customerServiceRequest));

        updatedCSR.inventoryDetails.forEach(lot => {
          lot.barrelNumbers.forEach(b => {
            if (barrelIds.includes(b.barrelId)) b.isScanned = isChecked;
          });

          if (isChecked) {
            const scanned = lot.barrelNumbers.filter(b => barrelIds.includes(b.barrelId));
            lot.scannedBarrels = [...lot.scannedBarrels.filter(b => !barrelIds.includes(b.barrelId)), ...scanned];
          } else {
            lot.scannedBarrels = lot.scannedBarrels.filter(b => !barrelIds.includes(b.barrelId));
          }
        });

        setCustomerServiceRequest(updatedCSR);
        handleClose();

        CommonService.Toast.fire({
          title: isChecked ? "Scan has been applied successfully." : "Scan has been cleared.",
          icon: "success",
        });
      } catch (error) {
        console.error("Scan update failed:", error);
        CommonService.Toast.fire({ title: "Failed to update scan", icon: "error" });
      }
    };
    
    function formatStatus(status?: string): string {
      let formattedStatus = "";
      if (status !== undefined) {
        formattedStatus = status
          ?.split(/[_\\]/)
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");
      }
      return formattedStatus;
    }

     const handleEditServiceRequest = () => {
        const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
        history.push(`${linkPrefix}/edit-customer-service-request/${id}`);
     }
    
     const fetchUnreadMessageCount = async () => {
      try{
        const response = await SupportApiService.fetchUnreadMessageCount(id);
        setUnreadMessageCount(response.data);
        
      } catch(error) {
        console.log("error is occurred while api calling")
      }

     }

    //use effect
    useEffect(() => {
        fetchCustomerServiceRequestHistory();
        getCustomerServiceRequestDetails();
        fetchCustomerServiceRequestDocs();
        fetchUnreadMessageCount();
    },[]);

    const routeBack = () => {
      history.goBack();
    };

     //handle edit button click
  const handleEditButtonClick = () => {
    if (isOpenEditSection) {
      setOpenEditSection(false);
    } else {
      setMessageBoxOpen(false);
      setOpenEditSection(true);
    }
  };

  //handle message box click
  const handleMessageBoxClick = () => {
    if (isMessageBoxOpen) {
      setMessageBoxOpen(false);
    } else {
      setOpenEditSection(false);
      setMessageBoxOpen(true);
      updateHeight();
      updateWrapperHeight();
      setUnreadMessageCount(0)
    }
  };

  const handleAdminMessageClick = () => {
    setShowMessageBox((prev) => !prev);
    updateHeight();
    updateWrapperHeight();
    // Reset unread groups count when the message box is toggled
    setUnreadGroupsCount(
      unreadGroupsCount > 0 && unreadMessageCount > 0
        ? unreadGroupsCount - 1
        : unreadGroupsCount
    );
  };

  const fetchData = async () => {
    try {
        fetchCustomerServiceRequestHistory();
        getCustomerServiceRequestDetails();
        fetchCustomerServiceRequestDocs();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString()}>
        <span>{value?.toString()}</span>
      </Tooltip>
    );
  };

  const formatVolume = (value) => {
    if (!Number.isFinite(value)) return 0;
    return parseFloat(Number(value).toFixed(2));
  };

  //data grid columns for docs
  const columnsForDoc: GridColDef[] = [
    {
      field: "createdDate",
      headerName: "Submitted On",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.createdDate ? row.createdDate : null;
        if (dateTimeString) {
          //call the method which formate the time
          return CommonService.formatDateTime(dateTimeString);
        }
      },
      headerClassName: "table-header",
    },
    {
      field: "fileName",
      headerName: "File Name",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) => {
        const fullFileName = row.fileName || "";
        const fileNameAfterFirstUnderscore = fullFileName.split('_').slice(1).join('_');
        return fileNameAfterFirstUnderscore || fullFileName;
      },
      headerClassName: "table-header",
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "userName",
      headerName: "Submitted By",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) =>
        `${row.userName}`,
      headerClassName: "table-header",
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth:140,
      sortable: false,
      width: 200,
      headerClassName: "table-header",
      renderCell: (params: any) => {

        //check file have .pdf extension or not
        const isPdf = params.row.fileName.toLowerCase().endsWith(".pdf");

        return (
        <div>

           {isPdf && (
                        <Tooltip title="View PDF" arrow>
                          <IconButton
                            onClick={() =>
                              CommonService.showPdf(
                                params.row.id,
                                params.row.companyId,
                                params.row?.siteId,
                                params.row.fileName,
                                Constant.RequestType.CUSTOMER_SERVICE_REQUEST,
                                customerServiceRequest?.requestNumber
                              )
                            }
                          >
                            <VisibilityOutlined />
                          </IconButton>
                        </Tooltip>
                      )}
        
          <Tooltip title="Download document" arrow>
            <IconButton
              onClick={(event) => downloadCustomerServiceRequestDOC(params.row)}
            >
              {/* <CloudDownloadOutlinedIcon /> */}
              <img className="cursor-pointer" 
                          src={DownLoadIcon}
                          alt="EditIcon"
                        />
            </IconButton>
          </Tooltip>
        </div>
      );
    }
    },
  ];

  // Define the localeText object based on the isLoading flag
  const localeText = {
    noRowsLabel: isLoading ? "Fetching records ..." : "No Record Found",
  };

  const hasPercentageFeeTypeField = (): boolean => {
    return customerServiceRequest?.dynamicFields?.some(
      (field) => field.value === 'PERCENTAGE'
    ) || false;
  };



  const handleStatusChange = async(newStatus:any) => {
    
    const status = newStatus?.replace(/[\s-]/g, "_").toUpperCase()
    
    const currentStatus = {
      customerServiceRequestId: id,
      serviceName: customerServiceRequest?.serviceName,
      reason: "",
      status: status,
      spendHourOnRequest: "",
      companyId: customerServiceRequest?.companyId,
      userId: customerServiceRequest?.userId,
      dynamicFields: customerServiceRequest.dynamicFields || [],
      fee: sellRequestFee,
      feeType: sellRequestFeeType,
      requestNumber: customerServiceRequest?.requestNumber,
      trackNumber: trackNumberValue,
      flow: flowValue,
      assignedTo: selectedWarehouseUser,
      transferRequestId: transferRequestId,
      destinationCompanyAcceptedByName: "",
      sourceCompanyAcceptedByName: ""
    };

    serviceRequestUpdateStatus.current = currentStatus;

    if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && customerServiceRequest?.serviceName == 'Sell Request') {
      setSellRequestAccepted(true);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setInTransit(false);
      setIsInWarehouse(false);
      setIsScannedCustomerServiceRequest(false);
      handleShow();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && customerServiceRequest?.serviceName === 'Ownership Transfer') {
      setSellRequestAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setInTransit(false);
      setIsInWarehouse(false);
      setIsScannedCustomerServiceRequest(false);
      fetchAllActiveAndInactiveCompanies();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CANCELLED) {
      setIsCancelled(true);
      setIsRejected(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setInTransit(false);
      setIsInWarehouse(false);
      setIsScannedCustomerServiceRequest(false);
      handleShow();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ADMIN_REJECTED) {
      setIsRejected(true);
      setIsCancelled(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setInTransit(false);
      setIsInWarehouse(false);
      setIsScannedCustomerServiceRequest(false);
      handleShow();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CLOSED) {
      if (customerServiceRequest?.serviceName === Constant.CustomerService.PRIVATE_SELL) {
        changeCustomerServiceRequestStatus();
      } else {
        setIsCancelled(false);
        setIsRejected(false);
        setSellRequestAccepted(false);
        setOwnershipTransferedAccepted(false);
        setInTransit(false);
        setIsInWarehouse(false);
        setIsScannedCustomerServiceRequest(false);
        handleShow();
      }
    } else if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.IN_TRANSIT && (customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST)) {
      setInTransit(true);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      setIsScannedCustomerServiceRequest(false);
      handleShow();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.SEND_TO_WAREHOUSE) {
      setIsInWarehouse(true);
      setIsCancelled(false);
      setIsRejected(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setInTransit(false);
      setIsScannedCustomerServiceRequest(false);
      let response = await SupportApiService.fetchAllWarehouseUser();
      setWarehouseUserList(response.data);
      handleShow();
    }else if (status === Constant.CustomerServiceRequestStatus.SOURCE_ACCEPTED || status === Constant.CustomerServiceRequestStatus.DESTINATION_ACCEPTED) {
      setSourceCompanyAccepted(true);
      setSourceCompanyRejected(false);
      setInTransit(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      handleShow();
    } else if (status === Constant.CustomerServiceRequestStatus.SOURCE_REJECTED || status === Constant.CustomerServiceRequestStatus.DESTINATION_REJECTED) {
      setSourceCompanyRejected(true);
      setSourceCompanyAccepted(false);
      setInTransit(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      handleShow();
    } else if (status === Constant.CustomerServiceRequestStatus.RE_OPEN) {
      setSourceCompanyRejected(false);
      setSourceCompanyAccepted(false);
      setInTransit(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      setIsScannedCustomerServiceRequest(false);
      setIsReopenConfirm(true);
      handleShow();
    } else {
      //if status is not ACCEPTED and REJECTED then call method don't open any popup
      changeCustomerServiceRequestStatus();
    }

  }

  const handleEditFeeDetails = () => {

    setSellRequestAccepted(true);
    setSellRequestFeeUpdated(true);

    //now set the Fee and Fee type for showing in popup
    customerServiceRequest?.dynamicFields?.forEach((field) => {
      if (field.dataType === Constant.FIELD_TYPES.COMMISSION_FEE) {
        setSellRequestFee(field.value);
      }
      if (field.dataType === Constant.FIELD_TYPES.FEE_TYPE_DROPDOWN) {
        setSellRequestFeeType(field.value);
      }
    });
    handleShow();
  }

  // const fetchAllActiveAndInactiveCompanies = async () => {
  //   try {
  //     const response = await Service.getAllActiveAndInactiveCompanies();
  //     setFilteredActiveInactiveCompaniesList(response.data);
      
  //     customerServiceRequest?.dynamicFields?.forEach((field) => {
  //       if (field?.fieldName === Constant.Field.RECEIVING_COMPANY) {
  //         setReceivingCompany(field.value);

  //         response.data.forEach((company) =>{              
  //           if (company.companyName?.toLowerCase() === field.value?.toLowerCase()) {
  //             setSelectedTransferCompany(company.id);
  //           }
  //         });

  //       }
  //     });
  //   } catch (error) {
  //     console.error("Error fetching companies:", error);
  //   }
  // };
    const fetchAllActiveAndInactiveCompanies = async () => {
      try {
        const companyResponse = await Service.getAllActiveAndInactiveCompanies();
        const companies = companyResponse.data || [];

        setFilteredActiveInactiveCompaniesList(companies);

        const dynamicFields =
          await SupportApiService.getAllDynamicFieldValueByServiceRequestId(
            serviceRequestUpdateStatus.current.customerServiceRequestId
          );

        let newCompanyId: string | null = null;
        let receivingCompanyName: string | null = null;

        // Extract required fields first (single loop)
        dynamicFields.data.forEach((field: any) => {
          if (field?.fieldName === Constant.Field.NEW_COMPANY) {
            newCompanyId = field.value; // already company id
          }

          if (field?.fieldName === Constant.Field.RECEIVING_COMPANY) {
            receivingCompanyName = field.value; // company name
          }
        });

        // ✅ Priority 1 → NEW_COMPANY (ID directly)
        if (newCompanyId) {
          setSelectedTransferCompany(newCompanyId);
          changeCustomerServiceRequestStatus();
          return;
        }

        // ✅ Priority 2 → old existing logic (name match)
        if (receivingCompanyName) {
          setReceivingCompany(receivingCompanyName);

          const matchedCompany = companies.find(
            (company: any) =>
              company.companyName?.toLowerCase() ===
              receivingCompanyName?.toLowerCase()
          );

          if (matchedCompany) {
            setSelectedTransferCompany(matchedCompany.id);
          }
        }

        setOwnershipTransferedAccepted(true);
        handleShow();
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

  const addCompany = async () => {
  
    if(!isReceivingCompanyExist){

      setIsLoading(true);

      const sanitizedValue = receivingCompany.replace(/[^a-zA-Z0-9]/g, "");
      const email = `${sanitizedValue}@yopmail.com`.toLowerCase(); 

      const requestData = {
        companyEmail: email,
        isActive: true,
        isDelete: false,
        companyName: receivingCompany
      };
      try {
        // Save company and get the savedCompanyId
        const response = await Service.addCompany(requestData);
        setSelectedTransferCompany(response.data);
        selectedTransferCompanyRef.current = response.data;

        updateTransferCompanyDetails();
      } catch (error) {
        console.error("Company creation or retrieval failed");
        console.error("Error saving company:", error);
        return; // Exit if the company save fails
      } finally{
        setIsLoading(false);
      }
    }
      
  };

  const updateTransferCompanyDetails = async () => {

    if ((isReceivingCompanyExist && selectedTransferCompany == '') || (!isReceivingCompanyExist && selectedTransferCompany == '' && selectedTransferCompanyRef.current == '')) {
      setTransferCompanyError("Please Select Transfer Company");
      return;
    }

    setIsLoading(true);

    let transferCompanyId = selectedTransferCompany || selectedTransferCompanyRef.current;

    const updateTransferCompanyDetails = {
      customerServiceRequestId: id,
      serviceName: customerServiceRequest?.serviceName,
      companyId: customerServiceRequest?.companyId,
      userId: customerServiceRequest?.userId,
      requestNumber: customerServiceRequest?.requestNumber,
      status: serviceRequestUpdateStatus.current.status,
      newCompanyId: transferCompanyId
    };

    try{
      const response = await SupportApiService.updateOwnershipTransferRequestCompanyDetails(updateTransferCompanyDetails);
      CommonService.Toast.fire({
        title: "Ownership transfer request details updated successfully",
        icon: "success",
      });

      getCustomerServiceRequestDetails();
      fetchCustomerServiceRequestHistory();

    } catch(error) {
      console.log("error occurred while api calling" + error);
      if(error?.response?.data?.errorMessage) {
         CommonService.Toast.fire({
          title: `${error?.response?.data?.errorMessage}`,
          icon: "error"
        });
      }
      
    } finally {
      setIsLoading(false);
      handleClose();
    }

  }

  const updateSampleRequestDetails = async () => {

    if(trackNumberValue == '') {
      setTrackNumberError("Please enter track number");
      return ;
    }
  
    setIsLoading(true);

    const updateSampleRequestDetails = {
      customerServiceRequestId: id,
      serviceName: customerServiceRequest?.serviceName,
      companyId: customerServiceRequest?.companyId,
      userId: customerServiceRequest?.userId,
      requestNumber: customerServiceRequest?.requestNumber,
      trackNumber: trackNumberValue,
      status: serviceRequestUpdateStatus.current.status
    };

    try{
      const response = await SupportApiService.updateSampleRequestDetails(updateSampleRequestDetails);
      CommonService.Toast.fire({
        title: "Sample request Details updated successfully",
        icon: "success",
      });

      getCustomerServiceRequestDetails();
      fetchCustomerServiceRequestHistory();

    } catch(error) {
      console.log("error occurred while api calling" + error);
      if(error?.response?.data?.errorMessage) {
         CommonService.Toast.fire({
          title: `${error?.response?.data?.errorMessage}`,
          icon: "error"
        });
      }
      
    } finally {
      setIsLoading(false);
      handleClose();
    }

  }

  const handleTrackNumberClick = (trackNumber: any) => {
    const url = Url.UPS_TRACK_NUMBER_URL + trackNumber;
    window.open(url, "_blank"); // open in new tab
  };

  const updateSellRequestFeeDetails = async () => {

    let isValid = true;

    //check entered value is valid or not
    if((Number(sellRequestFee)) < 0 || sellRequestFee?.trim().length < 1) {
      setFeeError((sellRequestFee?.trim().length < 1)? "Please enter commission fee" : "Commission Fee should be greater then or equal to zero")
      isValid = false;
    }
    if(sellRequestFeeType == '') {
      setFeeTypeError("Please select fee type")
      isValid = false;
    }


    if(!isValid) {
      return ;
    }

    setIsLoading(true);

    const updateSellRequestDetails = {
      customerServiceRequestId: id,
      fee: sellRequestFee,
      feeType: sellRequestFeeType
    };

    try{
      const response = await SupportApiService.updateSellRequestFeeDetails(updateSellRequestDetails);
      CommonService.Toast.fire({
        title: "Fee Details updated successfully",
        icon: "success",
      });

      getCustomerServiceRequestDetails();
      fetchCustomerServiceRequestHistory();

    } catch(error) {
      console.log("error occurred while api calling" + error);
      if(error?.response?.data?.errorMessage.includes("PENDING_REQUESTS") || error?.response?.data?.errorMessage.includes("REQUEST_CANCELLED") || error?.response?.data?.errorMessage.includes("ALREADY_SOLD")) {
            setSellRequestEditValidationType(error?.response?.data?.errorMessage);
            setShowSellRequestEditValidationPopup(true);
      } else if(error?.response?.data?.errorMessage) {
         CommonService.Toast.fire({
          title: `${error?.response?.data?.errorMessage}`,
          icon: "error"
        });
      }
      
    } finally {
      setIsLoading(false);
      handleClose();
    }


  }

  const changeCustomerServiceRequestStatus = async() => {

    if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ADMIN_REJECTED) && reason.trim().length <= 0) {
      setError("Please enter rejection reason");
      return;
    }

    if((serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.SOURCE_ACCEPTED || serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.DESTINATION_ACCEPTED) && (ownershipName.trim().length <= 0 || !isAgreed)) {
        setAgreeError(!isAgreed ? "Consent is required to treat your name as an electronic signature.": "");
        setOwnershipNameError(ownershipName.trim().length <= 0 ? "Please enter your full name": "");
        return;
    }

    if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED && reason.trim().length > 1000) {
      setError("Rejection note can not be more than 1000 characters");
      return;
    }

    if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CLOSED && customerServiceRequest?.serviceName !== Constant.CustomerService.PRIVATE_SELL && spendHour.trim().length <= 0) {
      setError("Please enter spend time in hours");
      return;
    }

    if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.SEND_TO_WAREHOUSE && selectedWarehouseUser == "") {
      setWarehouseError("Please Select Warehouse");
      return;
    }

    if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && customerServiceRequest?.serviceName == 'Sell Request') && ((Number(sellRequestFee)) < 0 || sellRequestFeeType == '') ) {
      
      if((Number(sellRequestFee)) < 0 || sellRequestFee?.trim().length < 1) {
        setFeeError((sellRequestFee?.trim().length < 1)? "Please enter commission fee" : "Commission Fee should be greater then or equal to zero")
      }
      if(sellRequestFeeType == '') {
        setFeeTypeError("Please select fee type")
      }
      return ;
    }

    if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.IN_TRANSIT && (customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST))) {      
      if(trackNumberValue == '') {
        setTrackNumberError("Please enter track number");
      }
      if(flowValue == '') {
        setFlowError("Please enter flow");
      }
      return ;
    }

    if (
      ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.COMPLETED) ||  serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED) &&
      customerServiceRequest?.serviceName === Constant.CustomerService.BARREL_PROOFING
    ) {
      const isPresent = await SupportApiService.checkAllBarrelProofingValuePresent(id);
      if (!isPresent.data) {
        const message = CommonService.isAdmin()
          ? "Cannot close request: selected container are missing proof values. Please add them before closing."
          : "Please add Proof value for all selected container before reassigning to admin.";

        CommonService.Toast.fire({
          title: message,
          icon: "error",
        });
        handleClose();
        return;
      }
    }
    
    if (((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.COMPLETED) ||  serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED) &&
      customerServiceRequest?.serviceName === Constant.CustomerService.BARREL_VALUATION) {
      const isPresent = await SupportApiService.checkAllBarrelValuationValuePresent(id);
      if (!isPresent.data) {
        const message = CommonService.isAdmin()
          ? "Cannot complete request: selected container are missing valuation cost. Please add them before closing."
          : "Please add Valuation cost for all selected container before reassigning to admin.";

        CommonService.Toast.fire({
          title: message,
          icon: "error",
        });
        handleClose();
        return;
      }
    }

    if (((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.COMPLETED) ||  serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED) &&
      customerServiceRequest?.serviceName === Constant.CustomerService.TASTING) {
      const isPresent = await SupportApiService.checkAllBarrelTastingNoteValuePresent(id);
      if (!isPresent.data) {
        const message = CommonService.isAdmin()
          ? "Cannot complete request: selected container are missing tasting details. Please add them before closing."
          : "Please add Tasting Details for all selected container before reassigning to admin.";

        CommonService.Toast.fire({
          title: message,
          icon: "error",
        });
        handleClose();
        return;
      }
    }

    if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.COMPLETED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED) &&
      (customerServiceRequest?.serviceName === Constant.CustomerService.BLENDING_REQUEST || customerServiceRequest?.serviceName === Constant.CustomerService.RE_CONTAINERIZATION)) {
      const isPresent = await SupportApiService.checkAllDestinationBarrelValuePresent(id, customerServiceRequest?.serviceName);
      if (!isPresent.data) {
        const message = CommonService.isAdmin()
          ? "Cannot complete request: selected container are missing destination container details. Please add them before closing."
          : "Please add Destination Container Details for all selected container before reassigning to admin.";

        CommonService.Toast.fire({
          title: message,
          icon: "error",
        });
        handleClose();
        return;
      }
    }
    
    setIsLoading(true);
    
      //now call the api and update the status
    try {
      //before calling the api we need to set the reason if status is cancelled and set spend hour if the status Closed
      if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CANCELLED) {
        serviceRequestUpdateStatus.current.reason = reason;
      } else if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED) {
        serviceRequestUpdateStatus.current.reason = reason;
      } else if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CLOSED) {
        serviceRequestUpdateStatus.current.spendHourOnRequest = spendHour;
      } else if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && customerServiceRequest?.serviceName == Constant.CustomerService.SELL_REQUEST)) {
        serviceRequestUpdateStatus.current.fee = sellRequestFee;
        serviceRequestUpdateStatus.current.feeType = sellRequestFeeType;
      } else if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.IN_TRANSIT && (customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST))) {
        serviceRequestUpdateStatus.current.trackNumber = trackNumberValue;
        serviceRequestUpdateStatus.current.flow = flowValue;
      } else if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.SEND_TO_WAREHOUSE) {
        serviceRequestUpdateStatus.current.assignedTo = selectedWarehouseUser;
      } else if(serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.SOURCE_ACCEPTED) {
        serviceRequestUpdateStatus.current.sourceCompanyAcceptedByName = ownershipName
      } else if(serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.DESTINATION_ACCEPTED) {
        serviceRequestUpdateStatus.current.destinationCompanyAcceptedByName = ownershipName
      }

      serviceRequestUpdateStatus.current.transferRequestId = 
          transferRequestId && transferRequestId.length > 0 ? transferRequestId : null;

      const response = await SupportApiService.updateCustomerServiceRequestStatus(serviceRequestUpdateStatus.current);
      getCustomerServiceRequestDetails();
      fetchCustomerServiceRequestHistory();
      handleClose();
      CommonService.Toast.fire({
        title: "Status updated successfully",
        icon: "success",
      });
      setIsLoading(false);
    } catch (error) {
      
      console.log("error occurred while api calling " + error?.response?.data?.errorMessage);

      if(customerServiceRequest?.serviceName == Constant.CustomerService.SELL_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.OWNERSHIP_TRANSFER || customerServiceRequest?.serviceName == Constant.CustomerService.LOGISTIC) {
        // CommonService.Toast.fire({
        //   title: `${error?.response?.data?.errorMessage}`,
        //   icon: "error",
        // });

        setIsSelectedBarrelAreReserved((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.DELETED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.UNPUBLISHED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REPUBLISHED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.IN_TRANSIT) ? error?.response?.data?.data : error?.response?.data?.errorMessage);
      }

      if(error?.response?.data?.errorMessage == 'REQUEST_CANCELLED') {
        CommonService.Toast.fire({
          title: `This request has already been cancelled and cannot be ${serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.UNPUBLISHED ? 'Unpublished' : 'Deleted'} `,
          icon: "error",
        });
      }
      
      setIsLoading(false);
    }
  
  }

  const toggleDropdown = () => {
    setOpen(!open);
  };

  const [activeRowIndex, setActiveRowIndex] = useState(null);

  const handleRowClick = (index: number, type: "quantity" | "scanned") => {
    if (activeRowIndex === index && activeType === type) {
      // collapse if clicked again
      setActiveRowIndex(null);
      setActiveType(null);
    } else {
      setActiveRowIndex(index);
      setActiveType(type);
    }
  };


    return(
        <>
        <div className="usersList position-relative" style={{ paddingBottom: CommonService.isAdmin() ? 54 : "" }}>
          <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div className="d-flex flex-wrap justify-content-between gap-4">
            {(CommonService.isAdmin() || CommonService.isWarehouse()) && (
              <div className="d-flex align-items-center gap-1">
              <><div className="back__button me-1" onClick={routeBack}>
                            <IconButton
                                aria-label="ArrowBackIcon"
                                sx={{ backgroundColor: "#FFF"}}
                            >
                                <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                            </IconButton>
                        </div>
                        <div className="header--title me-3">
                                <h1 className="title mb-0">
                                    Customer Service Request Details
                                    <i className="bi bi-heart-fill"></i>
                                </h1>
                            </div></>
                            </div>
            )}

  
            <div className="header--title d-flex flex-wrap me-auto mb-xxl-0 gap-2 gap-xxl-3">
              <div className="time__details me-4 me-xl-4 mb-0">
                <Typography
                  variant="h6"
                  sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                >
                  Request Number
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                >
                  #{customerServiceRequest?.requestNumber}
                </Typography>
              </div>
              {customerServiceRequest.serviceName === Constant.CustomerService.BULK_INVENTORY_UPLOAD ? ('') : (
                  <div className="time__details me-4 me-xl-4 mb-0">
                    <Typography
                      variant="h6"
                      sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                    >
                      Service Type
                    </Typography>
                    <Typography
                      variant="h3"
                      sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                    >
                      {customerServiceRequest?.serviceName}
                      {customerServiceRequest?.requestTitle
                      ? ` (${customerServiceRequest.requestTitle})`
                      : ""}
                    </Typography>
                  </div>
                )}

                  
                      {CommonService.isAdmin() && (
                        <div className="company__details me-4 me-xl-4 mb-0">
                          <Typography
                            variant="h6"
                            sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                          >
                            Company Name
                          </Typography>
                          <Typography
                            variant="h3"
                            sx={{
                              color: "#333333",
                              fontSize: { xl: "18px", xs: "16px" },
                              fontWeight: 700,
                            }}
                          >
                            {customerServiceRequest?.companyName}
                          </Typography>
                        </div>
                      )}
                      {/* Always show username */}
                      <div className="company__details me-4 me-xl-4 mb-0">
                        <Typography
                          variant="h6"
                          sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                        >
                          User
                        </Typography>
                        <Typography
                          variant="h3"
                          sx={{
                            color: "#333333",
                            fontSize: { xl: "18px", xs: "16px" },
                            fontWeight: 700,
                          }}
                        >
                          {customerServiceRequest?.userName}
                        </Typography>
                      </div>
                   
  
                  <div className="person__details me-4 me-xl-4 mb-0">
                    <Typography
                      variant="h6"
                      sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                    >
                      Requested On
                    </Typography>
                    <Typography
                      variant="h3"
                      sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                    >
                      {CommonService.formatDateTime(customerServiceRequest?.createdAt)}
                    </Typography>
                  </div>

                {/* As of now will not show Track Number in header will show in dynamic fields */}

                {/* {customerServiceRequest.serviceName === Constant.CustomerService.SAMPLE_REQUEST && (() => {
                  const trackField = customerServiceRequest?.dynamicFields?.find(
                    (field) => field?.fieldName === "Track Number" && field?.value
                  );

                  return trackField ? (
                    <div className="person__details me-4 me-xl-4 mb-0">
                      <Typography
                        variant="h6"
                        sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                      >
                        Track Number
                      </Typography>
                      <Typography
                        variant="h3"
                        sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                      >
                        {trackField.value}
                      </Typography>
                    </div>
                  ) : null;
                })()} */}

               {/*{customerServiceRequest?.status == 'CLOSED' && customerServiceRequest?.timeSpentOnRequest && (<div className="time__details me-4 me-xl-4 mb-0">
                <Typography
                  variant="h6"
                  sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                >
                  Spent Time
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                >
                  {customerServiceRequest?.timeSpentOnRequest} {customerServiceRequest?.timeSpentOnRequest > 1 ?  'Hrs' : 'Hr'} 
                </Typography>
              </div>)}*/}
              {customerServiceRequest?.status === 'CLOSED' && customerServiceRequest?.timeSpentOnRequest > 0 &&
                customerServiceRequest?.timeSpentOnRequest <= 24 && (
                  <div className="time__details me-4 me-xl-4 mb-0">
                    <Typography
                      variant="h6"
                      sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                    >
                      Spent Time
                    </Typography>
                    <Typography
                      variant="h3"
                      sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                    >
                      {customerServiceRequest?.timeSpentOnRequest}{" "}
                      {customerServiceRequest?.timeSpentOnRequest > 1 ? "Hrs" : "Hr"}
                    </Typography>
                  </div>
                )}
              <div className="time__details me-4 me-xl-4 mb-0">
                <Typography
                  variant="h6"
                  sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                >
                  Status
                </Typography>
                <Typography
                  variant="h3"
                  className="d-inline-flex align-items-center"
                >
                  {((customerServiceRequest?.status === "UPLOADING" && customerServiceRequest?.serviceName === Constant.CustomerService.BULK_INVENTORY_UPLOAD) || (customerServiceRequest?.status === "PROCESSING" && customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC)) && (
                    <div className="upload-spinner-wrapper me-1">
                    <Spinner/>
                    </div>
                  )} 
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={statusList.length == 0}
                  allowedLabels={CommonService.transformStatusList(statusList)}
                />
                {(customerServiceRequest?.status === "CANCELLED"  || customerServiceRequest?.status == 'REJECTED') && customerServiceRequest?.cancellationReason && (
                <Tooltip
                  title={`Reason: ${customerServiceRequest?.cancellationReason}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
                )}
                </Typography>
              </div>
              <div className="header--menu">
              <div className="header--menu-items d-flex align-items-center">
              {!CommonService.isWarehouse() && <IconButton
                  aria-label="message"
                  size="small"
                  onClick={
                    handleMessageBoxClick
                  }
                  sx={{
                    borderRadius: "50%",
                    backgroundColor: isMessageBoxOpen ? "#97AEB8" : "#FFF",
                    color: isMessageBoxOpen ? "#FFF" : "#1C1B1F",
                    marginInline: "8px",
                    padding: "8px",
                  }}
                >
                  <MarkunreadOutlinedIcon />
                  {unreadMessageCount > 0  && (
                    <div className="msg-count-wrapper">{unreadMessageCount}</div>
                  )}
                  {showMessageBox && <ArrowDropUpIcon className="arrow-icon" />}
                </IconButton>}
                {showMessageBox && (
                  <div className="admin-message-box">
                    <div
                      className="admin-message-box-left-inner"
                      onClick={handleAdminMessageClick}
                    ></div>
                    <div className="admin-message-box-inner positio-relative" ref={innerRef}>
                      <AdminMessageBox
                        selectedGroup={""}
                        requestId={id}
                        requestType={"CUSTOMER_SERVICE_REQUEST"}
                        unreadGroupsCount={unreadGroupsCount}
                        setUnreadGroupsCount={setUnreadGroupsCount}
                        isSeller={false}
                        containerHeight={innerHeight}
                      />
                    </div>
                  </div>
                )}
                </div>
              </div>
              <div className="header--menu">
              <div className="header--menu-items d-flex align-items-center">
                    {(((customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) && ['PENDING_REVIEW','UNDER_REVIEW', 'SEND_TO_OWNER'].includes(customerServiceRequest?.status)) 
                    || ((CommonService.isAdmin() && customerServiceRequest?.serviceName === Constant.CustomerService.TASTING && ['SEND_TO_WAREHOUSE', 'ADMIN_ACCEPTED_FOR_WAREHOUSE'].includes(customerServiceRequest?.status)))
                    || ((!(customerServiceRequest?.roleName == "SUPER_ADMIN" && CommonService.isUser()) || customerServiceRequest?.serviceName == Constant.CustomerService.RE_CONTAINERIZATION || customerServiceRequest?.serviceName == Constant.CustomerService.BARREL_HEAD_PAINTING) && customerServiceRequest?.serviceName !== Constant.CustomerService.TASTING && ['PENDING_REVIEW','UNDER_REVIEW', 'SEND_TO_OWNER'].includes(customerServiceRequest?.status)) 
                    || (customerServiceRequest.serviceName === Constant.CustomerService.SELL_REQUEST && (!['CANCELLED', 'REJECTED', 'DELETED','UNPUBLISHED'].includes(customerServiceRequest?.status))) 
                    || (customerServiceRequest.serviceName === Constant.CustomerService.WANTED_TO_BUY && (!['CANCELLED', 'REJECTED', 'DELETED','COMPLETED'].includes(customerServiceRequest?.status)))) 
                    && (<Tooltip title="Edit" arrow>
                    <IconButton
                        aria-label="message"
                        size="small"
                        disabled= {customerServiceRequest.serviceName !== Constant.CustomerService.SELL_REQUEST && customerServiceRequest.serviceName !== Constant.CustomerService.WANTED_TO_BUY && (customerServiceRequest?.roleName == "SUPER_ADMIN" && CommonService.isUser() && customerServiceRequest?.serviceName != Constant.CustomerService.RE_CONTAINERIZATION && customerServiceRequest?.serviceName != Constant.CustomerService.BARREL_HEAD_PAINTING) && !(customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST || customerServiceRequest?.serviceName != Constant.CustomerService.TASTING)}
                        onClick={handleEditServiceRequest}
                        sx={{ borderRadius: "50%", backgroundColor: "#FFF", color: "#1C1B1F", marginInline: "8px", padding: "8px" }}
                    >
                         <img className="cursor-pointer" 
                          src={EditIcon}
                          alt="EditIcon"
                        />
                    </IconButton>
                    </Tooltip>)}
                    {((CommonService.isAdmin() && customerServiceRequest.serviceName == Constant.CustomerService.BARREL_PROOFING && !['PENDING_REVIEW', 'UNDER_REVIEW', 'REJECTED', 'CANCELLED', 'CLOSED', 'ACCEPTED', 'COMPLETED'].includes(customerServiceRequest?.status)) || (CommonService.isWarehouse() && customerServiceRequest.serviceName == Constant.CustomerService.BARREL_PROOFING && ['SEND_TO_WAREHOUSE', 'IN_PROCESS'].includes(customerServiceRequest?.status))) && (<Tooltip title="Manage Proofing Details" arrow>
                    <IconButton
                        aria-label="message"
                        size="small"
                        onClick={() => setManageProofingDetailClick(true)}
                        sx={{ borderRadius: "50%", backgroundColor: "#FFF", color: "#1C1B1F", marginInline: "8px", padding: "8px", height:"40px", width:"40px" }}
                    >
                         <img className="cursor-pointer" 
                          src={ProofIcon}
                          alt="ProofIcon"
                        />
                    </IconButton>
                    </Tooltip>)}

                    {((CommonService.isAdmin() && customerServiceRequest.serviceName === Constant.CustomerService.BARREL_VALUATION && !['PENDING_REVIEW', 'UNDER_REVIEW', 'REJECTED', 'CANCELLED', 'CLOSED', 'ACCEPTED', 'COMPLETED'].includes(customerServiceRequest?.status))) && (<Tooltip title="Manage Valuation Details" arrow>
                    <IconButton
                        aria-label="message"
                        size="small"
                        onClick={() => setManageValuationDetailClick(true)}
                        sx={{ borderRadius: "50%", backgroundColor: "#FFF", color: "#1C1B1F", marginInline: "8px", padding: "8px", height:"40px", width:"40px" }}
                    >
                         <img className="cursor-pointer" 
                          src={ValuationIcon}
                          alt="ValuationIcon"
                          height={"40px"}
                        />
                    </IconButton>
                    </Tooltip>)}

                    {!CommonService.isUser() && !CommonService.isWarehouse() && ((CommonService.isAdmin() && (customerServiceRequest.serviceName === Constant.CustomerService.BLENDING_REQUEST || customerServiceRequest.serviceName === Constant.CustomerService.RE_CONTAINERIZATION) &&
                      !['PENDING_REVIEW', 'UNDER_REVIEW', 'REJECTED', 'CANCELLED', 'CLOSED', 'ACCEPTED', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ACCEPTED_REJECTED', 'SCHEDULED', 'COMPLETED'].includes(customerServiceRequest?.status)) ||
                      ((customerServiceRequest.serviceName === Constant.CustomerService.BLENDING_REQUEST || customerServiceRequest.serviceName === Constant.CustomerService.RE_CONTAINERIZATION) && ['SEND_TO_WAREHOUSE', 'IN_PROCESS'].includes(customerServiceRequest?.status))) && (<Tooltip title="Manage Destination Container Details" arrow>
                        <IconButton
                          aria-label="message"
                          size="small"
                          onClick={() => setManageDestinationDetailsClick(true)}
                          sx={{ borderRadius: "50%", backgroundColor: "#FFF", color: "#1C1B1F", marginInline: "8px", padding: "8px", height: "40px", width: "40px" }}
                        >
                          <img className="cursor-pointer"
                            src={DestinationBarrelIcon}
                            alt="DestinationBarrelIcon"
                            height={20}
                          />
                        </IconButton>
                      </Tooltip>)}
                    </div>
                  </div>
                    {/* {CommonService.isAdmin() && customerServiceRequest.serviceName == Constant.CustomerService.BARREL_PROOFING && (<Tooltip title="Export PDF" arrow>
                    <IconButton
                        aria-label="message"
                        size="small"
                        disabled= {customerServiceRequest.serviceName !== Constant.CustomerService.SELL_REQUEST && customerServiceRequest?.roleName == "SUPER_ADMIN" && CommonService.isUser() && !(customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST)}
                        onClick={() => exportBarrelProofingValue("PDF")}
                        sx={{ borderRadius: "50%", backgroundColor: "#FFF", color: "#1C1B1F", marginInline: "8px", padding: "8px" }}
                    >

                      <img className="cursor-pointer" 
                          src={ExportIcon}
                          alt="PdfExportIcon"
                        />
                      
                    </IconButton>
                    </Tooltip>)}

                    {CommonService.isAdmin() && customerServiceRequest.serviceName == Constant.CustomerService.BARREL_PROOFING && (<Tooltip title="Export PDF" arrow>
                    <IconButton
                        aria-label="message"
                        size="small"
                        disabled= {customerServiceRequest.serviceName !== Constant.CustomerService.SELL_REQUEST && customerServiceRequest?.roleName == "SUPER_ADMIN" && CommonService.isUser() && !(customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST)}
                        onClick={() => exportBarrelProofingValue("PDF")}
                        sx={{ borderRadius: "50%", backgroundColor: "#FFF", color: "#1C1B1F", marginInline: "8px", padding: "8px" }}
                    >
                         <img className="cursor-pointer" 
                          src={PDFExportIcon}
                          alt="PdfExportIcon"
                        />
                        Export as PDF
                    </IconButton>
                    </Tooltip>)}

                    {CommonService.isAdmin() && customerServiceRequest.serviceName == Constant.CustomerService.BARREL_PROOFING && (<Tooltip title="Export Excel" arrow>
                    <IconButton
                        aria-label="message"
                        size="small"
                        disabled= {customerServiceRequest.serviceName !== Constant.CustomerService.SELL_REQUEST && customerServiceRequest?.roleName == "SUPER_ADMIN" && CommonService.isUser() && !(customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST)}
                        onClick={() => exportBarrelProofingValue("Excel")}
                        sx={{ borderRadius: "50%", backgroundColor: "#FFF", color: "#1C1B1F", marginInline: "8px", padding: "8px" }}
                    >
                         <img className="cursor-pointer" 
                          src={ExcelExportIcon}
                          alt="PdfExportIcon"
                        /> Export as Excel
                    </IconButton>
                    </Tooltip>)} */}
                <div className="header--menu">
                  <div className="header--menu-items d-flex align-items-center"></div>
                  {customerServiceRequest.serviceName === Constant.CustomerService.BARREL_PROOFING && !['PENDING_REVIEW', "UNDER_REVIEW", "REJECTED", "CANCELLED", "ACCEPTED"].includes(customerServiceRequest?.status) && (
                    <div className="dropdown d-inline-block" ref={dropdownRef}>
                      <button
                        className="btn btn-light border rounded-circle d-flex align-items-center justify-content-center"
                        type="button"
                        onClick={toggleDropdown}
                        style={{
                          borderRadius: "50%",
                          backgroundColor: open ? "#97AEB8" : "#FFF",
                          color: open ? "#FFF" : "#1C1B1F",
                          marginInline: "8px",
                          padding: "8px",
                          height: "40px",
                          width: "40px",
                        }}
                      >
                        {open ? (
                          <img
                            className="cursor-pointer"
                            src={ExportIconLight}
                            alt="Proofing Export"
                          />
                        ) : (
                          <img
                            className="cursor-pointer"
                            src={ExportIcon}
                            alt="Proofing Export"
                          />
                        )}
                      </button>

                      <ul
                        className={`dropdown-menu ${open ? "show" : ""}`}
                        style={{ minWidth: "160px", marginLeft: "-74px" }}
                      >
                        <li>
                          <button className="dropdown-item d-flex align-items-center" onClick={() => exportBarrelProofingValue("PDF")}>
                            <img src={PDFExportIcon} alt="Export PDF" style={{ width: 18, height: 18, marginRight: 8 }} />
                            Export as PDF
                          </button>
                        </li>
                        <li>
                          <button className="dropdown-item d-flex align-items-center" onClick={() => exportBarrelProofingValue("Excel")}>
                            <img src={ExcelExportIcon} alt="Export Excel" style={{ width: 18, height: 18, marginRight: 8 }} />
                            Export as Excel
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                  {customerServiceRequest.serviceName === Constant.CustomerService.BARREL_VALUATION && !['PENDING_REVIEW', "UNDER_REVIEW", "REJECTED", "CANCELLED", "ACCEPTED"].includes(customerServiceRequest?.status) && (
                    <div className="dropdown d-inline-block" ref={dropdownRef}>
                      <button
                        className="btn btn-light border rounded-circle d-flex align-items-center justify-content-center"
                        type="button"
                        onClick={toggleDropdown}
                        style={{
                          borderRadius: "50%",
                          backgroundColor: open ? "#97AEB8" : "#FFF",
                          color: open ? "#FFF" : "#1C1B1F",
                          marginInline: "8px",
                          padding: "8px",
                          height: "40px",
                          width: "40px",
                        }}
                      >
                        {open ? (
                          <img
                            className="cursor-pointer"
                            src={ExportIconLight}
                            alt="Valuation Export"
                          />
                        ) : (
                          <img
                            className="cursor-pointer"
                            src={ExportIcon}
                            alt="Valuation Export"
                          />
                        )}
                      </button>

                      <ul
                        className={`dropdown-menu ${open ? "show" : ""}`}
                        style={{ minWidth: "160px", marginLeft: "-74px" }}
                      >
                        <li>
                          <button className="dropdown-item d-flex align-items-center" onClick={() => exportBarrelValuationValue("PDF")}>
                            <img src={PDFExportIcon} alt="Export PDF" style={{ width: 18, height: 18, marginRight: 8 }} />
                            Export as PDF
                          </button>
                        </li>
                        <li>
                          <button className="dropdown-item d-flex align-items-center" onClick={() => exportBarrelValuationValue("Excel")}>
                            <img src={ExcelExportIcon} alt="Export Excel" style={{ width: 18, height: 18, marginRight: 8 }} />
                            Export as Excel
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                  {customerServiceRequest.serviceName === Constant.CustomerService.TASTING && !['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'SCHEDULED','CANCELLED', 'ACCEPTED', 'REJECTED', 'DELETED'].includes(customerServiceRequest?.status) && (
                    <div className="dropdown d-inline-block" ref={dropdownRef}>
                      <button
                        className="btn btn-light border rounded-circle d-flex align-items-center justify-content-center"
                        type="button"
                        onClick={toggleDropdown}
                        style={{
                          borderRadius: "50%",
                          backgroundColor: open ? "#97AEB8" : "#FFF",
                          color: open ? "#FFF" : "#1C1B1F",
                          marginInline: "8px",
                          padding: "8px",
                          height: "40px",
                          width: "40px",
                        }}
                      >
                        {open ? (
                          <img
                            className="cursor-pointer"
                            src={ExportIconLight}
                            alt="Proofing Export"
                          />
                        ) : (
                          <img
                            className="cursor-pointer"
                            src={ExportIcon}
                            alt="Proofing Export"
                          />
                        )}
                      </button>

                      <ul
                        className={`dropdown-menu ${open ? "show" : ""}`}
                        style={{ minWidth: "160px", marginLeft: "-74px" }}
                      >
                        <li>
                          <button className="dropdown-item d-flex align-items-center" onClick={() => exportTastingValue("Excel")}>
                            <img src={ExcelExportIcon} alt="Export Excel" style={{ width: 18, height: 18, marginRight: 8 }} />
                            Export as Excel
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}

                  {((customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST)
                    || !(customerServiceRequest?.roleName == "SUPER_ADMIN" && CommonService.isUser()))
                    && ['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER'].includes(customerServiceRequest?.status)
                    && (<Tooltip title="Delete" arrow>
                      <IconButton
                        aria-label="message"
                        size="small"
                        disabled={customerServiceRequest?.roleName == "SUPER_ADMIN" && CommonService.isUser() && !(customerServiceRequest?.serviceName == Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST)}
                        sx={{ borderRadius: "50%", backgroundColor: "#FFF", color: "#1C1B1F", marginInline: "8px", padding: "8px" }}
                        onClick={deleteServiceRequest}
                      >
                        <img src={TrashIcon} />
                      </IconButton>
                    </Tooltip>
                    )}
                </div>
              </div>
                
              
            </div>
            <div className="header--menu ms-auto mb-xxl-0">
              <div className="header--menu-items d-flex align-items-center flex-wrap gap-2">
                {/* <IconButton
                  aria-label="message"
                  size="small"
                  onClick={
                    handleMessageBoxClick
                  }
                  sx={{
                    borderRadius: "50%",
                    backgroundColor: isMessageBoxOpen ? "#97AEB8" : "#FFF",
                    color: isMessageBoxOpen ? "#FFF" : "#1C1B1F",
                    marginInline: "8px",
                    padding: "8px",
                  }}
                >
                  <MarkunreadOutlinedIcon />
                  {unreadMessageCount > 0  && (
                    <div className="msg-count-wrapper">{unreadMessageCount}</div>
                  )}
                  {showMessageBox && <ArrowDropUpIcon className="arrow-icon" />}
                </IconButton>
                {showMessageBox && (
                  <div className="admin-message-box">
                    <div
                      className="admin-message-box-left-inner"
                      onClick={handleAdminMessageClick}
                    ></div>
                    <div className="admin-message-box-inner positio-relative" ref={innerRef}>
                      <AdminMessageBox
                        selectedGroup={""}
                        requestId={id}
                        requestType={"CUSTOMER_SERVICE_REQUEST"}
                        unreadGroupsCount={unreadGroupsCount}
                        setUnreadGroupsCount={setUnreadGroupsCount}
                        isSeller={false}
                        containerHeight={innerHeight}
                      />
                    </div>
                  </div>
                )} */}
              

{/* 
{(customerServiceRequest?.status == 'PENDING_REVIEW' ||  customerServiceRequest?.status == 'UNDER_REVIEW') && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={false}
                  allowedLabels={CommonService.isAdmin() ? ["Under Review","Accepted","Rejected"] : ["Cancelled"]}
                />)} */}

{/* {(customerServiceRequest?.status === Constant.CustomerServiceRequestStatus.PENDING_REVIEW ||
  customerServiceRequest?.status === Constant.CustomerServiceRequestStatus.UNDER_REVIEW) && (
  <StatusDropdown
    currentStatus={formatStatus(customerServiceRequest?.status)}
    onStatusChange={(newStatus) => handleStatusChange(newStatus)}
    disableCondition={false}
    allowedLabels={CustomerServiceStatus[customerServiceRequest?.status]?.allowedLabels(
      CommonService.isAdmin()
    )}
  />
)}  */}


{/* {(customerServiceRequest?.status === Constant.CustomerServiceRequestStatus.PENDING_REVIEW ||
  customerServiceRequest?.status === Constant.CustomerServiceRequestStatus.UNDER_REVIEW) && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={false}
                  allowedLabels={CommonService.isAdmin() ? [Constant.CustomerServiceRequestStatus.UNDER_REVIEW, Constant.CustomerServiceRequestStatus.ACCEPTED, Constant.CustomerServiceRequestStatus.REJECTED] : [Constant.CustomerServiceRequestStatus.CANCELLED]}
                />)}  */}

              {/* {customerServiceRequest?.status == 'ACCEPTED'  && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={false}
                  allowedLabels={CommonService.isAdmin() ? (customerServiceRequest?.serviceName == 'Ownership Transfer' ? ["In Progress", "Ownership Transferred","Rejected"]: ["In Progress","Uploaded","Rejected"]) : ["Cancelled"]}
                />)}

{customerServiceRequest?.status == 'IN_PROGRESS'  && customerServiceRequest?.serviceName != 'Ownership Transfer' && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={false}
                  allowedLabels={CommonService.isAdmin() ? ["Uploaded","Rejected","Closed"] : ["Cancelled"]}
                />)}

{customerServiceRequest?.status == 'IN_PROGRESS'  && customerServiceRequest?.serviceName == 'Ownership Transfer' && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={false}
                  allowedLabels={CommonService.isAdmin() ? ["Rejected","Ownership Transferred"] : ["Cancelled"]}
                />)}

{customerServiceRequest?.status == 'UPLOADED'  && customerServiceRequest?.serviceName == 'Bulk Inventory Upload' && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={["Closed"]}
                />)}

{customerServiceRequest?.status == 'OWNERSHIP_TRANSFERRED' && customerServiceRequest?.serviceName == 'Ownership Transfer' && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={["Rejected","Closed"]}
                />)}

              

                {/* if the status is cancelled or rejected or closed then its a last stage 
{(customerServiceRequest?.status == 'CANCELLED' || customerServiceRequest?.status == 'REJECTED' || customerServiceRequest?.status == 'CLOSED') && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={true}
                  allowedLabels={[""]}
                />)}
                
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={statusList.length == 0}
                  allowedLabels={CommonService.transformStatusList(statusList)}
                />
                
   {(customerServiceRequest?.status === "CANCELLED"  || customerServiceRequest?.status == 'REJECTED') && customerServiceRequest?.cancellationReason && (
                <Tooltip
                  title={`Reason: ${customerServiceRequest?.cancellationReason}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )}
                {/* {(customerServiceRequest?.status == 'PENDING_REVIEW' && customerServiceRequest?.status == 'OPEN') && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={false}
                  allowedLabels={["Open", "Close"]}
                />)}

                {customerServiceRequest?.status == 'CLOSE' && (
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={false}
                  allowedLabels={["Reopen"]}
                />)} */}
                <div className="d-inline-flex align-items-center">
                {/* {(customerServiceRequest?.status === "UPLOADING" && customerServiceRequest?.serviceName === "Bulk Inventory Upload") && (
                  <div className="upload-spinner-wrapper">
                  <Spinner/>
                  </div>
                )}
                <StatusDropdown
                  currentStatus={formatStatus(customerServiceRequest?.status)}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={statusList.length == 0}
                  allowedLabels={CommonService.transformStatusList(statusList)}
                /> */}
              {/* {(customerServiceRequest?.status === "CANCELLED"  || customerServiceRequest?.status == 'REJECTED') && customerServiceRequest?.cancellationReason && (
                <Tooltip
                  title={`Reason: ${customerServiceRequest?.cancellationReason}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )} */}

                </div>
              
                
              </div>
            </div>
          </div>
          <div className="viewSampleRequest--wrapper view_request--wrapper view_sample-wrapper viewOrderRequest--wrapper viewServiceRequest--wrapper viewSupport-req" ref={wrapperRef}>
            <div
              className={`${
                isOpenEditSection
                  ? "margin-right-400" // When only `isOpenEditSection` is true
                  : isMessageBoxOpen
                  ? "margin-right-430" // Only `isMessageBoxOpen` is true
                  : "no-margin w-100" // When none of the conditions are met
              }`}
            >
              <div
                className="view-sample-request m-0"
                style={{ zIndex: "10", position: "relative" }}
              >
                
                <div className="row m-0 mb-3">
                  <div className="col-12 px-0">
                    {customerServiceRequest.serviceName === Constant.CustomerService.BULK_INVENTORY_UPLOAD ? (
                    <>
                      <div className="inventory-file-list-table p-0">
                        <div className="service-detail-right bluk-upload-full">
                          <div className="row m-0">
                            <div className="col-12">
                              <div className="row">
                                {/* iterate customerServiceRequest.dynamicFields */}
                                <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                  <div className="content-wrapper">
                                    <p className="content-title">
                                        Service Type
                                    </p>
                                      <div className="title-bottom-line"></div>
                                      <div className="d-flex align-items-start gap-3">
                                        <p className="content-text">{customerServiceRequest?.serviceName}</p>
                                      </div>
                                  </div>
                                </div>
                                {customerServiceRequest?.dynamicFields?.filter(field => field?.fieldName !== "Upload Supporting Documents") // 👈 Exclude this field
                                .map((field, index) => (
                                  <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                    <div className="content-wrapper"> 
                                    {field?.fieldName !== "Upload Supporting Documents" ? (
                                      <>
                                        <p className="content-title">{field?.fieldName}</p>
                                        <div className="title-bottom-line"></div>
                                      </>
                                    ) : null}
                                      <div className="d-flex align-items-start gap-3">
                                        {field?.fieldName === "Upload Inventory CSV/Excel File" ? (
                                          <>
                                            <p className="content-text">{field?.value.split("_").slice(1).join("_")}</p>
                                            {['PENDING_REVIEW','UNDER_REVIEW'].includes(customerServiceRequest?.status)  && (
                                              <>
                                                {/* Tooltip button to open the file upload modal */}
                                                <Tooltip title="Upload" arrow>
                                                  <button className="upload-icon-btn" onClick={handleFileShow}>
                                                    <FileUploadOutlinedIcon sx={{ ml: 1 }} />
                                                  </button>
                                                </Tooltip>

                                                {/* File Upload Modal */}
                                                <Modal
                                                  size="lg"
                                                  show={showFileUploadModal}
                                                  onHide={handleFileClose}
                                                  className="modal__wd modal__inviteUser modal__wd--submitSellReq"
                                                >
                                                  <Modal.Header className="flex-column align-items-start">
                                                    <Modal.Title className="mb-1"> Bulk Inventory Upload File</Modal.Title>
                                                    {!isInvited && (
                                                      <p className="modal-text text-start mb-0">
                                                        To add a file, drag and drop in the area below or select the
                                                        "Select file" button.
                                                      </p>
                                                    )}
                                                    {isInvited && (
                                                      <p className="modal-text text-start">
                                                        Your submission has been submitted successfully, You will receive
                                                        a notification upon its completion.
                                                      </p>
                                                    )}
                                                    <Button
                                                      variant="close"
                                                      className="d-inline-flex justify-content-center align-items-center"
                                                      onClick={handleFileClose}
                                                    >
                                                      <CloseIcon />
                                                    </Button>
                                                  </Modal.Header>

                                                  {!isInvited && (
                                                    <Modal.Body className="border-0">
                                                      {(!validated && !isLoading) && (
                                                        <Form className="form__inner row d-flex pb-0" onSubmit={uploadFilesAndDocs}>
                                                          <Form.Group>
                                                            {/* Drag and Drop or Browse File */}
                                                            <div className="file__upload--container">
                                                              <div
                                                                className={`text-center mb-3 ${validated && !file
                                                                  ? "file__upload--dropzone-danger"
                                                                  : "file__upload--dropzone"
                                                                  }`}
                                                                id="drop_zone"
                                                                onDrop={onDropHandler}
                                                                onDragOver={onDragOver}
                                                              >
                                                                <div>
                                                                  <img src={CloudArrowUp} alt="Cloud Upload Icon" />
                                                                  <br />
                                                                  <span className="fw-bold">Drag & Drop to Upload File</span>
                                                                </div>
                                                                <div className="my-2 fw-bold">OR</div>

                                                                <label
                                                                  htmlFor="file_picker"
                                                                  className="primary-btn fp-label fw-bold"
                                                                >
                                                                  Browse file
                                                                </label>

                                                                <Form.Control
                                                                  required
                                                                  type="file"
                                                                  id="file_picker"
                                                                  onChange={handleFileChange}
                                                                  accept=".csv, .xls, .xlsx"
                                                                  style={{ display: "none" }}
                                                                />
                                                              </div>
                                                            </div>
                                                          </Form.Group>

                                                          {/* Error message if no file is selected */}
                                                          {validated && !file && (
                                                            <p className="error-message">
                                                              Please select a valid CSV or Excel file.
                                                            </p>
                                                          )}

                                                          {/* Display the selected file name */}
                                                          {file?.name && (
                                                            <>
                                                            {/* <div className="d-flex align-items-center gap-3 flex-wrap"> */}
                                                              <div className="file__upload--info d-inline-flex align-items-center mt-1" style={{ color: "#737376" }}>
                                                                <div className="me-2">
                                                                  <DescriptionOutlinedIcon />
                                                                </div>
                                                                <div
                                                                  className="file-name me-2"
                                                                  key={file?.name}
                                                                  // style={{ fontWeight: "bold" }}
                                                                >
                                                                  {file?.name}
                                                                </div>
                                                                <div
                                                                  className="file-delete"
                                                                  onClick={() => setFile(null)}
                                                                >
                                                                  <HighlightOffRoundedIcon fontSize="small" />
                                                                </div>
                                                              </div>
                                                              {/* </div> */}
                                                            </>
                                                          )}
                                                        </Form>
                                                      )}
                                                      {(validated && !isLoading) && (<List className="warning-list">
                                                        {validationsList?.map((validation, index) => (
                                                          <React.Fragment key={index}>
                                                            <ListItem alignItems="flex-start" sx={{ display: 'flex', paddingInline: '0px' }}>
                                                              <ListItemAvatar sx={{ minWidth: 'unset', marginTop: 0, marginRight: '2px' }}>
                                                                <WarningRoundedIcon sx={{ color: '#b10e1c' }} />
                                                              </ListItemAvatar>
                                                              <ListItemText
                                                                sx={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}
                                                                primary={
                                                                  <React.Fragment>
                                                                    <Typography
                                                                      component="span"
                                                                      variant="body2"
                                                                      sx={{ color: '#b10e1c', fontWeight: 600, wordBreak: 'break-all' }}
                                                                    >
                                                                      Row # {validation?.rowNumber} -
                                                                    </Typography>
                                                                    <Typography
                                                                      component="span"
                                                                      variant="body2"
                                                                      sx={{ color: '#b10e1c', fontWeight: 400, marginLeft: '4px' }}
                                                                    >
                                                                      {validation?.errorMessages}
                                                                    </Typography>
                                                                  </React.Fragment>
                                                                }
                                                                secondary={
                                                                  <React.Fragment>
                                                                    <Typography
                                                                      component="span"
                                                                      variant="body2"
                                                                      sx={{ color: '#496673', fontWeight: 400, cursor: 'pointer' }}
                                                                    >
                                                                    </Typography>
                                                                  </React.Fragment>
                                                                }
                                                              />
                                                            </ListItem>
                                                            {index !== companiesList?.length - 1 && (
                                                              <Divider variant="inset" component="li" sx={{ marginLeft: 0 }} />
                                                            )}
                                                          </React.Fragment>
                                                        ))}
                                                      </List>)}
                                                      {isLoading && (
                                                        <Container maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', miheight: '300px' }}>
                                                          <BootstrapSpinner animation="border" variant="secondary" className="mt-3" />
                                                          <Typography variant="subtitle1" sx={{ fontSize: '20px', fontWeight: 600, color: '#737376', marginTop: '12px' }}>
                                                            Validating file, please wait...
                                                          </Typography>
                                                        </Container>
                                                      )}
                                                    </Modal.Body>
                                                  )}

                                                  {!isInvited && (
                                                    <Modal.Footer className="justify-content-center align-items-center">
                                                      {/* Cancel Button */}
                                                      {!validated && (<button
                                                          className="secondary-btn px-5 mx-1"
                                                          onClick={handleFileClose}
                                                          disabled={isLoading}
                                                        >
                                                          Cancel
                                                        </button>)}
                                                      {/* Upload Button */}
                                                      {(!validated && !isLoading) && (<button
                                                          className="primary-btn px-5 mx-1"
                                                          onClick={uploadFilesAndDocs}
                                                          disabled={isLoading}
                                                        >
                                                          {isLoading && <BootstrapSpinner size="sm"/>}
                                                          Upload
                                                        </button>)}

                                                      {validated && (<button
                                                        className="secondary-btn px-5 mx-1"
                                                        onClick={() => setValidated(false)}
                                                      >
                                                        Back
                                                      </button>)}
                                                    </Modal.Footer>
                                                  )}
                                                  {isInvited && (
                                                    <>
                                                      <Modal.Footer className="justify-content-center bg-transparent">
                                                        <div className="btn-group row d-flex justify-content-center w-100">
                                                          <div className="col-12">
                                                            <button className="secondary-btn w-100" onClick={handleFileClose}>
                                                              Close
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </Modal.Footer>
                                                    </>
                                                  )}
                                                </Modal>
                                              </>)}
                                            
                                            <Tooltip title="Download" arrow>
                                              <IconButton className="download-icon-btn"
                                                onClick={(event) => {
                                                  const companyId = customerServiceRequest?.companyId;
                                                  const dynamicFields = customerServiceRequest?.dynamicFields || [];
                                                  const dynamicField = dynamicFields.find(field => field.fieldName === "Upload Inventory CSV/Excel File");
                                                  const id = dynamicField?.id;
                                                  const fileName = dynamicField?.value;
                                            
                                                  downloadCustomerServiceRequestValueDOC({
                                                    companyId,
                                                    id,
                                                    fileName,
                                                  })}}>
                                                <img className="cursor-pointer" 
                                                            src={DownLoadIcon}
                                                            alt="EditIcon"
                                                          />
                                              </IconButton>
                                            </Tooltip>
                                          </>
                                        ) : field?.value === "true" ? (
                                          <p className="content-text">Yes</p>
                                        ) : field?.value === "false" ? (
                                          <p className="content-text">No</p>
                                        ) : field?.dataType == "date" ? (
                                          <p> {CommonService.formatDate(field?.value)}</p>
                                        ) :(
                                          <p className="content-text">{field?.value}</p>
                                        )}

                                        {/*<div className="content-text">
                                            <ListItem key={index}>
                                              <Typography
                                                variant="body2"
                                                sx={{ color: '#333333', fontSize: '16px', textWrap: 'nowrap' }}
                                              >
                                                {field?.value === 'true' ? (
                                                  <>
                                                    <CheckIcon fontSize="small" sx={{ color: '#25CD25' }} /> Yes
                                                  </>
                                                ) : field?.value === 'false' ? (
                                                  <>
                                                    <CloseIcon fontSize="small" sx={{ color: '#FF3B30' }} /> No
                                                  </>
                                                ) : (
                                                  field?.value
                                                )}
                                              </Typography>
                                            </ListItem>
                                          </div>*/}
                                      </div>
                                    </div>
                                    
                                  </div>
                                ))}

                              {customerServiceRequest?.successCount != null && customerServiceRequest?.failureCount != null && (
                                <>
                                  <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                    <div className="content-wrapper">
                                      <p className="content-title">Total Container</p>
                                      <div className="title-bottom-line"></div>
                                      <div className="d-flex align-items-start gap-3">
                                        <p className="content-text">
                                          {customerServiceRequest.successCount + customerServiceRequest.failureCount}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                    <div className="content-wrapper">
                                      <p className="content-title">Success</p>
                                      <div className="title-bottom-line"></div>
                                      <div className="d-flex align-items-start gap-3">
                                        <p className="content-text">{customerServiceRequest.successCount}</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                    <div className="content-wrapper">
                                      <p className="content-title">Failed</p>
                                      <div className="title-bottom-line"></div>
                                      <div className="d-flex align-items-start gap-3">
                                        <p className="content-text">{customerServiceRequest.failureCount}</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                    <div className="content-wrapper">
                                      <p className="content-title">Export Report</p>
                                      <div className="title-bottom-line"></div>
                                      <div className="d-flex align-items-start gap-3">
                                        <p className="content-text">
                                          Export Report  
                                          <Tooltip title="Export Report" arrow>
                                            <IconButton className="ms-2 download-icon-btn" onClick={() => exportReport()}>
                                                <img className="cursor-pointer" src={DownLoadIcon} alt="EditIcon"
                                            />
                                            </IconButton>
                                          </Tooltip>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}




                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                    ) :
                    customerServiceRequest.serviceName === Constant.CustomerService.LOGISTIC ? (
                    <>
                      <div className="inventory-file-list-table p-0">
                          {isSelectedBarrelAreReserved && (<div className="alert barrel-alert alert-dismissible fade show" role="alert">
                            <span className="d-flex align-items-center gap-2">
                              <WarningIcon />{isSelectedBarrelAreReserved}</span>
                            <button type="button" className="btn-close" aria-label="Close" onClick={removeAlertMessage}> <CloseIcon /></button>
                          </div>)}

                          {/* Dynamic Fields */}
                          <div className="service-detail-right bluk-upload-full logistic-req-detail">
                            <div className="row m-0">
                              <div className="col-12">
                                <div className="row">
                                  {/* iterate customerServiceRequest.dynamicFields */}
                                  <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                    <div className="content-wrapper">
                                      <p className="content-title">
                                          Service Type
                                      </p>
                                        <div className="title-bottom-line"></div>
                                        <div className="d-flex align-items-start gap-3">
                                          <p className="content-text">{customerServiceRequest?.serviceName}</p>
                                        </div>
                                    </div>
                                  </div>
                                  {customerServiceRequest?.dynamicFields?.filter(field => field?.fieldName !== "Upload Supporting Documents") // 👈 Exclude this field
                                  .map((field, index) => (
                                    <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                      <div className="content-wrapper"> 
                                      {field?.fieldName !== "Upload Supporting Documents" ? (
                                        <>
                                          <p className="content-title">{field?.fieldName}</p>
                                          <div className="title-bottom-line"></div>
                                        </>
                                      ) : null}
                                        <div className="d-flex align-items-start gap-3">
                                          {field?.value === "true" ? (
                                            <p className="content-text">Yes</p>
                                          ) : field?.value === "false" ? (
                                            <p className="content-text">No</p>
                                          ) : field?.dataType == "date" ? (
                                            <p> {CommonService.formatDateWithoutTimezone(field?.value)}</p>
                                          ) : field?.dataType == "rich_text" ? (
                                              <p>
                                                {field?.value ? (
                                                  <div className="content-text"
                                                    dangerouslySetInnerHTML={{
                                                      __html: field?.value
                                                    }}
                                                  />
                                                ) : (
                                                  "-"
                                                )}
                                              </p>
                                          ) : (
                                            <p className="content-text">{field?.value}</p>
                                          )}
                                        </div>
                                      </div>
                                      
                                    </div>
                                  ))}
                                  {customerServiceRequest?.dynamicFields
                                  .map((field, index) => (
                                    field?.fieldName == 'Transfer Request' && (
                                      <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                    <div className="content-wrapper">
                                      <RequestDetails id={field?.value} onView={showRequestDetails} />
                                      </div>
                                  </div>
                                    )
                                  ))}
                                  <div className="col-12 col-sm-6 col-lg-3 mb-3">
                                    <div className="content-wrapper">
                                      <p className="content-title">
                                        Comment
                                      </p>
                                      <div className="title-bottom-line"></div>
                                      <p className="content-text">{customerServiceRequest?.comment}</p>
                                    </div>
                                  </div>
                                
                                </div>
                              </div>
                            </div>
                          </div>
                      
                          {/* Container Details */}
                          {(customerServiceRequest.serviceName != Constant.CustomerService.WANTED_TO_BUY ||
                            (customerServiceRequest?.barrelSource != null && customerServiceRequest?.barrelSource === Constant.BarrelSource.SHIP_BY_SELECTING_REQUEST)) && (
                              <div className="logistic-table-wrapper">
                                <div className="table-responsive service-detail-table-wrapper">
                                  <Table className="service-detail-table mb-0">
                                    <thead>
                                      <tr>
                                        <th className="text-start">Inventory</th>
                                        <th className="text-start">Producer</th>
                                        <th className="text-start">Proof</th>
                                        <th className="text-start">Volume</th>
                                        <th className="text-nowrap">Proof Gallon</th>
                                        <th className="text-nowrap">Quantity</th>
                                        <th className="text-nowrap">Scanned</th>
                                        <th className="text-nowrap">Progress</th>
                                        {CommonService.isAdmin() && (!['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'CANCELLED', 'ACCEPTED', 'REJECTED', 'DELETED', 'DELIVERED'].includes(customerServiceRequest.status)) && (
                                          <th className="text-nowrap" style={{ paddingLeft: "0px" }}>
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              checked={isAllChecked()}
                                              disabled={isAllScanned()}
                                              onChange={(e) => handleScanChange("all", e)}
                                              style={{ marginLeft: "10px", cursor: "pointer", width: "18px", height: "18px" }}
                                            />
                                          </th>
                                        )}
                                         
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {!customerServiceRequest?.inventoryDetails?.length &&
                                        customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC && (
                                          <tr>
                                            <td
                                              colSpan={
                                                CommonService.isAdmin() &&
                                                !['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'CANCELLED', 'ACCEPTED', 'REJECTED', 'DELETED', 'DELIVERED'].includes(customerServiceRequest.status)
                                                  ? 9
                                                  : 8
                                              }
                                              className="text-center text-muted"
                                            >
                                              No containers available
                                            </td>
                                          </tr>
                                        )}
                                      {customerServiceRequest?.inventoryDetails?.map((item, index) => {
                                        const total = item?.barrelNumbers?.length || 0;
                                        const scanned = item?.scannedBarrels?.length || 0;
                                        const progress = total > 0 ? Math.round((scanned / total) * 100) : 0;

                                        return (
                                          <React.Fragment key={index}>
                                            <tr
                                              style={{
                                                borderColor: activeRowIndex === index ? "transparent" : "#E4E4DD",
                                              }}
                                            >
                                              <td className="text-start">{`${item?.productName} (${item?.lotNo})`}
                                              </td>
                                              <td className="text-start">{item?.producer}</td>
                                              <td className="text-start">{item?.totalProof || "-"}</td>
                                              <td className="text-start">{item?.totalVolume || "-"}</td>
                                              <td className="text-start">{item?.totalProofGallon || "-"}</td>

                                              {/* Quantity */}
                                              <td className="text-nowrap">
                                                {item?.barrelNumbers?.length && (
                                                  <button
                                                    onClick={() => handleRowClick(index, "quantity")}
                                                    className="barrel-count-btn ms-1"
                                                    style={{
                                                      borderColor:
                                                        activeRowIndex === index && activeType === "quantity"
                                                          ? "#3A809E"
                                                          : "#8F9195",
                                                      color:
                                                        activeRowIndex === index && activeType === "quantity"
                                                          ? "#3A809E"
                                                          : "#737376",
                                                    }}
                                                  >
                                                    {item?.barrelNumbers?.length || 0}
                                                    <span className="p-1">
                                                      <img src={ExpandMore} alt="CompanyIcn" width={15} height={8} />
                                                    </span>
                                                  </button>
                                                )}
                                              </td>

                                              {/* Ship Barrels section */}
                                              {customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC && (
                                                <>
                                                  {/* Scanned */}
                                                  <td className="text-nowrap">
                                                    <button
                                                      onClick={() => handleRowClick(index, "scanned")}
                                                      className="barrel-count-btn ms-1"
                                                      style={{
                                                        borderColor:
                                                          activeRowIndex === index && activeType === "scanned"
                                                            ? "#3A809E"
                                                            : "#8F9195",
                                                        color:
                                                          activeRowIndex === index && activeType === "scanned"
                                                            ? "#3A809E"
                                                            : "#737376",
                                                      }}
                                                    >
                                                      {item?.scannedBarrels?.length ?? 0}
                                                      <span className="p-1">
                                                        <img src={ExpandMore} alt="ExpandIcon" width={15} height={8} />
                                                      </span>
                                                    </button>
                                                  </td>

                                                  {/* Progress */}
                                                  <td className="text-nowrap">
                                                    <small className="ms-2">{progress}%</small>
                                                  </td>

                                                  {/* Mark as Scan (Select ALL) */}
                                                  {CommonService.isAdmin() && (!['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'CANCELLED', 'ACCEPTED', 'REJECTED', 'DELETED', 'DELIVERED'].includes(customerServiceRequest.status)) && (
                                                    <td className="text-nowrap">
                                                      <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isLotChecked(index)}
                                                        disabled={isLotScanned(index)}
                                                        //onChange={(e) => handleSelectLotScan(e, index)}
                                                        onChange={(e) => handleScanChange("lot", e, index)}
                                                        style={{
                                                          cursor: "pointer",
                                                          width: "18px",
                                                          height: "18px"
                                                        }}
                                                      />
                                                    </td>
                                                  )}
                                                </>
                                              )}
                                            </tr>

                                            {/* Expanded Barrel List */}
                                            {activeRowIndex === index && (
                                              <tr className="total-barrel-wrapper">
                                                <td
                                                  colSpan={
                                                    customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC
                                                      ? 8
                                                      : 2
                                                  }
                                                >
                                                  <Accordion activeKey={activeRowIndex !== null ? "0" : null}>
                                                    <Accordion.Item eventKey="0">
                                                      <Accordion.Body>
                                                        <div className="total-barrel-list-wrapper">
                                                          {(customerServiceRequest?.serviceName === Constant.CustomerService.BLENDING_REQUEST ||
                                                            customerServiceRequest?.serviceName === Constant.CustomerService.DUMPING_REQUEST ||
                                                            customerServiceRequest?.serviceName === Constant.CustomerService.RE_CONTAINERIZATION) ? (
                                                            <div className="barrel-list d-flex align-items-center flex-wrap gap-2">
                                                              {(item?.barrelNumbers)?.map(
                                                                (barrel, barrelIndex) => (
                                                                  <div key={barrelIndex} className="barrel-list-item d-flex align-items-center gap-2 blending-barrel-list-item">
                                                                    <div className="barrel-item-wrapper d-flex align-items-center gap-1 w-100 cursor-pointer">
                                                                      <DoneIcon />
                                                                      <span>
                                                                        {barrel?.barrelNumber}
                                                                      </span>
                                                                      <span className='source-name'>Source</span>
                                                                      <div className="barrel-type">
                                                                        {barrel?.containerType}
                                                                      </div>
                                                                    </div>
                                                                    <OverlayTrigger
                                                                      trigger="click"
                                                                      placement="bottom-start"
                                                                      rootClose
                                                                      show={openPopupForBarrelId === barrel.barrelId}
                                                                      overlay={
                                                                        <div className="blending-dropdwon-wrapper">

                                                                          {/* ---------- HEADER ---------- */}
                                                                          <div className="dropdown-header">
                                                                            <div className="header-item">
                                                                              <p className="header-item-key">Source Volume</p>
                                                                              <p className="header-item-value">{formatVolume(barrel.volume)} Gal</p>
                                                                            </div>

                                                                            <div className="header-item">
                                                                              <p className="header-item-key">Distributed Volume</p>
                                                                              <p className="header-item-value">
                                                                                {formatVolume(
                                                                                  barrel.finalSelectedDestinationInventoriesRequest
                                                                                    ?.flatMap(f => f?.destinationBarrelNumberResponse || [])
                                                                                    ?.reduce((sum, d) => sum + (parseFloat(d.distributedVolume) + parseFloat(d.volume) || 0), 0)
                                                                                )} Gal
                                                                              </p>
                                                                            </div>

                                                                            <div className="header-item">
                                                                              <p className="header-item-key">Available Volume</p>
                                                                              <p className="header-item-value">
                                                                                {formatVolume(
                                                                                  barrel.volume -
                                                                                  barrel.finalSelectedDestinationInventoriesRequest
                                                                                    ?.flatMap(f => f?.destinationBarrelNumberResponse || [])
                                                                                    ?.reduce((sum, d) => sum + (parseFloat(d.distributedVolume) + parseFloat(d.volume) || 0), 0)
                                                                                )} Gal
                                                                              </p>
                                                                            </div>
                                                                          </div>

                                                                          {/* ---------- ALL DESTINATION BARRELS IN ONE POPUP ---------- */}
                                                                          <div className="dropdown-body">
                                                                            {
                                                                              barrel.finalSelectedDestinationInventoriesRequest
                                                                                ?.flatMap(f => f?.destinationBarrelNumberResponse || [])
                                                                                ?.map((dest, index) => (
                                                                                  <div key={index} className="barrel-detail-wrapper selected">

                                                                                    <div className="barrel-item">
                                                                                      <div className="barrel-number">
                                                                                        <DoneIcon />
                                                                                        {dest.barrelNumber}
                                                                                      </div>
                                                                                      <div className="barrel-type">{dest.containerType}</div>
                                                                                    </div>

                                                                                    <div className="fill-detail-wrapper">
                                                                                      <div className="d-flex align-items-center gap-1">
                                                                                        <div
                                                                                          className={
                                                                                            dest.volume == 0
                                                                                              ? "fill-detail-item empty-item d-flex align-items-center gap-1"
                                                                                              : "fill-detail-item d-flex align-items-center gap-1"
                                                                                          }>
                                                                                          <img
                                                                                            src={dest.volume == 0 ? EmptyBarrel : FilledBarrel}
                                                                                            alt={dest.volume == 0 ? "empty-barrel" : "filled-barrel"} />

                                                                                          <span>
                                                                                            {dest.volume} /{formatVolume(barrel.volume)} Gal
                                                                                          </span>
                                                                                        </div>
                                                                                      </div>

                                                                                      <div className="vr"></div>
                                                                                      <div className="fill-detail-input-wrapper fill-value">
                                                                                        <input
                                                                                          type="text"
                                                                                          placeholder="Enter Volume"
                                                                                          value={dest.distributedVolume === 0 ? "" : dest.distributedVolume}
                                                                                        />
                                                                                      </div>
                                                                                      <div>
                                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                          <path d="M21 4.5V14.25C21 14.6478 20.842 15.0294 20.5607 15.3107C20.2794 15.592 19.8978 15.75 19.5 15.75H9.31031L10.2806 16.7194C10.3503 16.7891 10.4056 16.8718 10.4433 16.9628C10.481 17.0539 10.5004 17.1515 10.5004 17.25C10.5004 17.3485 10.481 17.4461 10.4433 17.5372C10.4056 17.6282 10.3503 17.7109 10.2806 17.7806C10.2109 17.8503 10.1282 17.9056 10.0372 17.9433C9.94613 17.981 9.84855 18.0004 9.75 18.0004C9.65145 18.0004 9.55387 17.981 9.46283 17.9433C9.37178 17.9056 9.28906 17.8503 9.21937 17.7806L6.96937 15.5306C6.89964 15.461 6.84432 15.3783 6.80658 15.2872C6.76884 15.1962 6.74941 15.0986 6.74941 15C6.74941 14.9014 6.76884 14.8038 6.80658 14.7128C6.84432 14.6217 6.89964 14.539 6.96937 14.4694L9.21937 12.2194C9.36011 12.0786 9.55098 11.9996 9.75 11.9996C9.94902 11.9996 10.1399 12.0786 10.2806 12.2194C10.4214 12.3601 10.5004 12.551 10.5004 12.75C10.5004 12.949 10.4214 13.1399 10.2806 13.2806L9.31031 14.25H19.5V4.5H9V5.25C9 5.44891 8.92098 5.63968 8.78033 5.78033C8.63968 5.92098 8.44891 6 8.25 6C8.05109 6 7.86032 5.92098 7.71967 5.78033C7.57902 5.63968 7.5 5.44891 7.5 5.25V4.5C7.5 4.10218 7.65804 3.72064 7.93934 3.43934C8.22064 3.15804 8.60218 3 9 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934C20.842 3.72064 21 4.10218 21 4.5ZM15.75 18C15.5511 18 15.3603 18.079 15.2197 18.2197C15.079 18.3603 15 18.5511 15 18.75V19.5H4.5V9.75H14.6897L13.7194 10.7194C13.5786 10.8601 13.4996 11.051 13.4996 11.25C13.4996 11.449 13.5786 11.6399 13.7194 11.7806C13.8601 11.9214 14.051 12.0004 14.25 12.0004C14.449 12.0004 14.6399 11.9214 14.7806 11.7806L17.0306 9.53063C17.1004 9.46097 17.1557 9.37825 17.1934 9.28721C17.2312 9.19616 17.2506 9.09856 17.2506 9C17.2506 8.90144 17.2312 8.80384 17.1934 8.71279C17.1557 8.62175 17.1004 8.53903 17.0306 8.46937L14.7806 6.21937C14.6399 6.07864 14.449 5.99958 14.25 5.99958C14.051 5.99958 13.8601 6.07864 13.7194 6.21937C13.5786 6.36011 13.4996 6.55098 13.4996 6.75C13.4996 6.94902 13.5786 7.13989 13.7194 7.28063L14.6897 8.25H4.5C4.10218 8.25 3.72064 8.40804 3.43934 8.68934C3.15804 8.97064 3 9.35218 3 9.75V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H15C15.3978 21 15.7794 20.842 16.0607 20.5607C16.342 20.2794 16.5 19.8978 16.5 19.5V18.75C16.5 18.5511 16.421 18.3603 16.2803 18.2197C16.1397 18.079 15.9489 18 15.75 18Z" fill="#3A809E" />
                                                                                        </svg>
                                                                                      </div>
                                                                                      <div className="fill-detail-item d-flex align-items-center gap-1">
                                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                          <g clip-path="url(#clip0_16084_104361)">
                                                                                            <path d="M5.5 0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526784 5.86739 0 6 0L10 0C10.1326 0 10.2598 0.0526784 10.3536 0.146447C10.4473 0.240215 10.5 0.367392 10.5 0.5C10.5 0.632608 10.4473 0.759785 10.3536 0.853553C10.2598 0.947322 10.1326 1 10 1H6C5.86739 1 5.74021 0.947322 5.64645 0.853553C5.55268 0.759785 5.5 0.632608 5.5 0.5ZM12.5 3.5V14C12.5 14.3978 12.342 14.7794 12.0607 15.0607C11.7794 15.342 11.3978 15.5 11 15.5H5C4.60218 15.5 4.22064 15.342 3.93934 15.0607C3.65804 14.7794 3.5 14.3978 3.5 14V3.5C3.5 3.10218 3.65804 2.72064 3.93934 2.43934C4.22064 2.15804 4.60218 2 5 2H11C11.3978 2 11.7794 2.15804 12.0607 2.43934C12.342 2.72064 12.5 3.10218 12.5 3.5ZM11.5 3.5C11.5 3.36739 11.4473 3.24021 11.3536 3.14645C11.2598 3.05268 11.1326 3 11 3H5C4.86739 3 4.74021 3.05268 4.64645 3.14645C4.55268 3.24021 4.5 3.36739 4.5 3.5V14C4.5 14.1326 4.55268 14.2598 4.64645 14.3536C4.74021 14.4473 4.86739 14.5 5 14.5H11C11.1326 14.5 11.2598 14.4473 11.3536 14.3536C11.4473 14.2598 11.5 14.1326 11.5 14V3.5ZM10 7H6C5.86739 7 5.74021 7.05268 5.64645 7.14645C5.55268 7.24021 5.5 7.36739 5.5 7.5C5.5 7.63261 5.55268 7.75979 5.64645 7.85355C5.74021 7.94732 5.86739 8 6 8H10C10.1326 8 10.2598 7.94732 10.3536 7.85355C10.4473 7.75979 10.5 7.63261 10.5 7.5C10.5 7.36739 10.4473 7.24021 10.3536 7.14645C10.2598 7.05268 10.1326 7 10 7ZM10 9.5H6C5.86739 9.5 5.74021 9.55268 5.64645 9.64645C5.55268 9.74021 5.5 9.86739 5.5 10C5.5 10.1326 5.55268 10.2598 5.64645 10.3536C5.74021 10.4473 5.86739 10.5 6 10.5H10C10.1326 10.5 10.2598 10.4473 10.3536 10.3536C10.4473 10.2598 10.5 10.1326 10.5 10C10.5 9.86739 10.4473 9.74021 10.3536 9.64645C10.2598 9.55268 10.1326 9.5 10 9.5ZM10 12H6C5.86739 12 5.74021 12.0527 5.64645 12.1464C5.55268 12.2402 5.5 12.3674 5.5 12.5C5.5 12.6326 5.55268 12.7598 5.64645 12.8536C5.74021 12.9473 5.86739 13 6 13H10C10.1326 13 10.2598 12.9473 10.3536 12.8536C10.4473 12.7598 10.5 12.6326 10.5 12.5C10.5 12.3674 10.4473 12.2402 10.3536 12.1464C10.2598 12.0527 10.1326 12 10 12Z" fill="#519E3A" />
                                                                                          </g>
                                                                                          <defs>
                                                                                            <clipPath id="clip0_16084_104361">
                                                                                              <rect width="16" height="16" fill="white" />
                                                                                            </clipPath>
                                                                                          </defs>
                                                                                        </svg>
                                                                                        <span>
                                                                                          {(parseFloat(dest.volume) || 0) + (parseFloat(dest.distributedVolume) || 0)}
                                                                                          /{formatVolume(barrel?.volume)} Gal
                                                                                        </span>
                                                                                      </div>
                                                                                    </div>
                                                                                  </div>
                                                                                ))
                                                                            }
                                                                          </div>

                                                                          {/* ---------- FOOTER ---------- */}
                                                                          <div className="dropdown-footer">
                                                                            <button className="done-btn" onClick={handleClose}>
                                                                              <DoneIcon className="me-1" /> Close
                                                                            </button>
                                                                          </div>

                                                                        </div>
                                                                      }
                                                                    >

                                                                      {/* ---------- LINK BUTTON ---------- */}
                                                                      <div
                                                                        className="link-btn-wrapper"
                                                                        onClick={() => setOpenPopupForBarrelId(barrel.barrelId)}
                                                                      >
                                                                        <LinkIcon sx={{ color: "#616161", transform: "rotate(-45deg)" }} />

                                                                        {
                                                                          (() => {
                                                                            const dest =
                                                                              barrel?.finalSelectedDestinationInventoriesRequest?.flatMap(
                                                                                f => f.destinationBarrelNumberResponse || []
                                                                              ) || [];

                                                                            const c = dest.length;
                                                                            const f = dest[0]?.barrelNumber;

                                                                            return c === 0
                                                                              ? <>Link Destination Container(s)</>
                                                                              : c === 1
                                                                                ? <>{f}</>
                                                                                : <>{f} +{c - 1}</>;
                                                                          })()
                                                                        }

                                                                        <span className="destination-text">Destination</span>
                                                                        <KeyboardArrowDownIcon sx={{ color: "#3A809E" }} />
                                                                      </div>

                                                                    </OverlayTrigger>
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          ) : (
                                                            <div className="barrel-list d-flex align-items-center flex-wrap gap-2">
                                                               {(
                                                                (activeType === "scanned" ? item?.scannedBarrels : item?.barrelNumbers)?.length > 0
                                                                ) ? (
                                                                (activeType === "scanned" ? item?.scannedBarrels : item?.barrelNumbers)?.map(
                                                                  (barrel, barrelIndex) => (
                                                                  <div key={barrelIndex} className="barrel-list-item tasting-barrel-list-item d-flex align-items-center gap-2">
                                                                     {activeType === "quantity" && <div className="barrel-number-wrapper">
                                                                        <DoneIcon sx={{ height: "18px", width: "18px" }} />
                                                                        <span>{barrel?.barrelNumber}</span>
                                                                        <span className="barrel-text">{barrel?.containerType}</span>
                                                                     </div>}
                                                                     {activeType === "scanned" && <div className="barrel-number-wrapper">
                                                                      <span>{barrel?.barrelNumber}</span>
                                                                      <span className="barrel-text">{barrel?.containerType}</span>
                                                                     </div>}

                                                                    {/* Individual checkbox */}
                                                                    {customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC && CommonService.isAdmin() && (!['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'CANCELLED', 'ACCEPTED', 'REJECTED', 'DELETED', 'DELIVERED'].includes(customerServiceRequest.status)) &&
                                                                      activeType === "quantity" && (
                                                                        <input
                                                                          className="form-check-input"
                                                                          type="checkbox"
                                                                          checked={isBarrelChecked(barrel.barrelId)}
                                                                          disabled={barrel?.isScanned}
                                                                          //onChange={(e) => handleScanChange(e, barrel.barrelId, index)}
                                                                          onChange={(e) => handleScanChange("barrel", e, index, barrel.barrelId)}
                                                                          style={{
                                                                            cursor: "pointer",
                                                                            borderRadius: "3px",
                                                                            border: "1px solid #999",
                                                                            width: "16px",
                                                                            height: "16px",
                                                                          }}
                                                                        />
                                                                      )}

                                                                    {customerServiceRequest?.serviceName === Constant.CustomerService.TASTING &&
                                                                      (CommonService.isAdmin() || (CommonService.isWarehouse() && !['ADMIN_ACCEPTED_FOR_WAREHOUSE'].includes(customerServiceRequest.status))) &&
                                                                      !['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'SCHEDULED', 'COMPLETED', 'CANCELLED', 'ACCEPTED', 'REJECTED', 'DELETED', 'CLOSED']
                                                                        .includes(customerServiceRequest.status) && (<div className="detail-btn">
                                                                          <button onClick={() => history.push(`/master/add-tasting-detail/${barrel?.barrelId}`, {
                                                                            customerServiceRequestId: id
                                                                          })}
                                                                          >
                                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                              <path d="M16.148 4.10247L13.898 1.85247C13.8457 1.80017 13.7837 1.75868 13.7154 1.73038C13.6471 1.70207 13.5739 1.6875 13.5 1.6875C13.4261 1.6875 13.3529 1.70207 13.2846 1.73038C13.2163 1.75868 13.1543 1.80017 13.102 1.85247L6.35203 8.60247C6.29981 8.65475 6.2584 8.7168 6.23017 8.78509C6.20194 8.85337 6.18744 8.92655 6.1875 9.00044V11.2504C6.1875 11.3996 6.24676 11.5427 6.35225 11.6482C6.45774 11.7537 6.60082 11.8129 6.75 11.8129H9C9.07389 11.813 9.14707 11.7985 9.21535 11.7703C9.28364 11.742 9.34569 11.7006 9.39797 11.6484L16.148 4.89841C16.2003 4.84617 16.2418 4.78413 16.2701 4.71585C16.2984 4.64756 16.3129 4.57436 16.3129 4.50044C16.3129 4.42652 16.2984 4.35333 16.2701 4.28504C16.2418 4.21675 16.2003 4.15471 16.148 4.10247ZM8.76727 10.6879H7.3125V9.23318L11.8125 4.73318L13.2673 6.18794L8.76727 10.6879ZM14.0625 5.39271L12.6077 3.93794L13.5 3.04568L14.9548 4.50044L14.0625 5.39271ZM15.75 9.00044V14.6254C15.75 14.9238 15.6315 15.21 15.4205 15.4209C15.2095 15.6319 14.9234 15.7504 14.625 15.7504H3.375C3.07663 15.7504 2.79048 15.6319 2.5795 15.4209C2.36853 15.21 2.25 14.9238 2.25 14.6254V3.37544C2.25 3.07707 2.36853 2.79093 2.5795 2.57995C2.79048 2.36897 3.07663 2.25044 3.375 2.25044H9C9.14918 2.25044 9.29226 2.30971 9.39775 2.41519C9.50324 2.52068 9.5625 2.66376 9.5625 2.81294C9.5625 2.96213 9.50324 3.1052 9.39775 3.21069C9.29226 3.31618 9.14918 3.37544 9 3.37544H3.375V14.6254H14.625V9.00044C14.625 8.85126 14.6843 8.70818 14.7898 8.60269C14.8952 8.49721 15.0383 8.43794 15.1875 8.43794C15.3367 8.43794 15.4798 8.49721 15.5852 8.60269C15.6907 8.70818 15.75 8.85126 15.75 9.00044Z"
                                                                                fill={barrel?.isTastingNoteAdded === true ? '#3A809E' : '#616161'} />
                                                                            </svg>
                                                                            {barrel?.isTastingNoteAdded === true ? "Edit" : "Fill"} Details
                                                                          </button>
                                                                        </div>)}
                                                                  </div>
                                                                ))
                                                               ) : (
                                                                  <div className="w-100 d-flex justify-content-center align-items-center text-muted">
                                                                    {activeType === "scanned"
                                                                      ? "No scanned containers"
                                                                      : "No containers available"}
                                                                  </div>
                                                                )}
                                                            </div>
                                                          )}
                                                        </div>
                                                      </Accordion.Body>
                                                    </Accordion.Item>
                                                  </Accordion>
                                                </td>
                                              </tr>
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                    </tbody>
                                  </Table>
                                </div>

                               {CommonService.isAdmin() && customerServiceRequest.serviceName === Constant.CustomerService.LOGISTIC && !isAllScanned()
                               && (!['PENDING_REVIEW', 'UNDER_REVIEW', 'ACCEPTED', 'REJECTED', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'DELIVERED', 'CANCELLED', 'DELETED', 'CLOSED'].includes(customerServiceRequest.status)) && (
                                <div className="text-center">
                                   <button className="scanned-btn" onClick={handleMarkAsScannedClick}>
                                      <DoneIcon className="me-1" />
                                      Mark As Scanned
                                    </button>
                                </div>
                               )}
                               
                              </div>
                          )}

                          {/* <div className="col-xl-6">
                            <div className="service-detail-right">
                              <div className="row">
                                {customerServiceRequest?.dynamicFields
                                  .map((field, index) => (
                                    field?.fieldName == 'Transfer Request' && (
                                      <p className="content-text cursor-pointer"><RequestDetails id={field?.value} onView={showRequestDetails} /></p>
                                    )
                                  ))}
                              </div>
                            </div>
                          </div> */}
                        {/* </div> */}
                      </div>
                      
                    </>
                    ) : (
                      <>                 
                        <div className="inventory-file-list-table ">
                      {isSelectedBarrelAreReserved &&  (<div className="alert barrel-alert alert-dismissible fade show" role="alert">
                          <span className="d-flex align-items-center gap-2">
                        <WarningIcon />{isSelectedBarrelAreReserved}</span>
                          <button type="button" className="btn-close" aria-label="Close" onClick={removeAlertMessage}> <CloseIcon /></button>
                      </div>)}
                          <div className="row m-0">
                          {/*{(customerServiceRequest.serviceName != Constant.CustomerService.LOGISTIC || (customerServiceRequest?.barrelSource != null && customerServiceRequest?.barrelSource != Constant.BarrelSource.SHIP_BY_SELECTING_REQUEST)) && (<div className="col-xl-6">
                              <div className="table-responsive service-detail-table-wrapper">

                                <Table className="service-detail-table">
                                  <thead>
                                    <tr>
                                      <th className="text-start">Inventory</th>
                                      <th className="text-nowrap ">Quantity</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {customerServiceRequest?.inventoryDetails?.map((item, index) => (
                                      <React.Fragment key={index}>
                                        <tr style={{
                                          borderColor:
                                            activeRowIndex === index
                                              ? "transparent"
                                              : "#E4E4DD",
                                        }}>
                                          <td className="text-start">{`${item?.productName} (${item?.lotNo})`}</td>
                                          <td className="text-nowrap">

                                          {item?.barrelNumbers?.length &&
                                              (<button
                                                onClick={() => handleRowClick(index)}
                                                className="barrel-count-btn ms-1"
                                                style={{
                                                  borderColor:
                                                    activeRowIndex === index
                                                      ? "#3A809E"
                                                      : "#8F9195",
                                                  color:
                                                    activeRowIndex === index
                                                      ? "#3A809E"
                                                      : "#737376"
                                                }}
                                              >
                                                {item?.barrelNumbers?.length || 0}
                                                <span className="p-1">
                                                  <img src={ExpandMore} alt="CompanyIcn" width={15} height={8} />
                                                </span>

                                              </button>)}
                                          </td>
                                        </tr>
                                        {activeRowIndex === index && (
                                          <tr className="total-barrel-wrapper">
                                            <td colSpan={3}>
                                              <Accordion activeKey={activeRowIndex !== null ? "0" : null}>
                                                <Accordion.Item eventKey="0">
                                                  <Accordion.Body>
                                                    <div className="total-barrel-list-wrapper">
                                                      <div className="barrel-list d-flex align-items-center flex-wrap gap-2">
                                                        {item?.barrelNumbers?.map((barrel, barrelIndex) => (
                                                          <div
                                                            key={barrelIndex}
                                                            className="barrel-list-item"
                                                          >
                                                            {barrel?.barrelNumber}
                                                          </div>
                                                        ))}
                                                      </div>
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            </div>)}*/}
                            {/* start code for wanted to buy */}
                              {(CommonService.isAdmin() && customerServiceRequest.serviceName === Constant.CustomerService.WANTED_TO_BUY) && (<div className="col-xl-6">
                                <div className="mb-3"
                                  style={{
                                    display: "inline-flex", alignItems: "center", border: "1px solid #D9D9D3",
                                    borderRadius: "50px", background: "#FFFFFF", padding: "4px", gap: "4px",
                                  }}>
                                  <button
                                    onClick={() => handleTabClickForWantedToBuy("marketplace")}
                                    style={{
                                      padding: "8px 22px", border: "none", outline: "none", borderRadius: "40px",
                                      background: activeTab === "marketplace" ? "#043A47" : "transparent",
                                      color: activeTab === "marketplace" ? "#fff" : "#5F5F5F",
                                      fontSize: "14px", fontWeight: 600, cursor: "pointer", transition: "all 0.2s ease-in-out",
                                    }}
                                  > Marketplace Interested</button>

                                  <button
                                    onClick={() => handleTabClickForWantedToBuy("system")}
                                    style={{
                                      padding: "8px 22px", border: "none", outline: "none", borderRadius: "40px",
                                      background: activeTab === "system" ? "#043A47" : "transparent",
                                      color: activeTab === "system" ? "#fff" : "#5F5F5F", fontSize: "14px",
                                      fontWeight: 600, cursor: "pointer", transition: "all 0.2s ease-in-out",
                                    }}
                                  >System Suggested</button>
                                </div>
                                <div className="table-responsive service-detail-table-wrapper">
                                  <Table className="service-detail-table mb-0">
                                    <thead>
                                      <tr>
                                        {activeTab === "marketplace" && (
                                          <>
                                            <th className="text-nowrap">Interested User</th>
                                            <th className="text-nowrap">Quantity</th>
                                            <th className="text-nowrap">Interested On</th>
                                            <th className="text-nowrap">Actions</th>
                                          </>
                                        )}

                                        {/* System Suggested */}
                                        {activeTab === "system" && (
                                          <>
                                            <th className="text-nowrap">Suggested User</th>
                                            <th className="text-nowrap">Quantity</th>
                                            <th className="text-nowrap">Actions</th>
                                          </>
                                        )}
                                      </tr>
                                    </thead>
                                      <tbody>
                                        {loading ? (
                                          <tr>
                                            <td colSpan={4} className="text-center py-4">
                                              <div className="spinner-border" role="status"></div>
                                              <p className="mt-2 mb-0">Loading...</p>
                                            </td>
                                          </tr>
                                        ) : wantedToBuyCustomerServiceRequest?.length > 0 ? (
                                          wantedToBuyCustomerServiceRequest?.map((item, index) => (
                                            <React.Fragment key={index}>
                                              <tr style={{
                                                borderColor:
                                                  activeRowIndex === index
                                                    ? "transparent"
                                                    : "#E4E4DD",
                                              }}>
                                                <td className="text-start">{`${item?.companyName}`}</td>
                                                <td className="text-nowrap">
                                                  <button
                                                    onClick={() => handleRowClick(index, "quantity")}
                                                    className="barrel-count-btn ms-1"
                                                    style={{
                                                      borderColor:
                                                        activeRowIndex === index && activeType === "quantity"
                                                          ? "#3A809E"
                                                          : "#8F9195",
                                                      color:
                                                        activeRowIndex === index && activeType === "quantity"
                                                          ? "#3A809E"
                                                          : "#737376",
                                                    }}
                                                  >
                                                    {(() => {
                                                      const total = item.lots?.reduce(
                                                        (sum, lot) => sum + lot.barrelNumbers.length,
                                                        0
                                                      ) || 0;

                                                      return total === 0 ? "0" : total;
                                                    })()}

                                                    <span className="p-1">
                                                      <img src={ExpandMore} alt="CompanyIcn" width={15} height={8} />
                                                    </span>
                                                  </button>
                                                </td>
                                                {activeTab === "marketplace" && (
                                                  <td>
                                                    {formatDateForAll(item?.createdDate)}
                                                  </td>
                                                )}
                                                <td>
                                                  {(() => {
                                                    const total = item.lots?.reduce(
                                                      (sum, lot) => sum + lot.barrelNumbers.length,
                                                      0
                                                    ) || 0;

                                                    if (total === 0) return null;
                                                    return (
                                                      <>
                                                      {['PUBLISHED'].includes(customerServiceRequest.status) && (
                                                        <div className="d-flex align-items-center gap-3">
                                                        <div className="redirection-wrapper" onClick={() => handleCreateCustomerServiceRequest('Private Sale', item?.companyId, item?.lots)} style={{ cursor: "pointer" }}>
                                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_15293_70259)">
                                                              <path d="M23.8763 12.7753L14.221 3.12005C14.0771 2.97497 13.9058 2.85995 13.717 2.78167C13.5283 2.70339 13.3258 2.66342 13.1215 2.66407H4.10983C3.90354 2.66407 3.70571 2.74602 3.55985 2.89188C3.41398 3.03774 3.33204 3.23557 3.33204 3.44186V12.4535C3.33139 12.6578 3.37136 12.8603 3.44964 13.0491C3.52792 13.2378 3.64294 13.4092 3.78802 13.5531L13.4433 23.2083C13.5877 23.3528 13.7592 23.4674 13.948 23.5456C14.1367 23.6238 14.339 23.6641 14.5433 23.6641C14.7477 23.6641 14.95 23.6238 15.1387 23.5456C15.3275 23.4674 15.499 23.3528 15.6434 23.2083L23.8763 14.9755C24.0208 14.831 24.1354 14.6595 24.2136 14.4707C24.2918 14.282 24.332 14.0797 24.332 13.8754C24.332 13.6711 24.2918 13.4688 24.2136 13.28C24.1354 13.0912 24.0208 12.9197 23.8763 12.7753ZM14.5429 22.1087L4.88761 12.4535V4.21964H13.1215L22.7767 13.8749L14.5429 22.1087ZM9.55433 7.71968C9.55433 7.95043 9.4859 8.17599 9.35771 8.36785C9.22951 8.55971 9.0473 8.70925 8.83412 8.79755C8.62093 8.88585 8.38635 8.90896 8.16004 8.86394C7.93373 8.81893 7.72585 8.70781 7.56268 8.54465C7.39952 8.38148 7.2884 8.1736 7.24339 7.94729C7.19837 7.72097 7.22147 7.48639 7.30978 7.27321C7.39808 7.06003 7.54762 6.87782 7.73948 6.74962C7.93134 6.62143 8.1569 6.553 8.38765 6.553C8.69707 6.553 8.99382 6.67592 9.21262 6.89471C9.43141 7.11351 9.55433 7.41026 9.55433 7.71968Z" fill="#0C3344" />
                                                              <path d="M14.49 9.24023C13.5838 9.24023 12.698 9.50895 11.9445 10.0124C11.191 10.5159 10.6038 11.2314 10.257 12.0687C9.91019 12.9059 9.81945 13.8271 9.99624 14.7159C10.173 15.6047 10.6094 16.4211 11.2502 17.0619C11.891 17.7027 12.7074 18.139 13.5962 18.3158C14.4849 18.4926 15.4062 18.4019 16.2434 18.0551C17.0806 17.7083 17.7962 17.121 18.2997 16.3676C18.8031 15.6141 19.0718 14.7282 19.0718 13.8221C19.0706 12.6073 18.5874 11.4426 17.7284 10.5836C16.8695 9.72465 15.7048 9.24152 14.49 9.24023ZM14.49 17.699C13.7232 17.699 12.9737 17.4716 12.3361 17.0456C11.6986 16.6196 11.2016 16.0141 10.9082 15.3057C10.6148 14.5973 10.538 13.8177 10.6876 13.0657C10.8372 12.3137 11.2064 11.6229 11.7486 11.0807C12.2908 10.5385 12.9816 10.1692 13.7337 10.0196C14.4857 9.87003 15.2652 9.94681 15.9737 10.2402C16.6821 10.5337 17.2876 11.0306 17.7136 11.6681C18.1396 12.3057 18.3669 13.0553 18.3669 13.8221C18.3658 14.8499 17.9569 15.8354 17.2301 16.5622C16.5033 17.289 15.5179 17.6978 14.49 17.699ZM16.2523 13.1172C16.2523 12.8214 16.1779 12.5304 16.036 12.2709C15.894 12.0114 15.689 11.7919 15.4399 11.6324C15.1908 11.473 14.9055 11.3789 14.6104 11.3587C14.3154 11.3384 14.02 11.3928 13.7514 11.5168C13.4829 11.6408 13.2499 11.8303 13.0738 12.068C12.8978 12.3057 12.7845 12.5839 12.7442 12.8769C12.7039 13.1699 12.7381 13.4683 12.8434 13.7447C12.9488 14.021 13.1221 14.2664 13.3472 14.4582L12.7577 15.7944C12.7341 15.8481 12.7241 15.9068 12.7289 15.9653C12.7336 16.0237 12.7529 16.0801 12.7849 16.1292C12.817 16.1783 12.8607 16.2187 12.9123 16.2466C12.9639 16.2746 13.0216 16.2892 13.0802 16.2892H15.8998C15.9585 16.2892 16.0162 16.2746 16.0677 16.2466C16.1193 16.2187 16.1631 16.1783 16.1951 16.1292C16.2271 16.0801 16.2464 16.0237 16.2511 15.9653C16.2559 15.9068 16.246 15.8481 16.2223 15.7944L15.6328 14.4582C15.8267 14.2926 15.9824 14.0869 16.0893 13.8555C16.1962 13.624 16.2518 13.3721 16.2523 13.1172ZM14.8724 14.4829L15.357 15.5865H13.6208L14.1054 14.4829C14.1413 14.4034 14.1465 14.3134 14.1199 14.2303C14.0933 14.1472 14.0368 14.0769 13.9614 14.0331C13.7598 13.9167 13.6022 13.7371 13.5132 13.522C13.4241 13.307 13.4085 13.0686 13.4687 12.8437C13.5289 12.6189 13.6617 12.4202 13.8464 12.2785C14.031 12.1369 14.2573 12.0601 14.49 12.0601C14.7228 12.0601 14.949 12.1369 15.1337 12.2785C15.3183 12.4202 15.4511 12.6189 15.5113 12.8437C15.5716 13.0686 15.556 13.307 15.4669 13.522C15.3778 13.7371 15.2203 13.9167 15.0187 14.0331C14.9429 14.0766 14.8859 14.1467 14.8589 14.2298C14.8319 14.3129 14.8367 14.4031 14.8724 14.4829Z" fill="#0C3344" />
                                                            </g>
                                                            <defs>
                                                              <clipPath id="clip0_15293_70259">
                                                                <rect width="24" height="24" fill="white" />
                                                              </clipPath>
                                                            </defs>
                                                          </svg>
                                                          <p className="mb-0">Private Sale</p>
                                                        </div>
                                                        <div className="redirection-wrapper" onClick={() => handleCreateCustomerServiceRequest('Sell Request', item?.companyId, item?.lots)} style={{ cursor: "pointer" }}>
                                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M22.8103 12.75L13.5 3.43969C13.3612 3.2998 13.196 3.18889 13.014 3.11341C12.832 3.03792 12.6368 2.99938 12.4397 3.00001H3.75001C3.5511 3.00001 3.36033 3.07903 3.21968 3.21968C3.07903 3.36033 3.00001 3.5511 3.00001 3.75001V12.4397C2.99938 12.6368 3.03792 12.832 3.11341 13.014C3.18889 13.196 3.2998 13.3612 3.43969 13.5L12.75 22.8103C12.8893 22.9496 13.0547 23.0602 13.2367 23.1356C13.4187 23.211 13.6138 23.2498 13.8108 23.2498C14.0078 23.2498 14.2029 23.211 14.3849 23.1356C14.5669 23.0602 14.7323 22.9496 14.8716 22.8103L22.8103 14.8716C22.9496 14.7323 23.0602 14.5669 23.1356 14.3849C23.211 14.2029 23.2498 14.0078 23.2498 13.8108C23.2498 13.6138 23.211 13.4187 23.1356 13.2367C23.0602 13.0547 22.9496 12.8893 22.8103 12.75ZM13.8103 21.75L4.50001 12.4397V4.50001H12.4397L21.75 13.8103L13.8103 21.75ZM9.00001 7.87501C9.00001 8.09751 8.93403 8.31502 8.81041 8.50002C8.68679 8.68503 8.51109 8.82922 8.30553 8.91437C8.09996 8.99952 7.87376 9.0218 7.65553 8.97839C7.4373 8.93498 7.23685 8.82784 7.07951 8.6705C6.92218 8.51317 6.81503 8.31271 6.77162 8.09448C6.72822 7.87626 6.75049 7.65006 6.83564 7.44449C6.92079 7.23892 7.06499 7.06322 7.24999 6.9396C7.435 6.81599 7.6525 6.75001 7.87501 6.75001C8.17338 6.75001 8.45952 6.86853 8.6705 7.07951C8.88148 7.29049 9.00001 7.57664 9.00001 7.87501Z" fill="#0C3344" />
                                                          </svg>
                                                          <p className="mb-0">Sell Request</p>
                                                        </div>
                                                      </div>
                                                      )}
                                                      </>
                                                    );
                                                  })()}
                                                </td>
                                              </tr>
                                              {activeRowIndex === index && (
                                                <tr className="total-barrel-wrapper">
                                                  <td colSpan={4}>
                                                    {item?.quantity > 0 ? (
                                                    <Accordion activeKey="0">
                                                      <Accordion.Item eventKey="0">
                                                          <Accordion.Body>
                                                            <div className="total-barrel-list-wrapper wanted-to-buy-list-wrapper">
                                                              {item?.lots?.map((lot, i) => (
                                                                <div key={i} className="mb-3 wanted-to-buy-lot-wrapper">

                                                                  {/* LOT TITLE */}
                                                                  <div className="lot-title" style={{ fontSize: "14px" }}>
                                                                    Lot # {lot?.lotNo}
                                                                    &nbsp;
                                                                    <span>
                                                                      ({lot?.barrelNumbers?.length} matching container found)
                                                                    </span>
                                                                  </div>

                                                                  {/* BARREL PILLS UNDER THIS LOT */}
                                                                  <div className="barrel-lot-wrapper">
                                                                    {lot?.barrelNumbers?.map((barrel, bIndex) => (
                                                                      <div
                                                                        key={bIndex}
                                                                        className="barrel-item-wrapper"
                                                                      >
                                                                        <span>{barrel?.barrelNumber}</span>

                                                                        <OverlayTrigger trigger="hover" placement="auto" overlay={
                                                                          <Popover id="popover-basic">
                                                                            <div className="info-card">
                                                                              <div className="section">
                                                                                <div className="label">Age</div>
                                                                                <div className="value">{getAge(barrel)}</div>
                                                                              </div>

                                                                              <div className="section">
                                                                                <div className="label">Mash Bill</div>
                                                                                <div className="value">{barrel?.mashBill || "-"}</div>
                                                                              </div>

                                                                              <div className="section">
                                                                                <div className="label">Proofing</div>
                                                                                <div className="value">{barrel?.proof || "-"}</div>
                                                                              </div>
                                                                            </div>
                                                                            </Popover>
                                                                          }>
                                                                          <svg
                                                                            width="20"
                                                                            height="20"
                                                                            viewBox="0 0 20 20"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                          >
                                                                            <path
                                                                              d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.6875 5.625C9.87292 5.625 10.0542 5.67998 10.2084 5.783C10.3625 5.88601 10.4827 6.03243 10.5536 6.20373C10.6246 6.37504 10.6432 6.56354 10.607 6.7454C10.5708 6.92725 10.4815 7.0943 10.3504 7.22541C10.2193 7.35652 10.0523 7.44581 9.8704 7.48199C9.68854 7.51816 9.50004 7.49959 9.32874 7.42864C9.15743 7.35768 9.01101 7.23752 8.908 7.08335C8.80499 6.92918 8.75 6.74792 8.75 6.5625C8.75 6.31386 8.84878 6.0754 9.02459 5.89959C9.20041 5.72377 9.43886 5.625 9.6875 5.625ZM10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z"
                                                                              fill="#616161"
                                                                            />
                                                                          </svg>
                                                                        </OverlayTrigger>
                                                                      </div>
                                                                    ))}
                                                                  </div>
                                                                </div>
                                                              ))}
                                                            </div>
                                                          </Accordion.Body>
                                                      </Accordion.Item>
                                                    </Accordion>
                                                    ) : (
                                                        <tr
                                                          className="no-record-row"
                                                          style={{ border: "none", boxShadow: "none", backgroundImage: "none" }}
                                                        >
                                                          <td
                                                            colSpan={4}
                                                            className="text-center py-3"
                                                            style={{ border: "none", boxShadow: "none", backgroundImage: "none", paddingLeft: "330px" }}
                                                          >
                                                            No matching records found
                                                          </td>
                                                        </tr>
                                                        )}
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={4} className="text-center py-3">
                                              No records found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                  </Table>
                                </div>
                              </div>)}
                            {/* end code for wanted to buy */}

                            {(customerServiceRequest.serviceName != Constant.CustomerService.WANTED_TO_BUY ||
                            (customerServiceRequest?.barrelSource != null && customerServiceRequest?.barrelSource === Constant.BarrelSource.SHIP_BY_SELECTING_REQUEST)) && (
                            <div className="col-xl-6" style={{height:"fit-content"}}>
                              <div className="table-responsive service-detail-table-wrapper">
                                <Table className="service-detail-table mb-0">
                                  <thead>
                                    <tr>
                                      <th className="text-start">Inventory</th>
                                      <th className="text-nowrap">Quantity</th>

                                          {customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC && (
                                            <>
                                              <th className="text-nowrap">Scanned</th>
                                              <th className="text-nowrap">Progress</th>
                                              {CommonService.isAdmin() && (!['PENDING_REVIEW', 'UNDER_REVIEW','SEND_TO_OWNER','ADMIN_ACCEPTED','ADMIN_REJECTED','CANCELLED','ACCEPTED','REJECTED', 'DELETED','DELIVERED'].includes(customerServiceRequest.status)) && (
                                                <th className="text-nowrap" style={{ paddingLeft: "0px" }}>
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={isAllChecked()}
                                                    onChange={(e) => handleScanChange("all", e)}
                                                    style={{ marginLeft: "10px", cursor: "pointer", width: "18px", height: "18px" }}
                                                  />
                                                </th>
                                              )}
                                            </>
                                          )}
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {!customerServiceRequest?.inventoryDetails?.length &&
                                          customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC && (
                                            <tr>
                                              <td
                                                colSpan={
                                                  CommonService.isAdmin() &&
                                                  !['PENDING_REVIEW', 'UNDER_REVIEW','SEND_TO_OWNER','ADMIN_ACCEPTED','ADMIN_REJECTED','CANCELLED','ACCEPTED','REJECTED', 'DELETED','DELIVERED'].includes(customerServiceRequest.status)
                                                    ? 5
                                                    : 4
                                                }
                                                className="text-center text-muted"
                                              >
                                                No containers available
                                              </td>
                                            </tr>
                                          )}
                                        {customerServiceRequest?.inventoryDetails?.map((item, index) => {
                                          const total = item?.barrelNumbers?.length || 0;
                                          const scanned = item?.scannedBarrels?.length || 0;
                                          const progress = total > 0 ? Math.round((scanned / total) * 100) : 0;

                                          return (
                                            <React.Fragment key={index}>
                                              <tr
                                                style={{
                                                  borderColor: activeRowIndex === index ? "transparent" : "#E4E4DD",
                                                }}
                                              >
                                                <td className="text-start">{`${item?.productName} (${item?.lotNo})`}
                                                </td>

                                                {/* Quantity */}
                                                <td className="text-nowrap">
                                                  {item?.barrelNumbers?.length && (
                                                    <button
                                                      onClick={() => handleRowClick(index, "quantity")}
                                                      className="barrel-count-btn ms-1"
                                                      style={{
                                                        borderColor:
                                                          activeRowIndex === index && activeType === "quantity"
                                                            ? "#3A809E"
                                                            : "#8F9195",
                                                        color:
                                                          activeRowIndex === index && activeType === "quantity"
                                                            ? "#3A809E"
                                                            : "#737376",
                                                      }}
                                                    >
                                                      {item?.barrelNumbers?.length || 0}
                                                      <span className="p-1">
                                                        <img src={ExpandMore} alt="CompanyIcn" width={15} height={8} />
                                                      </span>
                                                    </button>
                                                  )}
                                                </td>

                                                {/* Ship Barrels section */}
                                                {customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC && (
                                                  <>
                                                    {/* Scanned */}
                                                    <td className="text-nowrap">
                                                      <button
                                                        onClick={() => handleRowClick(index, "scanned")}
                                                        className="barrel-count-btn ms-1"
                                                        style={{
                                                          borderColor:
                                                            activeRowIndex === index && activeType === "scanned"
                                                              ? "#3A809E"
                                                              : "#8F9195",
                                                          color:
                                                            activeRowIndex === index && activeType === "scanned"
                                                              ? "#3A809E"
                                                              : "#737376",
                                                        }}
                                                      >
                                                        {item?.scannedBarrels?.length ?? 0}
                                                        <span className="p-1">
                                                          <img src={ExpandMore} alt="ExpandIcon" width={15} height={8} />
                                                        </span>
                                                      </button>
                                                    </td>

                                                    {/* Progress */}
                                                    <td className="text-nowrap">
                                                      <small className="ms-2">{progress}%</small>
                                                    </td>

                                                    {/* Mark as Scan (Select ALL) */}
                                                    {CommonService.isAdmin() && (!['PENDING_REVIEW', 'UNDER_REVIEW','SEND_TO_OWNER','ADMIN_ACCEPTED','ADMIN_REJECTED','CANCELLED','ACCEPTED','REJECTED', 'DELETED','DELIVERED'].includes(customerServiceRequest.status)) && (
                                                      <td className="text-nowrap">
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={isLotChecked(index)}
                                                          //onChange={(e) => handleSelectLotScan(e, index)}
                                                          onChange={(e) => handleScanChange("lot", e, index)}
                                                          style={{
                                                            cursor: "pointer",
                                                            width: "18px",
                                                            height: "18px"
                                                          }}
                                                        />
                                                      </td>
                                                    )}
                                                  </>
                                                )}
                                              </tr>

                                              {/* Expanded Barrel List */}
                                              {activeRowIndex === index && (
                                                <tr className="total-barrel-wrapper">
                                                  <td
                                                    colSpan={
                                                      customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC
                                                        ? 4
                                                        : 2
                                                    }
                                                  >
                                                    <Accordion activeKey={activeRowIndex !== null ? "0" : null}>
                                                      <Accordion.Item eventKey="0">
                                                        <Accordion.Body>
                                                          <div className="total-barrel-list-wrapper">
                                                            {(customerServiceRequest?.serviceName === Constant.CustomerService.BLENDING_REQUEST ||
                                                              customerServiceRequest?.serviceName === Constant.CustomerService.DUMPING_REQUEST ||
                                                              customerServiceRequest?.serviceName === Constant.CustomerService.RE_CONTAINERIZATION) ? (
                                                              <div className="barrel-list d-flex align-items-center flex-wrap gap-2">
                                                                {(item?.barrelNumbers)?.map(
                                                                  (barrel, barrelIndex) => (
                                                                    <div key={barrelIndex} className="barrel-list-item d-flex align-items-center gap-2 blending-barrel-list-item">
                                                                      <div className="barrel-item-wrapper d-flex align-items-center gap-1 w-100 cursor-pointer">
                                                                        <DoneIcon />
                                                                        <span>
                                                                          {barrel?.barrelNumber}
                                                                        </span>
                                                                        <span className='source-name'>Source</span>
                                                                        <div className="barrel-type">
                                                                          {barrel?.containerType}
                                                                        </div>
                                                                      </div>
                                                                      <OverlayTrigger
                                                                        trigger="click"
                                                                        placement="bottom-start"
                                                                        rootClose
                                                                        show={openPopupForBarrelId === barrel.barrelId}
                                                                        overlay={
                                                                          <div className="blending-dropdwon-wrapper">

                                                                            {/* ---------- HEADER ---------- */}
                                                                            <div className="dropdown-header">
                                                                              <div className="header-item">
                                                                                <p className="header-item-key">Source Volume</p>
                                                                                <p className="header-item-value">{formatVolume(barrel.volume)} Gal</p>
                                                                              </div>

                                                                              <div className="header-item">
                                                                                <p className="header-item-key">Distributed Volume</p>
                                                                                <p className="header-item-value">
                                                                                  {formatVolume(
                                                                                    barrel.finalSelectedDestinationInventoriesRequest
                                                                                      ?.flatMap(f => f?.destinationBarrelNumberResponse || [])
                                                                                      ?.reduce((sum, d) => sum + (parseFloat(d.distributedVolume) + parseFloat(d.volume) || 0), 0)
                                                                                  )} Gal
                                                                                </p>
                                                                              </div>

                                                                              <div className="header-item">
                                                                                <p className="header-item-key">Available Volume</p>
                                                                                <p className="header-item-value">
                                                                                  {formatVolume(
                                                                                    barrel.volume -
                                                                                    barrel.finalSelectedDestinationInventoriesRequest
                                                                                      ?.flatMap(f => f?.destinationBarrelNumberResponse || [])
                                                                                      ?.reduce((sum, d) => sum + (parseFloat(d.distributedVolume) + parseFloat(d.volume) || 0), 0)
                                                                                  )} Gal
                                                                                </p>
                                                                              </div>
                                                                            </div>

                                                                            {/* ---------- ALL DESTINATION BARRELS IN ONE POPUP ---------- */}
                                                                            <div className="dropdown-body">
                                                                              {
                                                                                barrel.finalSelectedDestinationInventoriesRequest
                                                                                  ?.flatMap(f => f?.destinationBarrelNumberResponse || [])
                                                                                  ?.map((dest, index) => (
                                                                                    <div key={index} className="barrel-detail-wrapper selected">

                                                                                      <div className="barrel-item">
                                                                                        <div className="barrel-number">
                                                                                          <DoneIcon />
                                                                                          {dest.barrelNumber}
                                                                                        </div>
                                                                                        <div className="barrel-type">{dest.containerType}</div>
                                                                                      </div>

                                                                                      <div className="fill-detail-wrapper">
                                                                                        <div className="d-flex align-items-center gap-1">
                                                                                          <div
                                                                                            className={
                                                                                              dest.volume == 0
                                                                                                ? "fill-detail-item empty-item d-flex align-items-center gap-1"
                                                                                                : "fill-detail-item d-flex align-items-center gap-1"
                                                                                            }>
                                                                                            <img
                                                                                              src={dest.volume == 0 ? EmptyBarrel : FilledBarrel}
                                                                                              alt={dest.volume == 0 ? "empty-barrel" : "filled-barrel"} />

                                                                                            <span>
                                                                                            {dest.volume} /{formatVolume(barrel.volume)} Gal
                                                                                            </span>
                                                                                          </div>
                                                                                        </div>

                                                                                        <div className="vr"></div>
                                                                                        <div className="fill-detail-input-wrapper fill-value">
                                                                                          <input
                                                                                            type="text"
                                                                                            placeholder="Enter Volume"
                                                                                            value={dest.distributedVolume === 0 ? "" : dest.distributedVolume}
                                                                                          />
                                                                                        </div>
                                                                                        <div>
                                                                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path d="M21 4.5V14.25C21 14.6478 20.842 15.0294 20.5607 15.3107C20.2794 15.592 19.8978 15.75 19.5 15.75H9.31031L10.2806 16.7194C10.3503 16.7891 10.4056 16.8718 10.4433 16.9628C10.481 17.0539 10.5004 17.1515 10.5004 17.25C10.5004 17.3485 10.481 17.4461 10.4433 17.5372C10.4056 17.6282 10.3503 17.7109 10.2806 17.7806C10.2109 17.8503 10.1282 17.9056 10.0372 17.9433C9.94613 17.981 9.84855 18.0004 9.75 18.0004C9.65145 18.0004 9.55387 17.981 9.46283 17.9433C9.37178 17.9056 9.28906 17.8503 9.21937 17.7806L6.96937 15.5306C6.89964 15.461 6.84432 15.3783 6.80658 15.2872C6.76884 15.1962 6.74941 15.0986 6.74941 15C6.74941 14.9014 6.76884 14.8038 6.80658 14.7128C6.84432 14.6217 6.89964 14.539 6.96937 14.4694L9.21937 12.2194C9.36011 12.0786 9.55098 11.9996 9.75 11.9996C9.94902 11.9996 10.1399 12.0786 10.2806 12.2194C10.4214 12.3601 10.5004 12.551 10.5004 12.75C10.5004 12.949 10.4214 13.1399 10.2806 13.2806L9.31031 14.25H19.5V4.5H9V5.25C9 5.44891 8.92098 5.63968 8.78033 5.78033C8.63968 5.92098 8.44891 6 8.25 6C8.05109 6 7.86032 5.92098 7.71967 5.78033C7.57902 5.63968 7.5 5.44891 7.5 5.25V4.5C7.5 4.10218 7.65804 3.72064 7.93934 3.43934C8.22064 3.15804 8.60218 3 9 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934C20.842 3.72064 21 4.10218 21 4.5ZM15.75 18C15.5511 18 15.3603 18.079 15.2197 18.2197C15.079 18.3603 15 18.5511 15 18.75V19.5H4.5V9.75H14.6897L13.7194 10.7194C13.5786 10.8601 13.4996 11.051 13.4996 11.25C13.4996 11.449 13.5786 11.6399 13.7194 11.7806C13.8601 11.9214 14.051 12.0004 14.25 12.0004C14.449 12.0004 14.6399 11.9214 14.7806 11.7806L17.0306 9.53063C17.1004 9.46097 17.1557 9.37825 17.1934 9.28721C17.2312 9.19616 17.2506 9.09856 17.2506 9C17.2506 8.90144 17.2312 8.80384 17.1934 8.71279C17.1557 8.62175 17.1004 8.53903 17.0306 8.46937L14.7806 6.21937C14.6399 6.07864 14.449 5.99958 14.25 5.99958C14.051 5.99958 13.8601 6.07864 13.7194 6.21937C13.5786 6.36011 13.4996 6.55098 13.4996 6.75C13.4996 6.94902 13.5786 7.13989 13.7194 7.28063L14.6897 8.25H4.5C4.10218 8.25 3.72064 8.40804 3.43934 8.68934C3.15804 8.97064 3 9.35218 3 9.75V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H15C15.3978 21 15.7794 20.842 16.0607 20.5607C16.342 20.2794 16.5 19.8978 16.5 19.5V18.75C16.5 18.5511 16.421 18.3603 16.2803 18.2197C16.1397 18.079 15.9489 18 15.75 18Z" fill="#3A809E" />
                                                                                          </svg>
                                                                                        </div>
                                                                                        <div className="fill-detail-item d-flex align-items-center gap-1">
                                                                                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <g clip-path="url(#clip0_16084_104361)">
                                                                                              <path d="M5.5 0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526784 5.86739 0 6 0L10 0C10.1326 0 10.2598 0.0526784 10.3536 0.146447C10.4473 0.240215 10.5 0.367392 10.5 0.5C10.5 0.632608 10.4473 0.759785 10.3536 0.853553C10.2598 0.947322 10.1326 1 10 1H6C5.86739 1 5.74021 0.947322 5.64645 0.853553C5.55268 0.759785 5.5 0.632608 5.5 0.5ZM12.5 3.5V14C12.5 14.3978 12.342 14.7794 12.0607 15.0607C11.7794 15.342 11.3978 15.5 11 15.5H5C4.60218 15.5 4.22064 15.342 3.93934 15.0607C3.65804 14.7794 3.5 14.3978 3.5 14V3.5C3.5 3.10218 3.65804 2.72064 3.93934 2.43934C4.22064 2.15804 4.60218 2 5 2H11C11.3978 2 11.7794 2.15804 12.0607 2.43934C12.342 2.72064 12.5 3.10218 12.5 3.5ZM11.5 3.5C11.5 3.36739 11.4473 3.24021 11.3536 3.14645C11.2598 3.05268 11.1326 3 11 3H5C4.86739 3 4.74021 3.05268 4.64645 3.14645C4.55268 3.24021 4.5 3.36739 4.5 3.5V14C4.5 14.1326 4.55268 14.2598 4.64645 14.3536C4.74021 14.4473 4.86739 14.5 5 14.5H11C11.1326 14.5 11.2598 14.4473 11.3536 14.3536C11.4473 14.2598 11.5 14.1326 11.5 14V3.5ZM10 7H6C5.86739 7 5.74021 7.05268 5.64645 7.14645C5.55268 7.24021 5.5 7.36739 5.5 7.5C5.5 7.63261 5.55268 7.75979 5.64645 7.85355C5.74021 7.94732 5.86739 8 6 8H10C10.1326 8 10.2598 7.94732 10.3536 7.85355C10.4473 7.75979 10.5 7.63261 10.5 7.5C10.5 7.36739 10.4473 7.24021 10.3536 7.14645C10.2598 7.05268 10.1326 7 10 7ZM10 9.5H6C5.86739 9.5 5.74021 9.55268 5.64645 9.64645C5.55268 9.74021 5.5 9.86739 5.5 10C5.5 10.1326 5.55268 10.2598 5.64645 10.3536C5.74021 10.4473 5.86739 10.5 6 10.5H10C10.1326 10.5 10.2598 10.4473 10.3536 10.3536C10.4473 10.2598 10.5 10.1326 10.5 10C10.5 9.86739 10.4473 9.74021 10.3536 9.64645C10.2598 9.55268 10.1326 9.5 10 9.5ZM10 12H6C5.86739 12 5.74021 12.0527 5.64645 12.1464C5.55268 12.2402 5.5 12.3674 5.5 12.5C5.5 12.6326 5.55268 12.7598 5.64645 12.8536C5.74021 12.9473 5.86739 13 6 13H10C10.1326 13 10.2598 12.9473 10.3536 12.8536C10.4473 12.7598 10.5 12.6326 10.5 12.5C10.5 12.3674 10.4473 12.2402 10.3536 12.1464C10.2598 12.0527 10.1326 12 10 12Z" fill="#519E3A" />
                                                                                            </g>
                                                                                            <defs>
                                                                                              <clipPath id="clip0_16084_104361">
                                                                                                <rect width="16" height="16" fill="white" />
                                                                                              </clipPath>
                                                                                            </defs>
                                                                                          </svg>
                                                                                          <span>
                                                                                            {(parseFloat(dest.volume) || 0) + (parseFloat(dest.distributedVolume) || 0)}
                                                                                            /{formatVolume(barrel?.volume)} Gal
                                                                                          </span>
                                                                                        </div>
                                                                                      </div>
                                                                                    </div>
                                                                                  ))
                                                                              }
                                                                            </div>

                                                                            {/* ---------- FOOTER ---------- */}
                                                                            <div className="dropdown-footer">
                                                                              <button className="done-btn" onClick={handleClose}>
                                                                                <DoneIcon className="me-1" /> Close
                                                                              </button>
                                                                            </div>

                                                                          </div>
                                                                        }
                                                                      >

                                                                        {/* ---------- LINK BUTTON ---------- */}
                                                                        <div
                                                                          className="link-btn-wrapper"
                                                                          onClick={() => setOpenPopupForBarrelId(barrel.barrelId)}
                                                                        >
                                                                          <LinkIcon sx={{ color: "#616161", transform: "rotate(-45deg)" }} />

                                                                          {
                                                                            (() => {
                                                                              const dest =
                                                                                barrel?.finalSelectedDestinationInventoriesRequest?.flatMap(
                                                                                  f => f.destinationBarrelNumberResponse || []
                                                                                ) || [];

                                                                              const c = dest.length;
                                                                              const f = dest[0]?.barrelNumber;

                                                                              return c === 0
                                                                                ? <>Link Destination Container(s)</>
                                                                                : c === 1
                                                                                  ? <>{f}</>
                                                                                  : <>{f} +{c - 1}</>;
                                                                            })()
                                                                          }

                                                                          <span className="destination-text">Destination</span>
                                                                          <KeyboardArrowDownIcon sx={{ color: "#3A809E" }} />
                                                                        </div>

                                                                      </OverlayTrigger>
                                                                    </div>
                                                                  )
                                                                )}
                                                              </div>
                                                            ) : (
                                                              <div className="barrel-list d-flex align-items-center flex-wrap gap-2">
                                                                {(activeType === "scanned" ? item?.scannedBarrels : item?.barrelNumbers)?.map(
                                                                  (barrel, barrelIndex) => (
                                                                    <div key={barrelIndex} className="barrel-list-item tasting-barrel-list-item d-flex align-items-center gap-2">
                                                                      {activeType === "quantity" && <div className="barrel-number-wrapper">
                                                                          <DoneIcon sx={{ height: "18px", width: "18px" }} />
                                                                          <span>{barrel?.barrelNumber}</span>
                                                                          <span className="barrel-text">{barrel?.containerType}</span>
                                                                      </div>}
                                                                      {activeType === "scanned" && <span>{barrel?.barrelNumber}</span>}

                                                                      {/* Individual checkbox */}
                                                                      {customerServiceRequest?.serviceName === Constant.CustomerService.LOGISTIC && CommonService.isAdmin() && (!['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'CANCELLED', 'ACCEPTED', 'REJECTED', 'DELETED', 'DELIVERED'].includes(customerServiceRequest.status)) &&
                                                                        activeType === "quantity" && (
                                                                          <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={isBarrelChecked(barrel.barrelId)}
                                                                            //onChange={(e) => handleScanChange(e, barrel.barrelId, index)}
                                                                            onChange={(e) => handleScanChange("barrel", e, index, barrel.barrelId)}
                                                                            style={{
                                                                              cursor: "pointer",
                                                                              borderRadius: "3px",
                                                                              border: "1px solid #999",
                                                                              width: "16px",
                                                                              height: "16px",
                                                                            }}
                                                                          />
                                                                        )}

                                                                        {customerServiceRequest?.serviceName === Constant.CustomerService.TASTING &&
                                                                        (CommonService.isAdmin() || (CommonService.isWarehouse() && !['ADMIN_ACCEPTED_FOR_WAREHOUSE'].includes(customerServiceRequest.status))) &&
                                                                        !['PENDING_REVIEW', 'UNDER_REVIEW', 'SEND_TO_OWNER', 'ADMIN_ACCEPTED', 'ADMIN_REJECTED', 'SCHEDULED', 'COMPLETED', 'CANCELLED', 'ACCEPTED', 'REJECTED', 'DELETED', 'CLOSED']
                                                                        .includes(customerServiceRequest.status) && (<div className="detail-btn">
                                                                          <button  onClick={() => history.push(`/master/add-tasting-detail/${barrel?.barrelId}`,{
                                                                                                    customerServiceRequestId: id })}
                                                                            >
                                                                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                                                                            <path d="M16.148 4.10247L13.898 1.85247C13.8457 1.80017 13.7837 1.75868 13.7154 1.73038C13.6471 1.70207 13.5739 1.6875 13.5 1.6875C13.4261 1.6875 13.3529 1.70207 13.2846 1.73038C13.2163 1.75868 13.1543 1.80017 13.102 1.85247L6.35203 8.60247C6.29981 8.65475 6.2584 8.7168 6.23017 8.78509C6.20194 8.85337 6.18744 8.92655 6.1875 9.00044V11.2504C6.1875 11.3996 6.24676 11.5427 6.35225 11.6482C6.45774 11.7537 6.60082 11.8129 6.75 11.8129H9C9.07389 11.813 9.14707 11.7985 9.21535 11.7703C9.28364 11.742 9.34569 11.7006 9.39797 11.6484L16.148 4.89841C16.2003 4.84617 16.2418 4.78413 16.2701 4.71585C16.2984 4.64756 16.3129 4.57436 16.3129 4.50044C16.3129 4.42652 16.2984 4.35333 16.2701 4.28504C16.2418 4.21675 16.2003 4.15471 16.148 4.10247ZM8.76727 10.6879H7.3125V9.23318L11.8125 4.73318L13.2673 6.18794L8.76727 10.6879ZM14.0625 5.39271L12.6077 3.93794L13.5 3.04568L14.9548 4.50044L14.0625 5.39271ZM15.75 9.00044V14.6254C15.75 14.9238 15.6315 15.21 15.4205 15.4209C15.2095 15.6319 14.9234 15.7504 14.625 15.7504H3.375C3.07663 15.7504 2.79048 15.6319 2.5795 15.4209C2.36853 15.21 2.25 14.9238 2.25 14.6254V3.37544C2.25 3.07707 2.36853 2.79093 2.5795 2.57995C2.79048 2.36897 3.07663 2.25044 3.375 2.25044H9C9.14918 2.25044 9.29226 2.30971 9.39775 2.41519C9.50324 2.52068 9.5625 2.66376 9.5625 2.81294C9.5625 2.96213 9.50324 3.1052 9.39775 3.21069C9.29226 3.31618 9.14918 3.37544 9 3.37544H3.375V14.6254H14.625V9.00044C14.625 8.85126 14.6843 8.70818 14.7898 8.60269C14.8952 8.49721 15.0383 8.43794 15.1875 8.43794C15.3367 8.43794 15.4798 8.49721 15.5852 8.60269C15.6907 8.70818 15.75 8.85126 15.75 9.00044Z" 
                                                                            fill={barrel?.isTastingNoteAdded === true ? '#3A809E' : '#616161'}  /> 
                                                                          </svg>
                                                                            {barrel?.isTastingNoteAdded === true ? "Edit" :"Fill"} Details
                                                                          </button>
                                                                        </div>)}
                                                                    </div>
                                                                  )
                                                                )}
                                                              </div>
                                                            )}
                                                          </div>
                                                        </Accordion.Body>
                                                      </Accordion.Item>
                                                    </Accordion>
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tbody>
                                    </Table>
                                  </div>

                                {CommonService.isAdmin() && customerServiceRequest.serviceName === Constant.CustomerService.LOGISTIC
                                && (!['PENDING_REVIEW', 'UNDER_REVIEW','SEND_TO_OWNER','ADMIN_ACCEPTED','ADMIN_REJECTED','CANCELLED','ACCEPTED','REJECTED', 'DELETED','DELIVERED'].includes(customerServiceRequest.status)) && (
                                  <div className="text-center">
                                    <button className="scanned-btn" onClick={handleMarkAsScannedClick}>
                                        <DoneIcon className="me-1" />
                                        Mark As Scanned
                                      </button>
                                  </div>
                                )}
                                
                                </div>
                              )}
                            <div
                              className={`${
                                customerServiceRequest.serviceName === Constant.CustomerService.LOGISTIC &&
                                customerServiceRequest?.barrelSource !== null &&
                                customerServiceRequest?.barrelSource === Constant.BarrelSource.SHIP_BY_SELECTING_REQUEST
                                  ? "col-xl-6"
                                  : (customerServiceRequest.serviceName === Constant.CustomerService.WANTED_TO_BUY && CommonService.isUser())
                                  ? "col-xl-12"
                                  : "col-xl-6"
                              }`}
                            >
                              <div className="service-detail-right">
                                <div className="row">
                                  {/* Age */}
                                  {customerServiceRequest?.dynamicFields?.some(
                                    (field) => field.dataType === "age_start" || field.dataType === "age_end"
                                  ) && (
                                    <div className="col-sm-6 col-md-4">
                                      <div className="content-wrapper">
                                        <p className="content-title">Age</p>
                                        <div className="title-bottom-line"></div>
                                        <p className="content-text">
                                          {`${customerServiceRequest.dynamicFields.find(f => f.dataType === "age_start")?.value} years - ${customerServiceRequest.dynamicFields.find(f => f.dataType === "age_end")?.value} years`}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                  {/* Proofing */}
                                  {customerServiceRequest?.dynamicFields?.some(
                                    (field) => field.dataType === "proofing_min" || field.dataType === "proofing_max"
                                  ) && (
                                    <div className="col-sm-6 col-md-4">
                                      <div className="content-wrapper">
                                        <p className="content-title">Proofing</p>
                                        <div className="title-bottom-line"></div>
                                        <p className="content-text">
                                          {`${parseFloat(customerServiceRequest.dynamicFields.find(f => f.dataType === "proofing_min")?.value || "0").toFixed(2)} - ${parseFloat(customerServiceRequest.dynamicFields.find(f => f.dataType === "proofing_max")?.value || "0").toFixed(2)}`}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                  {/* iterate customerServiceRequest.dynamicFields */}
                                {customerServiceRequest?.dynamicFields
                                ?.filter((field) => {
                                  // Exclude Requesting Organization field if service is Sample Request and role is USER
                                  if (
                                  (customerServiceRequest?.serviceName === Constant.CustomerService.SAMPLE_REQUEST || customerServiceRequest?.serviceName === Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) &&
                                    CommonService.isUser() &&
                                    field?.fieldName === Constant.Field.REQUESTING_ORGANIZATION
                                  ) {
                                    return false;
                                  }
                                  // Exclude age and proofing fields (already displayed above)
                                  if (["age_start", "age_end", "proofing_min", "proofing_max"].includes(field?.dataType)) {
                                    return false;
                                  }
                                  // Otherwise include the field
                                  return true;
                                })
                                .map((field, index) => (
                                  <div className={`${field?.dataType === Constant.FIELD_TYPES.RICH_TEXT ? "col-12" : "col-sm-6 col-md-4 col-xl-6 col-xxl-4 "} `} key={index}>
                                    <div className="content-wrapper">
                                      <p className="content-title">{field?.dataType == Constant.FIELD_TYPES.COMMISSION_FEE ? `${field?.fieldName}/Container` : field?.dataType == Constant.FIELD_TYPES.PRICE ? `${field?.fieldName}/Container` : field?.fieldName}

                                      {field?.dataType == Constant.FIELD_TYPES.COMMISSION_FEE  && CommonService.isAdmin() && (!['PENDING_REVIEW', 'UNDER_REVIEW','UNPUBLISHED','CANCELLED','REJECTED', 'DELETED'].includes(customerServiceRequest.status)) && (<Tooltip title="Edit commission fee" arrow>
                                          <IconButton
                                              aria-label="message"
                                              size="small"
                                              onClick={handleEditFeeDetails}
                                              sx={{ padding:0,color: "#1C1B1F"}}
                                          >
                                              <img className="cursor-pointer" 
                                                src={EditIcon}
                                                alt="EditIcon"
                                                height={15}
                                                style={{marginLeft:5}}
                                              />
                                          </IconButton>
                                          </Tooltip>)}

                                      </p>
                                      <div className="title-bottom-line"></div>

                                      {field?.dataType == Constant.FIELD_TYPES.COMMISSION_FEE ? (
                                          hasPercentageFeeTypeField() ? (
                                        <p className="content-text">{field?.value}%</p> // Display placeholder when PERCENTAGE is detected
                                      ) : (
                                        <p className="content-text">
                                          <CurrencyFormatter amount={field?.value} locale="en-US" currency="USD" />
                                        </p>
                                      )
                                    ) : field?.fieldName === "Tentative Price" ? (
                                      <p className="content-text">
                                      {field?.value}{" / "}
                                        {
                                          customerServiceRequest?.dynamicFields?.find(
                                            (x) => x.fieldName === "Container Type"
                                          )?.value || ""
                                        }
                                      </p>
                                    ) : field?.dataType === Constant.FIELD_TYPES.PRICE ? (<p className="content-text">
                                      <CurrencyFormatter amount={field?.value} locale="en-US" currency="USD" />
                                    </p>
                                    ): field?.dataType === Constant.FIELD_TYPES.RICH_TEXT ? (
                                      <p className="content-text">
                                        <CKContent
                                          content={
                                            customerServiceRequest.dynamicFields.find(field => field?.dataType === Constant.FIELD_TYPES.RICH_TEXT)?.value
                                          }
                                          className="custom-class"
                                        />
                                      </p>
                                    ) : field?.value === "true" ? (
                                      <p className="content-text">Yes</p>
                                    ) : field?.value === "false" ? (
                                      <p className="content-text">No</p>
                                    ) : field?.dataType == "date" ? (
                                      <p className="content-text">{CommonService.formatDateForSupportRequest(field.value)}</p>
                                    ) : field?.fieldName == 'Track Number' ? (
                                      <div className="flex items-center space-x-2 d-flex">
                                      <span className="content-text" style={{ color: "#3A809E" }}>
                                        {field?.value}
                                      </span>
                                      <Tooltip title="View Track Details" arrow>
                                        <IconButton
                                          size="small"
                                          onClick={() => handleTrackNumberClick(field?.value)}
                                        >
                                          <img
                                            className="cursor-pointer"
                                            src={RedirectIcon}
                                            alt="RedirectIcon"
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </div>
                                    ): field?.fieldName == 'Transfer Request' ? (
                                      <p  className="content-text cursor-pointer"><RequestDetails id={field?.value} onView={showRequestDetails} /></p>
                                    ):(
                                      <p className="content-text">
                                        {field?.dataType === Constant.FIELD_TYPES.FEE_TYPE_DROPDOWN ? CommonService.formatRoleName(field?.value) : field?.value}
                                      </p>
                                    )}
                                    </div>
                                  </div>
                                ))}

                                {/* </div>  */}

                                {/* Show the Description separately if it exists */}
                                {/* {customerServiceRequest?.dynamicFields?.some(field => field?.fieldName === Constant.Field.DESCRIPTION) && (
                                  <div className="col-12">
                                    <div className="content-wrapper mt-2">
                                      <p className="content-title">Description</p>
                                      <div className="title-bottom-line"></div><p className="content-text">
                                      <CKContent
                                        content={
                                          customerServiceRequest.dynamicFields.find(field => field?.fieldName === Constant.Field.DESCRIPTION)?.value
                                        }
                                        className="custom-class"
                                      />
                                      </p>
                                    </div>
                                  </div>
                                )} */}

                                {/* <div> */}
                                {( customerServiceRequest.serviceName !== Constant.CustomerService.WANTED_TO_BUY &&
                                  <div className="col-12">
                                    <div className="content-wrapper mt-2">
                                      <p className="content-title">
                                        Comment
                                      </p>
                                      <div className="title-bottom-line"></div>
                                      <p className="content-text">{customerServiceRequest?.comment}</p>
                                    </div>
                                  </div>
                                )}

                                {(customerServiceRequest?.sourceCompanyAcceptedByName && CommonService.isAdmin() &&
                                  <div className="col-12 col-md-6">
                                    <div className="content-wrapper mt-2">
                                      <p className="content-title">
                                        Accepted By Source Company
                                      </p>
                                      <div className="title-bottom-line"></div>
                                      <p className="content-text">{customerServiceRequest?.sourceCompanyAcceptedByName}</p>
                                    </div>
                                  </div>
                                )}

                                {(customerServiceRequest?.destinationCompanyAcceptedByName && CommonService.isAdmin() &&
                                  <div className="col-12 col-md-6">
                                    <div className="content-wrapper mt-2">
                                      <p className="content-title">
                                        Accepted By Destination Company
                                      </p>
                                      <div className="title-bottom-line"></div>
                                      <p className="content-text">{customerServiceRequest?.destinationCompanyAcceptedByName}</p>
                                    </div>
                                  </div>
                                )}

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  
                </div>
                <div className="row m-0 p-0">
                    <div className="col-xl-6 mb-3 mb-xl-0 ps-0 pe-xl-2 pe-0">
                      <div className="orderDetail-footer-content-wrapper">
                        <div className="title-bar d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
                          <h3 className="mb-0">List of Documents</h3>
                          <div className="ms-auto">
                            <UploadDocs
                              fetchData={fetchData}
                              csvId={id}
                              uploadCSV={false}
                              requestType={"CUSTOMER_SERVICE_REQUEST"}
                              requestNumber = {customerServiceRequest?.requestNumber}
                            />
                          </div>
                        </div>
                        <div
                          className="inventory-doc-table"
                          // style={{ height: 350, width: "100%" }}
                        >
                          {/* {isLoading ? (
                            <>
                              <Skeleton
                                animation="wave"
                                variant="rounded"
                                // height={550}
                                style={{ height: "100%" }}
                              />
                            </>
                          ) : ( */}
                            <>
                              <DataGrid
                                localeText={localeText}
                                rows={customerServiceRequestDocs}
                                columns={columnsForDoc}
                                className="data-grid upload-doc-datagrid-table"
                                // hideFooterPagination
                                hideFooter
                                loading={isLoading}
                                disableColumnResize
                              />
                            </>
                          {/* )} */}
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 mb-3 mb-xl-0 pe-0 ps-xl-2 ps-0">
                      <div className="recentActivity h-100">
                        <div className="title-bar d-flex justify-content-between align-items-center flex-wrap gap-3 py-0">
                        {(customerServiceRequest?.serviceName === Constant.CustomerService.SELL_REQUEST && isShowSellRequestPricingHistory) 
                          ? (<h3 className="mb-0">Pricing Insights</h3>) 
                          : <h3 className="mb-0">Recent Activity</h3>}

                        {customerServiceRequest?.serviceName === Constant.CustomerService.SELL_REQUEST && (
                          <div className="btn-group user-activity-btn-grp flex-wrap ms-auto" role="group" aria-label="Basic mixed styles example">
                            <button
                              className={`tab-btn d-inline-flex justify-content-between align-items-center ${
                                !isShowSellRequestPricingHistory ? "bg-theme" : "bg-theme-white"
                              }`}
                              onClick={() => {
                                setShowSellRequestPricingHistory(false);
                              }}
                            >
                              Recent Activity
                            </button>

                            <button
                              className={`tab-btn d-inline-flex justify-content-between align-items-center ${
                                isShowSellRequestPricingHistory ? "bg-theme" : "bg-theme-white"
                              }`}
                              onClick={() => {
                                setShowSellRequestPricingHistory(true); // ✅ fixed this line
                              }}
                            >
                              Pricing Insights
                            </button>
                          </div>
                        )}

                        </div>
                        <div className="history-stepper-wrapper support-history-wrapper">
                         {isShowSellRequestPricingHistory ?  <SellRequestPricingInsightChart customerServiceRequestId={id}/> : <HistoryStepper historyData={customerServiceRequestHistory} requestId={id} serviceName ={customerServiceRequest?.serviceName} />}
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
            
          </div>
          {(isOpenEditSection || isMessageBoxOpen) && (
              <div className={`msgContainerBox my-3 my-xl-0 ${customerServiceRequest.serviceName === Constant.CustomerService.BULK_INVENTORY_UPLOAD && "msgContainerBox-upload" }`}>
                {isOpenEditSection && (
                  <EditRequest
                    requestType={"SAMPLE_REQUEST"}
                    id={id}
                    refreshData={fetchData}
                    onEditClick={handleEditButtonClick}
                  />
                )}
                {isMessageBoxOpen && (
                  <ContainerMessageBox
                    requestType={"CUSTOMER_SERVICE_REQUEST"}
                    sellerCompanyId={null} 
                    isSeller={false}
                    wrapperHeight={wrapperHeight}
                  />
                )}
              </div>
            )}
        </div>
      </div>

      {isShowSellRequestEditValidationPopup && (
          <SellRequestEditValidationPopup
              redirectToDashboard={redirectToDashboard}
              onCancel={handlePopupCancel}
              type= {sellRequestEditValidationType}
          />
      )} 

       {isManageProofingDetailsClick && (
          <ManageBarrelProofingDetails
              customerServiceRequestId={id}
              reloadTable={() => {}}
              onClose={() => setManageProofingDetailClick(false)}
          />
      )} 

      {isManageValuationDetailsClick && (
          <ManageBarrelValuationDetails
              customerServiceRequestId={id}
              reloadTable={() => {}}
              onClose={() => setManageValuationDetailClick(false)}
          />
      )}

      {isManageDestinationDetailsClick && (
          <ManageDestinationBarrelDetails
              customerServiceRequestId={id}
              customerServiceType={customerServiceRequest.serviceName}
              reloadTable={() => {}}
              onClose={() => setManageDestinationDetailsClick(false)}
          />
      )}

      <Modal
        show={show}
        onHide={handleClose}
        size={isScannedCustomerServiceRequest || isSourceCompanyAccepted || isSourceCompanyRejected ? "lg" : undefined}
        centered ={isScannedCustomerServiceRequest}
        className={`modal__wd modal__wd--submitSellReq ${isScannedCustomerServiceRequest && "barrel-assignment-modal signup-success-modal"}`}
      >
        <Modal.Header className={`${isSourceCompanyAccepted || isSourceCompanyRejected || isScannedCustomerServiceRequest ? "align-items-center justify-content-between" : "flex-column align-items-start"}`} closeButton={isSourceCompanyAccepted || isSourceCompanyRejected}>
          {!isScannedCustomerServiceRequest && (
            <Modal.Title> {(isSourceCompanyAccepted || isSourceCompanyRejected) ? "Legal Statement" : "Update Customer Service Request Status"}</Modal.Title>
          )} 
          {(isSourceCompanyAccepted || isSourceCompanyRejected) &&
            <button onClick={handleClose} type="button" className="p-0 bg-transparent border-0 outline-0" data-bs-dismiss="modal" aria-label="Close">
              <CloseIcon sx={{ color: "#ffffff" }} />
            </button>
          }         
          {isScannedCustomerServiceRequest && (
            <>
            <Modal.Title>Mark as Scanned</Modal.Title>
            <button onClick={handleClose} type="button" className="p-0 bg-transparent border-0 outline-0" data-bs-dismiss="modal" aria-label="Close">
              <CloseIcon sx={{color:"#ffffff"}} />
              </button>
            </>
          )}
          {isCancelled && (
            <p className="modal-text">
              Are you sure you want to cancel? {(customerServiceRequest?.status != 'PENDING_REVIEW' && customerServiceRequest?.status != 'UNDER_REVIEW') ? "A cancellation charge may apply." : ""}
            </p>
          )}
          {isRejected && (
            <p className="modal-text">
              Are you sure you want to reject? {(customerServiceRequest?.status != 'PENDING_REVIEW' && customerServiceRequest?.status != 'UNDER_REVIEW') ? "" : ""}
            </p>
          )}
          {isOwnershipTransferedAccepted && (
            <p className="modal-text">
              Please select transfer company
            </p>
          )}
          {isSellRequestAccepted && (
            <p className="modal-text">
              Please enter commission fee and fee type {(customerServiceRequest?.status != 'PENDING_REVIEW' && customerServiceRequest?.status != 'UNDER_REVIEW') ? "" : ""}
            </p>
          )}
          {isInTransit && (
            <p className="modal-text">
              Please enter track number
            </p>
          )}
          {isInWarehouse && !isScannedCustomerServiceRequest && (
            <p className="modal-text">
              Please select warehouse
            </p>
          )}
          {isReopenConfirm && (
            <p className="modal-text">
              Are you sure you want to reopen this request?
            </p>
          )}
          {!isCancelled && !isRejected && !isSellRequestAccepted && !isInTransit && !isInWarehouse && !isOwnershipTransferedAccepted && !isScannedCustomerServiceRequest && !isSourceCompanyAccepted && !isSourceCompanyRejected && !isReopenConfirm && (
            <p className="modal-text">
              Close customer service request
            </p>
          )}
        </Modal.Header>
        <Modal.Body>
          
          {isScannedCustomerServiceRequest && (
            <div className="form__inner scanned-popup-wrapper">
              <div className="text-center d-flex justify-content-center">
                <span className="warning-icon-wrapper">
                  <img src={ScannedWarning} alt="Product Checkout icon" />
                </span>
              </div>
              <h2 className="modal-body__title">
                Are you sure you want to mark selected as scanned?
              </h2>

              <p className="modal-text">
                You are choosing to manually complete the scan step for the selected container.
                This action will complete the scan step without performing a physical scan.
              </p>
            </div>
          )}

          {isCancelled && (
            <div className="form__inner">
            <textarea
                className={`form-control ${error ? "is_invalid" : ""}`}
                aria-label="With textarea"
                rows={8}
                style={{ resize: "none" }}
                value={reason}
                onChange={handleReasonChange}
                placeholder="Enter cancellation reason.."
              />
             
              {error && <div className="error-message">{error}</div>}
            </div>
          )}
          
          {isRejected && (
            <div className="form__inner">
            <textarea
                className={`form-control ${error ? "is_invalid" : ""}`}
                aria-label="With textarea"
                rows={8}
                style={{ resize: "none" }}
                value={reason}
                onChange={handleReasonChange}
                placeholder="Enter rejection reason.."
              />
             
              {error && <div className="error-message">{error}</div>}
            </div>
          )}

          {isInWarehouse && (
            <div className="form__inner">
              <label className="modal-body__title mb-1">Select Warehouse</label>
              <Select
                className={`select-company-dropdown form-control w-100 multi-select-dropdown ${warehouseError ? "is_invalid" : ""
                  }`}
                options={warehouseUserList.map((user) => ({
                  value: user.userId,
                  label: user.userName,
                }))}
                onChange={handleWarehouseUserChange}
                components={{
                  DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                  IndicatorSeparator: () => null, // Remove the default separator
                }}
                isSearchable
                placeholder="Select Warehouse"
              />
              {warehouseError && <div className="error-message">{warehouseError}</div>}
            </div>
          )}
          
          {isOwnershipTransferedAccepted && (
              <div className="form__inner">
                <div className="d-flex align-items-start gap-3 justify-content-between">
                  <div>
                    <label className="modal-body__title">Receiving Company Name:</label>
                    <p className="receiving-company-name">{receivingCompany}</p>
                  </div>
                  {/* {!isReceivingCompanyExist && receivingCompany != '' &&
                    <button
                      type="button"
                      className="primary-btn text-nowrap"
                      onClick={addCompany}
                    >
                      Create & Accept
                    </button>} */}
                </div>
                {!isReceivingCompanyExist && receivingCompany != "" && (
                    <div style={{color: "red", fontSize: "13px", marginBottom: "12px"}}>
                      Company and associated user must be created in the system before accepting this ownership request.
                    </div>
                  )}
                <label className="modal-body__title mb-1" style={{ marginTop: "-34px" }}>Select Transfer Company</label>
                <Select
                  className={`select-company-dropdown form-control w-100 multi-select-dropdown ${transferCompanyError ? "is_invalid" : ""}`}
                  placeholder="Select Transfer Company"
                  options={filteredCompanyOptions}
                  value={
                    filteredCompanyOptions.find(
                      (option) => option.value === selectedTransferCompany
                    ) ||
                    filteredCompanyOptions.find(
                      (option) =>
                        option.label?.toLowerCase() === receivingCompany?.toLowerCase()
                    ) ||
                    null // <-- shows placeholder if not found
                  }
                  onChange={handleTransferCompanyChange}
                  components={{
                    DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                    IndicatorSeparator: () => null,
                  }}
                  isSearchable
                />
                {transferCompanyError && <div className="error-message">{transferCompanyError}</div>}
              </div>
          )}

          {isSellRequestAccepted && (
                <><div className="form__inner">
                <label style={{ color: "#333333", fontWeight: "700", marginBottom: "6px" }}>
                  Fee Type<span className="star-required text-danger">*</span>
                </label>
                <select
                  id="fee-type-dropdown"
                  value={sellRequestFeeType}
                  style={{ cursor: "pointer" }}
                  onChange={handleSellRequestFeeTypeChange}
                  className={`form-control no-spinner ${feeTypeError ? "is_invalid" : ""}`}
                >
                  <option value="">Select Fee Type</option>
                  <option value="FLAT">Flat</option>
                  <option value="PERCENTAGE">Percentage</option>
                </select>
                {feeTypeError && <div className="error-message">{feeTypeError}</div>}
              </div>

              <div className="form__inner mt-2">
              <label style={{ color: "#333333", fontWeight: "700", marginBottom: "6px" }}>
                Commission Fee ($) /Container<span className="star-required text-danger">*</span>
              </label>
              <Form.Control
                className={`form-control no-spinner ${feeError ? "is_invalid" : ""}`}
                type="number"
                value={sellRequestFee}
                onChange={handleSellRequestFeeChange}
                placeholder="Enter commission fee amount"
              />
              {feeError && <div className="error-message">{feeError}</div>}
              </div></>
            )}

          {isInTransit && (
              <>
                <div className="form__inner">
                  <label style={{ color: "#333333", fontWeight: "700", marginBottom: "6px" }}>
                    Track Number<span className="star-required text-danger">*</span>
                  </label>
                  <Form.Control
                    className={`form-control ${trackNumberError ? "is_invalid" : ""}`}
                    type="text"
                    value={trackNumberValue}
                    onChange={handleInputTrackerNumber}
                    placeholder="Enter Tracking Number..."
                  />
                  {trackNumberError && <div className="error-message">{trackNumberError}</div>}
                </div>
              </>
            )}

          {isSourceCompanyAccepted && (
              <div className="source-company-modal">
                <div className="dynamic-content-wrapper">
                  <h3>Please review and accept the following legal statement.</h3>
                  {customerServiceRequest?.companyId == CommonService.getCompanyId() ? (<p>
                     By confirming, you acknowledge that the selected lots and
                    their associated containers have been reviewed, validated, and
                    are eligible for transfer. You authorize the transfer of
                    ownership for the specified container from the <strong>{customerServiceRequest?.companyName}</strong> to the <strong>{getField(Constant.Field.NEW_COMPANY)?.value} </strong>on 
                    the effective transfer date {CommonService.formatDateForSupportRequest(getField(Constant.Field.DATE_OF_TRANSFER)?.value)}.
                  </p>) : (
                  <p>
                  By confirming, you acknowledge that the selected lots and their associated containers 
                  have been reviewed and validated for transfer. You accept the transfer of ownership
                  for the specified container from <strong>{customerServiceRequest?.companyName}</strong>  to <strong>{getField(Constant.Field.NEW_COMPANY)?.value} </strong> effective {CommonService.formatDateForSupportRequest(getField(Constant.Field.DATE_OF_TRANSFER)?.value)}.
                  </p>
                  )}
                  <p>
                    You understand and agree that:
                  </p>

                  {customerServiceRequest?.companyId == CommonService.getCompanyId() ? (<ul>
                    <li>
                      All information submitted in this request is accurate and complete to the best of your knowledge.
                    </li>
                    <li>
                      The container selected for transfer meet the required compliance, warehouse, and industry standards.
                    </li>
                    <li>
                      The transfer will result in a formal and binding update to the ownership records.
                    </li>
                    <li>
                      Once approved, the transfer cannot be reversed without initiating a new request and obtaining the necessary approvals.
                    </li>
                  </ul>) : (
                  <ul>
                    <li>
                      The information provided in this transfer request is accurate and complete to the best of your knowledge.
                    </li>
                    <li>
                      The container being transferred meet all required compliance, warehouse, and industry standards.
                    </li>
                    <li>
                      This transfer will result in a formal and binding update to the ownership records, recognizing <strong>{getField(Constant.Field.NEW_COMPANY)?.value} </strong> as the new owner.
                    </li>
                    <li>
                      Once approved, the transfer cannot be reversed without submitting a new request and obtaining the necessary approvals.
                    </li>
                  </ul>
                  )}
                </div>
                <div className="form__inner">
                    <label style={{ color: "#333333", fontWeight: "700", marginBottom: "6px" }}>
                      Enter Your Full Name<span className="star-required text-danger">*</span>
                    </label>
                    <Form.Control
                      className={`form-control ${ownershipNameError ? "is_invalid" : ""}`}
                      type="text"
                      value={ownershipName}
                      onChange={handleInputOwnershipName}
                      placeholder=" Enter Your Full Name"
                    />
                      {ownershipNameError && <div className="error-message">{ownershipNameError}</div>}
                    <p className="customer-info-text">
                      This transfer is at the direction of customer and any agreement to transfer property is between customer and new customer for which White Dog is not liable.
                    </p>
                      {/* ✅ Agree Checkbox */}
                    <div className="form-check mt-3">
                      <input
                        type="checkbox"
                        id="agreeConsent"
                        className="form-check-input"
                        checked={isAgreed}
                        onChange={(e) => {
                        setAgreeError('');
                        setIsAgreed(e.target.checked)
                        }}
                      />

                      <label htmlFor="agreeConsent" className="form-check-label">
                        By clicking <strong>Agree</strong>, you confirm your consent by providing full legal name,
                        which will be treated as your electronic signature.
                      </label>
                    </div>

                      {agreeError && <div className="error-message">{agreeError}</div>}
                </div>
              </div>
          )}

          {isSourceCompanyRejected && (
              <div className="source-rejected-wrapper">
                <h3>Are you sure you want to disagree?</h3>
                <p>
                  This will close the request from your end.
                </p>
                <p className="mb-3">
                  If you want to reopen the request mind later, you may need to contact an administrator or submit a new one.
                </p>

                <div className="form__inner">

                      {/* NO - Go Back */}
                    <div
                      className="form-check accept-form-check"
                    >
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <input
                            type="radio"
                            id="goBack"
                            name="decision"
                            className="form-check-input"
                            onChange={() => handleClose()}
                          />

                            <label htmlFor="goBack" className="form-check-label">
                              No, Go Back
                            </label>
                          </div>
                          <div className="info-msg">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.00195 0C9.31566 0 12.002 2.68629 12.002 6C12.002 9.31371 9.31566 12 6.00195 12C2.6883 11.9999 0.00195312 9.31367 0.00195312 6C0.00195333 2.68633 2.6883 6.10937e-05 6.00195 0ZM4.98145 5.15625L4.91992 5.44238L5.25879 5.50391C5.47834 5.55664 5.52196 5.63581 5.47363 5.85547L4.91992 8.45703C4.77518 9.12886 4.99944 9.44516 5.52637 9.44531C5.93496 9.44531 6.40959 9.25625 6.625 8.99707L6.69141 8.68555C6.542 8.81726 6.32172 8.87012 6.17676 8.87012C5.97053 8.86994 5.89557 8.7244 5.94824 8.46973L6.7002 4.94141L4.98145 5.15625ZM6.00195 2.625C5.58779 2.62506 5.25195 2.96082 5.25195 3.375C5.25195 3.78918 5.58779 4.12494 6.00195 4.125C6.41617 4.125 6.75195 3.78921 6.75195 3.375C6.75195 2.96079 6.41617 2.625 6.00195 2.625Z" fill="#0A3622"/>
                            </svg>

                            Choose if you want to review the legal terms again.
                          </div>
                    </div>


                      {/* YES - Close Request */}
                    <div
                      className="form-check reject-form-check"
                    >
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <input
                            type="radio"
                            id="closeRequest"
                            name="decision"
                            className="form-check-input"
                            onChange={() => changeCustomerServiceRequestStatus()}
                          />

                          <label htmlFor="closeRequest" className="form-check-label">
                            Yes, Close Request
                          </label>
                        </div>
                        <div className="info-msg">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.00195 0C9.31566 0 12.002 2.68629 12.002 6C12.002 9.31371 9.31566 12 6.00195 12C2.6883 11.9999 0.00195312 9.31367 0.00195312 6C0.00195333 2.68633 2.6883 6.10937e-05 6.00195 0ZM4.98145 5.15625L4.91992 5.44238L5.25879 5.50391C5.47834 5.55664 5.52196 5.63581 5.47363 5.85547L4.91992 8.45703C4.77518 9.12886 4.99944 9.44516 5.52637 9.44531C5.93496 9.44531 6.40959 9.25625 6.625 8.99707L6.69141 8.68555C6.542 8.81726 6.32172 8.87012 6.17676 8.87012C5.97053 8.86994 5.89557 8.7244 5.94824 8.46973L6.7002 4.94141L4.98145 5.15625ZM6.00195 2.625C5.58779 2.62506 5.25195 2.96082 5.25195 3.375C5.25195 3.78918 5.58779 4.12494 6.00195 4.125C6.41617 4.125 6.75195 3.78921 6.75195 3.375C6.75195 2.96079 6.41617 2.625 6.00195 2.625Z" fill="#0A3622"/>
                            </svg>

                            Choose if you want to close the request.
                          </div>
                    </div>

                </div>
              </div>
          )}

          {isReopenConfirm && (
            <div className="form__inner">
              <p className="mb-0">
                This action will move the request back to an active state.
              </p>
            </div>
          )}

          {!isCancelled && !isRejected && !isSellRequestAccepted && !isInTransit && !isInWarehouse && !isOwnershipTransferedAccepted && !isScannedCustomerServiceRequest && !isSourceCompanyAccepted && !isSourceCompanyRejected && !isReopenConfirm && customerServiceRequest?.serviceName !== Constant.CustomerService.PRIVATE_SELL && (
            <div className="form__inner">

              <label style={{color:" #333333",fontWeight: "700",marginBottom: "6px",}}>Time Spent (hours)<span className="star-required text-danger">*</span></label>
               <Form.Control
                className={`form-control no-spinner ${error ? "is_invalid" : ""}`}
                type="number"
                value={spendHour}
                onChange={handleSpendHourChange}
                placeholder="Enter hours"
              />
              {error && <div className="error-message">{error}</div>}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          {!isSourceCompanyRejected && (<div className={`btn-group d-flex w-100 ${!isScannedCustomerServiceRequest ? "justify-content-between row " : "justify-content-center gap-3"}`}>
            <div className={`${!isScannedCustomerServiceRequest && "col-6 ps-0"}`}>
              <button
                className={`secondary-btn ${!isScannedCustomerServiceRequest && "w-100"}`}
                onClick={handleClose}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>

            <div className={`${!isScannedCustomerServiceRequest && "col-6 pe-0"}`}>
             <button
                className={`primary-btn ${!isScannedCustomerServiceRequest && "w-100"}`}
                //onClick={isSellRequestFeeUpdated ? updateSellRequestFeeDetails : changeCustomerServiceRequestStatus}
                onClick={isScannedCustomerServiceRequest ? () => updateScan(selectedBarrelIds, true) : isInTransit ? updateSampleRequestDetails : isSellRequestFeeUpdated ? updateSellRequestFeeDetails : isOwnershipTransferedAccepted ? updateTransferCompanyDetails : changeCustomerServiceRequestStatus}
                disabled={isLoading}>
                {isLoading && <Spinner />} {isScannedCustomerServiceRequest ? "Yes" : (isInTransit || isInWarehouse) ? 'Yes' : isSellRequestFeeUpdated ? 'Update' : isCancelled ? "Cancel Request" : isRejected ? "Reject Request" : isReopenConfirm ? "Reopen Request" : ((isSellRequestAccepted || isOwnershipTransferedAccepted) ? "Accept" : (isSourceCompanyAccepted) ? "Agree" : "Close Request")}
              </button>        
            </div>
          </div>)} 
        </Modal.Footer>
      </Modal>
      </>
  );
};

export default ViewSupportRequest;
